/* eslint-disable */
// AUTO-GENERATED by scripts/generate-operations.ts from @up2rent/models. Do not edit by hand.

export const acknowledgeAnomalies = /* GraphQL */ `mutation AcknowledgeAnomalies($id: ID!, $acknowledged: Boolean!) {
  acknowledgeAnomalies(id: $id, acknowledged: $acknowledged) {
    amount
    anomalies
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryIban
    beneficiaryIbanReplaced
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    beneficiaryIbanState
    beneficiaryName
    buildingId
    buildingName
    bulkApprovable
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    collectedFee
    confirmationDeadlineDate
    confirmationOverdue
    counterpartContactId
    counterpartRemittanceInformation
    createdBy
    dueDate
    eligibleRerouteAccountIds
    executedAt
    executedBy
    executedDate
    executedTransactionId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    id
    invoiceId
    issuedAt
    issuedBy
    paymentBatchId
    periodFrom
    recurringPaymentTemplateId
    recurringPendingCount
    recurringPendingRank
    reference
    reissuable
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    selectable
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    __typename
  }
}
`;

export const addAuthUserTeam = /* GraphQL */ `mutation AddAuthUserTeam($input: AddAuthUserTeamInput!) {
  addAuthUserTeam(input: $input) {
    clientId
    dynamoUserId
    id
    teamId
    userId
    __typename
  }
}
`;

export const addOrdersToSepaBatch = /* GraphQL */ `mutation AddOrdersToSepaBatch($input: SepaBatchOrdersInput!) {
  addOrdersToSepaBatch(input: $input) {
    batches {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    failures {
      orderId
      reason
      __typename
    }
    __typename
  }
}
`;

export const addSenderAlias = /* GraphQL */ `mutation AddSenderAlias($input: SenderAliasInput!) {
  addSenderAlias(input: $input) {
    id
    confirmations
    confirmedBy
    key
    kind
    lastSeenAt
    lookupKey
    printedValue
    senderKeyType
    source
    targetId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const approveOrders = /* GraphQL */ `mutation ApproveOrders($ids: [ID!]!, $acknowledgeAnomalies: Boolean) {
  approveOrders(ids: $ids, acknowledgeAnomalies: $acknowledgeAnomalies) {
    failures {
      id
      reason
      __typename
    }
    items {
      amount
      anomalies
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      beneficiaryBankAccountId
      beneficiaryIban
      beneficiaryIbanReplaced
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      beneficiaryIbanState
      beneficiaryName
      buildingId
      buildingName
      bulkApprovable
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      collectedFee
      confirmationDeadlineDate
      confirmationOverdue
      counterpartContactId
      counterpartRemittanceInformation
      createdBy
      dueDate
      eligibleRerouteAccountIds
      executedAt
      executedBy
      executedDate
      executedTransactionId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      id
      invoiceId
      issuedAt
      issuedBy
      paymentBatchId
      periodFrom
      recurringPaymentTemplateId
      recurringPendingCount
      recurringPendingRank
      reference
      reissuable
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      selectable
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      __typename
    }
    __typename
  }
}
`;

export const archiveEntity = /* GraphQL */ `mutation ArchiveEntity($input: ArchiveEntityInput!) {
  archiveEntity(input: $input) {
    status
    id
    __typename
  }
}
`;

export const autoReconcilePaymentProviderPayout = /* GraphQL */ `mutation AutoReconcilePaymentProviderPayout($input: AutoReconcilePaymentProviderPayoutInput!) {
  autoReconcilePaymentProviderPayout(input: $input) {
    status
    id
    __typename
  }
}
`;

export const batchChangeCommunications = /* GraphQL */ `mutation BatchChangeCommunications($input: BatchChangeCommunicationsInput!) {
  batchChangeCommunications(input: $input) {
    status
    id
    __typename
  }
}
`;

export const cancelOrder = /* GraphQL */ `mutation CancelOrder($id: ID!, $reasonCode: String) {
  cancelOrder(id: $id, reasonCode: $reasonCode) {
    amount
    anomalies
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryIban
    beneficiaryIbanReplaced
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    beneficiaryIbanState
    beneficiaryName
    buildingId
    buildingName
    bulkApprovable
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    collectedFee
    confirmationDeadlineDate
    confirmationOverdue
    counterpartContactId
    counterpartRemittanceInformation
    createdBy
    dueDate
    eligibleRerouteAccountIds
    executedAt
    executedBy
    executedDate
    executedTransactionId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    id
    invoiceId
    issuedAt
    issuedBy
    paymentBatchId
    periodFrom
    recurringPaymentTemplateId
    recurringPendingCount
    recurringPendingRank
    reference
    reissuable
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    selectable
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    __typename
  }
}
`;

export const changeProfessionalActivityForLease = /* GraphQL */ `mutation ChangeProfessionalActivityForLease($input: ChangeProfessionalActivityForLeaseInput!) {
  changeProfessionalActivityForLease(input: $input) {
    status
    id
    __typename
  }
}
`;

export const changeSupplierPaymentMode = /* GraphQL */ `mutation ChangeSupplierPaymentMode($input: ChangeSupplierPaymentModeInput!) {
  changeSupplierPaymentMode(input: $input) {
    changed
    reopenedSectionIds
    __typename
  }
}
`;

export const changeTransactionLinks = /* GraphQL */ `mutation ChangeTransactionLinks($input: ChangeTransactionLinksInput!) {
  changeTransactionLinks(input: $input) {
    id
    status
    transactionIdsUpdated
    __typename
  }
}
`;

export const chargeInvoiceByMandate = /* GraphQL */ `mutation ChargeInvoiceByMandate($input: ChargeInvoiceByMandateInput!) {
  chargeInvoiceByMandate(input: $input) {
    status
    id
    __typename
  }
}
`;

export const confirmExecution = /* GraphQL */ `mutation ConfirmExecution($ids: [ID!]!) {
  confirmExecution(ids: $ids) {
    failures {
      id
      reason
      __typename
    }
    items {
      amount
      anomalies
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      beneficiaryBankAccountId
      beneficiaryIban
      beneficiaryIbanReplaced
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      beneficiaryIbanState
      beneficiaryName
      buildingId
      buildingName
      bulkApprovable
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      collectedFee
      confirmationDeadlineDate
      confirmationOverdue
      counterpartContactId
      counterpartRemittanceInformation
      createdBy
      dueDate
      eligibleRerouteAccountIds
      executedAt
      executedBy
      executedDate
      executedTransactionId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      id
      invoiceId
      issuedAt
      issuedBy
      paymentBatchId
      periodFrom
      recurringPaymentTemplateId
      recurringPendingCount
      recurringPendingRank
      reference
      reissuable
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      selectable
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      __typename
    }
    __typename
  }
}
`;

export const consumeReauthProof = /* GraphQL */ `mutation ConsumeReauthProof($input: ConsumeReauthProofInput!) {
  consumeReauthProof(input: $input) {
    status
    id
    __typename
  }
}
`;

export const convertHeicToJpeg = /* GraphQL */ `mutation ConvertHeicToJpeg($input: ConvertHeicToJpegInput!) {
  convertHeicToJpeg(input: $input) {
    fileUrl
    fileKey
    __typename
  }
}
`;

export const createAccountLabel = /* GraphQL */ `mutation CreateAccountLabel($input: CreateAccountLabelInput!, $condition: ModelAccountLabelConditionInput) {
  createAccountLabel(input: $input, condition: $condition) {
    id
    labels {
      language
      label
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    class
    customUsage
    customValues {
      name
      value
      __typename
    }
    disabled
    hoaFundId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    topClass
    vatNonDeductiblePercentage
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createAddress = /* GraphQL */ `mutation CreateAddress($input: CreateAddressInput!, $condition: ModelAddressConditionInput) {
  createAddress(input: $input, condition: $condition) {
    id
    status
    street
    number
    box
    postalCode
    city
    region
    country
    customValues {
      name
      value
      __typename
    }
    latitude
    longitude
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createAdminCommunication = /* GraphQL */ `mutation CreateAdminCommunication($input: CreateAdminCommunicationInput!, $condition: ModelAdminCommunicationConditionInput) {
  createAdminCommunication(input: $input, condition: $condition) {
    id
    body
    clientId
    externalId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    applicationInvoiceId
    recipient
    sentAt
    status
    subject
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createAdminFile = /* GraphQL */ `mutation CreateAdminFile($input: CreateAdminFileInput!, $condition: ModelAdminFileConditionInput) {
  createAdminFile(input: $input, condition: $condition) {
    id
    bucket
    foreignKey
    foreignTableName
    key
    mimeType
    region
    size
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createAdvertisement = /* GraphQL */ `mutation CreateAdvertisement($input: CreateAdvertisementInput!, $condition: ModelAdvertisementConditionInput) {
  createAdvertisement(input: $input, condition: $condition) {
    id
    type
    subType
    amenities
    amountOfFacades
    availabilityDate
    certificateOfConformity
    citationForPlanningOffence
    descriptions {
      language
      description
      __typename
    }
    delimitedZone
    floodProneArea
    furnished
    firstOccupancy
    gardenSurface
    heatingAmenities
    heatingType
    landTerrain
    landArea
    length
    nearbyComodities {
      type
      name
      distance
      __typename
    }
    publishedPlatforms {
      name
      publishedDate
      id
      __typename
    }
    planningPermission
    publishCadastralIncome
    resort
    rightOfPreemption
    subdivisionAuthorization
    wheelChairAccessible
    width
    terraceSurface
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createAgencyRate = /* GraphQL */ `mutation CreateAgencyRate($input: CreateAgencyRateInput!, $condition: ModelAgencyRateConditionInput) {
  createAgencyRate(input: $input, condition: $condition) {
    id
    amountDetails {
      amountType
      endAmount
      feeApplied
      startAmount
      __typename
    }
    rateWhenVacant {
      amount
      type
      __typename
    }
    amountMinimumFees
    custom
    feesAppliedTo
    includedInAmount
    name
    owners {
      items {
        id
        agencyRateId
        contactId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    repartitionType
    type
    unitType
    vatRateId
    unitIds
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createAgencyRateOwner = /* GraphQL */ `mutation CreateAgencyRateOwner($input: CreateAgencyRateOwnerInput!, $condition: ModelAgencyRateOwnerConditionInput) {
  createAgencyRateOwner(input: $input, condition: $condition) {
    id
    agencyRateId
    contactId
    agencyRate {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createAgencyRateStatement = /* GraphQL */ `mutation CreateAgencyRateStatement($input: CreateAgencyRateStatementInput!, $condition: ModelAgencyRateStatementConditionInput) {
  createAgencyRateStatement(input: $input, condition: $condition) {
    id
    agencyRate {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    agencyRateId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    unitAmounts {
      unitId
      amountRateable
      fixedAmount
      __typename
    }
    totalAmountRateable
    totalFixedAmount
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createAndValidateCompanyInvoice = /* GraphQL */ `mutation CreateAndValidateCompanyInvoice($input: CreateCompanyInvoiceInput!) {
  createAndValidateCompanyInvoice(input: $input) {
    status
    id
    __typename
  }
}
`;

export const createApplicationInvoice = /* GraphQL */ `mutation CreateApplicationInvoice($input: CreateApplicationInvoiceInput!, $condition: ModelApplicationInvoiceConditionInput) {
  createApplicationInvoice(input: $input, condition: $condition) {
    id
    amount
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    dueDate
    invoiceDate
    invoiceLines {
      items {
        id
        amountVatExcluded
        applicationInvoiceId
        calculationMethod
        clientId
        customLabel
        extraInformation
        quantity
        periodFrom
        periodTo
        subscriptionVariousOperationId
        subscriptionUsageHistoryId
        totalAmount
        type
        vatAmount
        vatRate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoiceNumber
    periodFrom
    periodTo
    clientSnapshot {
      name
      vat
      businessNumber
      email
      address {
        street
        number
        box
        postalCode
        city
        country
        __typename
      }
      __typename
    }
    peppolProperties {
      peppolStatus
      peppolId
      peppolErrorType
      peppolErrorMessage
      __typename
    }
    status
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createApplicationInvoiceLine = /* GraphQL */ `mutation CreateApplicationInvoiceLine($input: CreateApplicationInvoiceLineInput!, $condition: ModelApplicationInvoiceLineConditionInput) {
  createApplicationInvoiceLine(input: $input, condition: $condition) {
    id
    amountVatExcluded
    applicationInvoiceId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    calculationDetail {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    clientId
    customLabel
    extraInformation
    quantity
    periodFrom
    periodTo
    subscriptionVariousOperationId
    subscriptionVariousOperation {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    subscriptionUsageHistoryId
    subscriptionUsageHistory {
      id
      clientId
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    totalAmount
    type
    vatAmount
    vatRate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createApplicationPlan = /* GraphQL */ `mutation CreateApplicationPlan($input: CreateApplicationPlanInput!, $condition: ModelApplicationPlanConditionInput) {
  createApplicationPlan(input: $input, condition: $condition) {
    id
    calculationDetails {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    includedVariousOperations {
      items {
        id
        amount
        applicationPlanIncludedVariousOperationsId
        customerVisible
        duration
        numberOfCredits
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    isBillable
    isDefaultPlan
    labels {
      language
      label
      __typename
    }
    numberOfTrialMonths
    setupFees
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createApplicationSubscription = /* GraphQL */ `mutation CreateApplicationSubscription($input: CreateApplicationSubscriptionInput!, $condition: ModelApplicationSubscriptionConditionInput) {
  createApplicationSubscription(input: $input, condition: $condition) {
    id
    clientId
    creditsBalancePaid
    creditsBalanceIncluded
    creditsConfiguration {
      allowPostPaid
      creditsNotification
      postPaidThreshold
      __typename
    }
    endDate
    language
    lastInvoiceDate
    paymentCustomerId
    paymentLastExecution
    paymentLastStatus
    paymentLastError
    paymentMode
    paymentTerms
    invoicesProperties {
      hideQuantities
      __typename
    }
    plan {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    planId
    referenceNumber
    seller {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sellerId
    startDate
    status
    subscriptionVariousOperations {
      items {
        id
        applicationSubscriptionId
        clientId
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createApplicationSubscriptionVariousOperation = /* GraphQL */ `mutation CreateApplicationSubscriptionVariousOperation($input: CreateApplicationSubscriptionVariousOperationInput!, $condition: ModelApplicationSubscriptionVariousOperationConditionInput) {
  createApplicationSubscriptionVariousOperation(input: $input, condition: $condition) {
    id
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    createdBy {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    endDate
    label
    lastInvoiceDate
    sellerId
    startDate
    subscriptionVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createApplicationVariousOperation = /* GraphQL */ `mutation CreateApplicationVariousOperation($input: CreateApplicationVariousOperationInput!, $condition: ModelApplicationVariousOperationConditionInput) {
  createApplicationVariousOperation(input: $input, condition: $condition) {
    id
    amount
    applicationPlanIncludedVariousOperationsId
    customerVisible
    duration
    labels {
      language
      label
      __typename
    }
    numberOfCredits
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createAuthTeam = /* GraphQL */ `mutation CreateAuthTeam($input: CreateAuthTeamInput!) {
  createAuthTeam(input: $input) {
    clientId
    id
    name
    parentId
    __typename
  }
}
`;

export const createAuthUserRole = /* GraphQL */ `mutation CreateAuthUserRole($input: CreateAuthUserRoleInput!) {
  createAuthUserRole(input: $input) {
    clientId
    id
    isDefault
    name
    userRights {
      access
      section
      __typename
    }
    __typename
  }
}
`;

export const createBankAccount = /* GraphQL */ `mutation CreateBankAccount($input: CreateBankAccountInput!, $condition: ModelBankAccountConditionInput) {
  createBankAccount(input: $input, condition: $condition) {
    id
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactIds
    buildingIds
    number
    bicNumber
    bankName
    holderName
    label
    customValues {
      name
      value
      __typename
    }
    disabled
    integrations
    matchingRule
    initiationChannel
    retainedBalanceThreshold
    balance
    balanceDate
    type
    ibanStatus
    ibanVerifiedAt
    ibanVerifiedBy
    ibanVerifiedNumber
    ibanVerifiedSourceDocumentId
    ibanRole
    ibanRoleLabel
    isDefault
    note
    paymentRunPriorityOrderIds
    paymentRunPriorityUpdatedAt
    paymentRunPriorityUpdatedBy
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createBillingItem = /* GraphQL */ `mutation CreateBillingItem($input: CreateBillingItemInput!, $condition: ModelBillingItemConditionInput) {
  createBillingItem(input: $input, condition: $condition) {
    id
    name
    baseAmount
    billingType
    amountCalculationType
    percentageBase
    period
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    quantity
    percentage
    allocationOption
    multipleUnitsSplit
    leaseIds
    unitIds
    buildingIds
    accountLabelId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createBuilding = /* GraphQL */ `mutation CreateBuilding($input: CreateBuildingInput!, $condition: ModelBuildingConditionInput) {
  createBuilding(input: $input, condition: $condition) {
    id
    name
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    acquisitionValue
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    amountOfFacades
    amountOfFloors
    amountOfHousings
    buildingState
    cadastralIncome
    constructionYear
    customValues {
      name
      value
      __typename
    }
    janitor
    jointOwnershipId
    notes
    owners {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    propertyTax
    residenceName
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    units {
      items {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        buildingId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createBuildingEvent = /* GraphQL */ `mutation CreateBuildingEvent($input: CreateBuildingEventInput!, $condition: ModelBuildingEventConditionInput) {
  createBuildingEvent(input: $input, condition: $condition) {
    id
    buildingId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createBuildingOwner = /* GraphQL */ `mutation CreateBuildingOwner($input: CreateBuildingOwnerInput!, $condition: ModelBuildingOwnerConditionInput) {
  createBuildingOwner(input: $input, condition: $condition) {
    id
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    periodTo
    stake
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createBuildingSite = /* GraphQL */ `mutation CreateBuildingSite($input: CreateBuildingSiteInput!, $condition: ModelBuildingSiteConditionInput) {
  createBuildingSite(input: $input, condition: $condition) {
    id
    name
    buildings {
      items {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCashExpectation = /* GraphQL */ `mutation CreateCashExpectation($input: CreateCashExpectationInput!, $condition: ModelCashExpectationConditionInput) {
  createCashExpectation(input: $input, condition: $condition) {
    id
    sourceType
    sourceId
    direction
    flowType
    status
    accountIds
    originalAmount
    openAmount
    disputedAmount
    expectedAmount
    issueDate
    dueDate
    confirmationDeadline
    structuredCommunication
    invoiceNumber
    reference
    counterpartyIban
    leaseId
    unitId
    ownerId
    contractorId
    isOffLedgerReceivable
    awaitingPosting
    lines {
      postingId
      accountClass
      originalAmount
      openAmount
      disputed
      periodFrom
      periodTo
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCause = /* GraphQL */ `mutation CreateCause($input: CreateCauseInput!, $condition: ModelCauseConditionInput) {
  createCause(input: $input, condition: $condition) {
    id
    distinctValues {
      candidates {
        reason
        targetId
        __typename
      }
      display
      sectionIds
      value
      __typename
    }
    importRunId
    key
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCharge = /* GraphQL */ `mutation CreateCharge($input: CreateChargeInput!, $condition: ModelChargeConditionInput) {
  createCharge(input: $input, condition: $condition) {
    id
    status
    invoiceDate
    paymentDueDate
    archivedDate
    periodFrom
    periodTo
    totalAmount
    payableAmount
    source
    draftFromOcr
    accountingDocumentId
    paid
    settlement {
      bankCheck
      modeResolved
      modeSource
      parts {
        amount
        executeOn
        kind
        reference
        __typename
      }
      __typename
    }
    remittanceInformation
    note
    creatorEmail
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedContractors {
      id
      confidence
      __typename
    }
    recipientId
    recipient {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedRecipients {
      id
      confidence
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    documentId
    sectionId
    document {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readId
    clientId
    openChargeClientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createChargeEnvelope = /* GraphQL */ `mutation CreateChargeEnvelope($input: CreateChargeEnvelopeInput!, $condition: ModelChargeEnvelopeConditionInput) {
  createChargeEnvelope(input: $input, condition: $condition) {
    id
    channel
    decryptedS3Key
    duplicateOfEnvelopeId
    encryption
    fileHash
    fileId
    file {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    importRunId
    mimeType
    originalFileName
    pageQuality {
      alphaRatio
      averageFontSize
      dictionaryHits
      kind
      page
      __typename
    }
    pages
    readFailure
    receivedAt
    s3Key
    sections {
      items {
        id
        attachedToSectionId
        chargeId
        envelopeId
        excludedPages
        fallbackIdentityKey
        genre
        genreSubKind
        identityKey
        index
        issueDate
        issuerDateKey
        issuerNumberKey
        readFailure
        setAsideReason
        splitSource
        state
        valuesFromSectionId
        resolvedAliases
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    setAsideReason
    splitProposal {
      ambiguousBoundaries
      autoApplied
      cuts {
        afterPage
        reason
        rule
        score
        __typename
      }
      proposedAt
      source
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createChargeSection = /* GraphQL */ `mutation CreateChargeSection($input: CreateChargeSectionInput!, $condition: ModelChargeSectionConditionInput) {
  createChargeSection(input: $input, condition: $condition) {
    id
    attachedToSectionId
    chargeId
    checkpoints {
      allocate
      pay
      payReasons
      read
      resolve
      sort
      tenant
      __typename
    }
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    duplicateCandidates {
      reason
      sectionId
      __typename
    }
    envelopeId
    envelope {
      id
      channel
      decryptedS3Key
      duplicateOfEnvelopeId
      encryption
      fileHash
      fileId
      file {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      importRunId
      mimeType
      originalFileName
      pageQuality {
        alphaRatio
        averageFontSize
        dictionaryHits
        kind
        page
        __typename
      }
      pages
      readFailure
      receivedAt
      s3Key
      sections {
        nextToken
        startedAt
        __typename
      }
      setAsideReason
      splitProposal {
        ambiguousBoundaries
        autoApplied
        proposedAt
        source
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    excludedPages
    fallbackIdentityKey
    genre
    genreCandidates {
      genre
      reasons
      score
      __typename
    }
    genreSubKind
    identity {
      documentNumber
      grossTotal
      issuer
      source
      values {
        field
        value
        __typename
      }
      __typename
    }
    identityKey
    index
    issueDate
    issuerDateKey
    issuerNumberKey
    readFailure
    pageRange {
      from
      to
      __typename
    }
    renderings {
      attachedAt
      differences {
        field
        renderingValue
        survivorValue
        __typename
      }
      envelopeId
      reason
      sectionId
      source
      __typename
    }
    setAsideReason
    splitSource
    state
    valuesFromSectionId
    resolvedAliases
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createChargeStatement = /* GraphQL */ `mutation CreateChargeStatement($input: CreateChargeStatementInput!, $condition: ModelChargeStatementConditionInput) {
  createChargeStatement(input: $input, condition: $condition) {
    id
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createClientAccount = /* GraphQL */ `mutation CreateClientAccount($input: CreateClientAccountInput!) {
  createClientAccount(input: $input) {
    status
    id
    __typename
  }
}
`;

export const createCommunication = /* GraphQL */ `mutation CreateCommunication($input: CreateCommunicationInput!, $condition: ModelCommunicationConditionInput) {
  createCommunication(input: $input, condition: $condition) {
    id
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    blockedRecipients {
      recipient
      bounceType
      __typename
    }
    body
    buildingId
    channel
    communicationTemplateId
    concernedContactIds
    contactId
    contactIds
    deliveredAt
    draftProperties {
      entityType
      leaseIds
      unitIds
      buildingIds
      contactIds
      contactTypes
      sendInBcc
      cc
      bcc
      allowRecipientsToSeeEachOther
      unitTypeFilter
      __typename
    }
    errorCode
    expirationDate
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    leasePriceHistoryId
    leasePriceHistory {
      id
      previousTotalRentalPrice
      totalRentalPrice
      optimalTotalRentalPrice
      optimalTotalMonthlyCharges
      applicationDate
      status
      comment
      amountDetails {
        unitId
        indexationBaseIndex
        indexationNewIndex
        previousRentalPrice
        newRentalPrice
        rentalStatus
        monthlyChargesStatus
        optimalNewRentalPrice
        optimalNewMonthlyChargesPrice
        epb
        epbIssueDate
        oldestIndexForCorrectionFactorCalculation
        newestIndexForCorrectionFactorCalculation
        rentIndexedPriceAfterNewEpbReduction
        chargesIndexedPriceAfterNewEpbReduction
        correctionFactor
        reductionPercentage
        rentDifference
        rentReduction
        indexedRentAfterReduction
        chargesDifference
        chargesReduction
        indexedChargesAfterReduction
        previousYearIndexationNewIndex
        previousYearIndexedRent
        previousYearIndexedCharges
        __typename
      }
      type
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    letterTrackingCode
    letterTrackingProvider
    linkedCommunicationsIds
    nextRetryAt
    recipient
    recipientContactIdsInBcc
    recipientContactIdsInCc
    recipientInBcc
    recipientInCc
    scheduledAt
    sender
    sendRetryCount
    sentAt
    externalId
    externalStatus
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    snoozedDate
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    status
    subject
    supportingDocumentFileIds
    toSend
    hideLogo
    type
    _ttl
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCommunicationSettingsProfile = /* GraphQL */ `mutation CreateCommunicationSettingsProfile($input: CreateCommunicationSettingsProfileInput!, $condition: ModelCommunicationSettingsProfileConditionInput) {
  createCommunicationSettingsProfile(input: $input, condition: $condition) {
    id
    communicationsSettings {
      channels
      communicationType
      daysBeforeDueDate
      daysOverdue
      invoiceDaysAfterPeriodStart
      frequency {
        dateFrom
        periodInterval
        periodType
        __typename
      }
      sendingRule
      recipients
      recipientsInBcc
      recipientsInCopy
      displayOpenBalance
      __typename
    }
    defaultName
    isDefaultSetting
    referent
    tenantStatementView
    replacementId
    displayLogo
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCompanyInvoice = /* GraphQL */ `mutation CreateCompanyInvoice($input: CreateCompanyInvoiceInput!) {
  createCompanyInvoice(input: $input) {
    status
    id
    __typename
  }
}
`;

export const createCompanyUser = /* GraphQL */ `mutation CreateCompanyUser($input: CreateCompanyUserInput!, $condition: ModelCompanyUserConditionInput) {
  createCompanyUser(input: $input, condition: $condition) {
    id
    cognitoSub
    email
    firstName
    language
    lastName
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createContact = /* GraphQL */ `mutation CreateContact($input: CreateContactInput!, $condition: ModelContactConditionInput) {
  createContact(input: $input, condition: $condition) {
    id
    firstName
    lastName
    companyName
    commercialName
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    businessNumber
    types
    vat
    emails {
      address
      isPrimary
      label
      __typename
    }
    email
    birthDate
    birthPlace
    nationalRegister
    ipiNumber
    insuranceCompany
    insuranceContractNumber
    judicialDistrict
    civility
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    phoneNumbers {
      countryCode
      isPrimary
      label
      number
      __typename
    }
    language
    notes
    profileType
    jointOwners {
      contactId
      contactPerson
      __typename
    }
    hoaFunds {
      archivedAt
      id
      kind
      name
      __typename
    }
    paymentTermDays
    acpSyndicEras {
      syndicContactId
      validFrom
      validTo
      __typename
    }
    acpSyndicHistory {
      changedAt
      changedBy
      previousSyndicContactId
      previousValidFrom
      syndicContactId
      validFrom
      __typename
    }
    defaultBankAccountId
    supplierPaymentMode
    supplierPaymentModeExceptions {
      confirmedAt
      confirmedBy
      mode
      ownerId
      __typename
    }
    supplierPaymentModeHistory {
      changedAt
      changedBy
      mode
      ownerId
      previousMode
      __typename
    }
    agencyRateDisabled
    attachStatementSupportingDocuments
    status
    leases {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildings {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sendInvitation
    peppolProperties {
      isRegistered
      mustSend
      __typename
    }
    integrations {
      paymentProperties {
        accountId
        __typename
      }
      __typename
    }
    readers
    readId
    clientId
    sourceEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    foreignEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCounterpartyIdentity = /* GraphQL */ `mutation CreateCounterpartyIdentity($input: CreateCounterpartyIdentityInput!, $condition: ModelCounterpartyIdentityConditionInput) {
  createCounterpartyIdentity(input: $input, condition: $condition) {
    id
    keyType
    key
    isFullRemittance
    kind
    contactId
    source
    status
    evidenceCount
    firstSeenAt
    lastSeenAt
    lastCounterpartName
    lastDecisionId
    evidenceTransactionIds
    exclusionReason
    exclusionComment
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCounterpartyRole = /* GraphQL */ `mutation CreateCounterpartyRole($input: CreateCounterpartyRoleInput!, $condition: ModelCounterpartyRoleConditionInput) {
  createCounterpartyRole(input: $input, condition: $condition) {
    id
    subjectId
    targetType
    targetId
    source
    status
    evidenceCount
    lastSeenAt
    lastDecisionId
    evidenceTransactionIds
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCreditCost = /* GraphQL */ `mutation CreateCreditCost($input: CreateCreditCostInput!, $condition: ModelCreditCostConditionInput) {
  createCreditCost(input: $input, condition: $condition) {
    id
    clientId
    endDate
    numberOfCredits
    price
    startDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCreditUsageCost = /* GraphQL */ `mutation CreateCreditUsageCost($input: CreateCreditUsageCostInput!, $condition: ModelCreditUsageCostConditionInput) {
  createCreditUsageCost(input: $input, condition: $condition) {
    id
    endDate
    numberOfCreditsPerOperation
    startDate
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCustomField = /* GraphQL */ `mutation CreateCustomField($input: CreateCustomFieldInput!, $condition: ModelCustomFieldConditionInput) {
  createCustomField(input: $input, condition: $condition) {
    id
    fieldName
    fieldType
    foreignKey
    foreignTableName
    labels {
      language
      label
      __typename
    }
    customFieldProperties {
      isRequired
      isDefault
      defaultValue
      options {
        id
        __typename
      }
      __typename
    }
    order
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createCustomSubscription = /* GraphQL */ `mutation CreateCustomSubscription($input: CreateCustomSubscriptionInput!, $condition: ModelCustomSubscriptionConditionInput) {
  createCustomSubscription(input: $input, condition: $condition) {
    id
    name
    value
    userId
    _ttl
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createDocumentCategory = /* GraphQL */ `mutation CreateDocumentCategory($input: CreateDocumentCategoryInput!, $condition: ModelDocumentCategoryConditionInput) {
  createDocumentCategory(input: $input, condition: $condition) {
    id
    entity
    fileCategory
    labels {
      language
      label
      __typename
    }
    parentId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createDocumentExtraction = /* GraphQL */ `mutation CreateDocumentExtraction($input: CreateDocumentExtractionInput!, $condition: ModelDocumentExtractionConditionInput) {
  createDocumentExtraction(input: $input, condition: $condition) {
    id
    corrected
    createdBy
    evidence {
      bbox
      field
      method
      page
      quote
      rawConfidence
      __typename
    }
    flags
    raw
    reasons
    score
    sectionId
    version
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createDocumentNumber = /* GraphQL */ `mutation CreateDocumentNumber($input: CreateDocumentNumberInput!, $condition: ModelDocumentNumberConditionInput) {
  createDocumentNumber(input: $input, condition: $condition) {
    id
    format
    lastUpdate
    incrementNumber
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createEntityAlias = /* GraphQL */ `mutation CreateEntityAlias($input: CreateEntityAliasInput!, $condition: ModelEntityAliasConditionInput) {
  createEntityAlias(input: $input, condition: $condition) {
    id
    confirmations
    confirmedBy
    key
    kind
    lastSeenAt
    lookupKey
    printedValue
    senderKeyType
    source
    targetId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createEntityRelation = /* GraphQL */ `mutation CreateEntityRelation($input: CreateEntityRelationInput!, $condition: ModelEntityRelationConditionInput) {
  createEntityRelation(input: $input, condition: $condition) {
    id
    sourceId
    sourceTableName
    foreignId
    foreignTableName
    linkDescription
    linkProperties {
      contact {
        communicationSubscriptions
        __typename
      }
      __typename
    }
    clientId
    readers
    readId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createFeeArrears = /* GraphQL */ `mutation CreateFeeArrears($input: CreateFeeArrearsInput!, $condition: ModelFeeArrearsConditionInput) {
  createFeeArrears(input: $input, condition: $condition) {
    id
    accumulatedFrom {
      accumulatedAt
      amount
      paymentOrderId
      __typename
    }
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    openedAt
    originalAmount
    originPaymentOrderId
    originPaymentOrder {
      id
      amount
      anomalies
      anomalyAcknowledgedAt
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      confirmationDeadlineDate
      counterpartAccountNumber
      counterpartContactId
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      counterpartContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartRemittanceInformation
      createdBy
      dueDate
      executedDate
      executedAt
      executedBy
      executedTransactionId
      feeArrearsId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      fundAmounts {
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issuedAt
      issuedBy
      ownerContactId
      paymentBatchId
      paymentBatch {
        id
        bankAccountId
        clientStatusKey
        currentVersion
        number
        outdated
        sentAt
        sentBy
        status
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      reconciledAt
      recurringPaymentTemplateId
      reference
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      requestedAmount
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerContactId
    ownerContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    servedBy {
      amount
      paymentOrderId
      servedAt
      __typename
    }
    settledAt
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createFile = /* GraphQL */ `mutation CreateFile($input: CreateFileInput!, $condition: ModelFileConditionInput) {
  createFile(input: $input, condition: $condition) {
    id
    bucket
    category {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    categoryId
    foreignKey
    foreignTableName
    key
    mimeType
    region
    signaturePositions {
      top
      left
      page
      width
      height
      contactId
      __typename
    }
    size
    readers
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createFilterGroup = /* GraphQL */ `mutation CreateFilterGroup($input: CreateFilterGroupInput!, $condition: ModelFilterGroupConditionInput) {
  createFilterGroup(input: $input, condition: $condition) {
    id
    filterGroupDetails {
      filterEntityType
      filterEntityField
      filterEntityValues
      filterEntityNumber
      filterEntityDate
      __typename
    }
    name
    screenName
    type
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createImportRun = /* GraphQL */ `mutation CreateImportRun($input: CreateImportRunInput!, $condition: ModelImportRunConditionInput) {
  createImportRun(input: $input, condition: $condition) {
    id
    channel
    files
    finishedAt
    handled
    needsYou
    reviewEverything
    sections
    setAside
    startedAt
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createIntegration = /* GraphQL */ `mutation CreateIntegration($input: CreateIntegrationInput!, $condition: ModelIntegrationConditionInput) {
  createIntegration(input: $input, condition: $condition) {
    id
    configurations {
      name
      value
      __typename
    }
    error
    lastRun
    name
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createInternalComment = /* GraphQL */ `mutation CreateInternalComment($input: CreateInternalCommentInput!, $condition: ModelInternalCommentConditionInput) {
  createInternalComment(input: $input, condition: $condition) {
    id
    authorId
    content
    entityId
    entityType
    kind
    mentionedUserIds
    userIdsReactions {
      reactionType
      userId
      __typename
    }
    replyToId
    attachmentFileIds
    systemMessage
    systemMessageParameters
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createInvoice = /* GraphQL */ `mutation CreateInvoice($input: CreateInvoiceInput!, $condition: ModelInvoiceConditionInput) {
  createInvoice(input: $input, condition: $condition) {
    id
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    creditNote
    creditNoteLabel
    customValues {
      name
      value
      __typename
    }
    disputedPostingIds
    disputes {
      id
      scope
      postingId
      postingLabel
      reason
      comment
      disputedOn
      openedAt
      openedById
      openDecisionId
      liftedAt
      liftedById
      liftCause
      liftDecisionId
      __typename
    }
    disputeStatus
    dueDate
    invoiceDate
    invoiceNumber
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    paid
    integrations {
      paymentProperties {
        availableOn
        error
        feeAmount
        paymentIntentId
        paymentLinkAmount
        paymentLinkUrl
        payoutId
        statementDescriptor
        __typename
      }
      __typename
    }
    lastValidatedAt
    note
    postedDate
    purchaseOrderNumber
    receiptNumber
    reminderDates
    remittanceInformation
    reversedInvoiceId
    sentVersions {
      version
      sentAt
      invoiceNumber
      invoiceSenderId
      channels {
        channel
        status
        communicationId
        peppolId
        __typename
      }
      pdfFileId
      xmlFileId
      resetAt
      resetBy
      reason
      __typename
    }
    statementId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    type
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createInvoiceSetting = /* GraphQL */ `mutation CreateInvoiceSetting($input: CreateInvoiceSettingInput!, $condition: ModelInvoiceSettingConditionInput) {
  createInvoiceSetting(input: $input, condition: $condition) {
    id
    creditNoteFormat
    creditNoteLastUpdate
    creditNoteIncrementNumber
    invoiceFormat
    invoiceLastUpdate
    invoiceIncrementNumber
    paymentRequestFormat
    paymentRequestLastUpdate
    paymentRequestIncrementNumber
    receiptFormat
    receiptLastUpdate
    receiptIncrementNumber
    variousOperationFormat
    variousOperationLastUpdate
    variousOperationIncrementNumber
    customInvoicingConfiguration
    defaultVatRateId
    fiscalYearStart
    allPurposeInvoiceIssuer
    paymentBankAccountId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createLearningEvent = /* GraphQL */ `mutation CreateLearningEvent($input: CreateLearningEventInput!, $condition: ModelLearningEventConditionInput) {
  createLearningEvent(input: $input, condition: $condition) {
    id
    at
    field
    from
    kind
    layoutId
    senderId
    to
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createLease = /* GraphQL */ `mutation CreateLease($input: CreateLeaseInput!, $condition: ModelLeaseConditionInput) {
  createLease(input: $input, condition: $condition) {
    id
    advancedChargesInvoices {
      communicationSettingsProfileId
      invoiceSenderId
      lastDraftInvoiceDate
      lastInvoiceDate
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      remittanceInformation
      remittanceInformationType
      bankAccountId
      __typename
    }
    balance
    canBeExtended
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    endDate
    includeRealEstateInLeaseContract
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    inventoryOfFixturesExpert
    inventoryOfFixturesMethod
    inventoryOfFixturesType
    ipiNumber
    language
    lastDraftInvoiceDate
    lastIndexationProcessDate
    lastInvoiceDate
    legalCompetentAuthority
    name
    notes
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    paymentOption {
      enabled
      mandateStatus
      mandateActivatedAt
      customerId
      paymentMethodId
      qrType
      __typename
    }
    purchaseOrderNumber
    realEstateAgency
    realEstateTax
    remittanceInformation
    remittanceInformationType
    rentalGuaranty {
      amount
      blockedAmount
      releasedAmount
      type
      financialInstitution
      __typename
    }
    signatureDate
    startDate
    nextIndexationMonth
    nextIndexation
    status
    subletting
    technicCommunicationSettingsProfileId
    totalInitialRentalPrice
    totalRentalPrice
    type
    vatRateRentId
    vatRateRent {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    additionalClauses {
      items {
        id
        leaseId
        title
        body
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    attachStatementSupportingDocuments
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contacts {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leaseActionHistories {
      items {
        id
        action
        comment
        contactId
        leaseId
        communicationId
        signatureDocumentId
        status
        communicationChannel
        communicationSendDate
        communicationByPlatform
        endReason
        endReasonOwnUseRelation
        endReasonOwnUseName
        initiator
        totalAmount
        totalAmountLabel
        automatic
        hasLeaseTypeChanged
        jiraId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leasePriceHistories {
      items {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    signatureDocuments {
      items {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    variousOperations {
      items {
        id
        accountLabelIds
        amount
        billingMode
        contactId
        dueDateDaysAfterPeriodStart
        endDate
        indexationBaseAmount
        indexationBaseIndexDate
        indexationFrozen
        invoiceSenderId
        issueLeadDays
        label
        lastInvoiceDate
        leaseId
        operationType
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        periodNature
        reason
        separateInvoice
        startDate
        type
        unitId
        vatRateId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createLeaseActionHistory = /* GraphQL */ `mutation CreateLeaseActionHistory($input: CreateLeaseActionHistoryInput!, $condition: ModelLeaseActionHistoryConditionInput) {
  createLeaseActionHistory(input: $input, condition: $condition) {
    id
    action
    comment
    contactId
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    historyDetails {
      unitId
      newEndDate
      newSignatureDate
      newStartDate
      previousEndDate
      previousSignatureDate
      previousStartDate
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    communicationChannel
    communicationSendDate
    communicationByPlatform
    endReason
    endReasonOwnUseRelation
    endReasonOwnUseName
    initiator
    totalAmount
    totalAmountLabel
    automatic
    hasLeaseTypeChanged
    jiraId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createLeaseAdditionalClause = /* GraphQL */ `mutation CreateLeaseAdditionalClause($input: CreateLeaseAdditionalClauseInput!, $condition: ModelLeaseAdditionalClauseConditionInput) {
  createLeaseAdditionalClause(input: $input, condition: $condition) {
    id
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    title
    body
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createLeaseContact = /* GraphQL */ `mutation CreateLeaseContact($input: CreateLeaseContactInput!, $condition: ModelLeaseContactConditionInput) {
  createLeaseContact(input: $input, condition: $condition) {
    id
    leaseId
    contactId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactRole
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createLeasePriceHistory = /* GraphQL */ `mutation CreateLeasePriceHistory($input: CreateLeasePriceHistoryInput!, $condition: ModelLeasePriceHistoryConditionInput) {
  createLeasePriceHistory(input: $input, condition: $condition) {
    id
    previousTotalRentalPrice
    totalRentalPrice
    optimalTotalRentalPrice
    optimalTotalMonthlyCharges
    applicationDate
    status
    comment
    amountDetails {
      unitId
      indexationBaseIndex
      indexationNewIndex
      previousRentalPrice
      newRentalPrice
      rentalStatus
      monthlyChargesStatus
      optimalNewRentalPrice
      optimalNewMonthlyChargesPrice
      epb
      epbIssueDate
      oldestIndexForCorrectionFactorCalculation
      newestIndexForCorrectionFactorCalculation
      rentIndexedPriceAfterNewEpbReduction
      chargesIndexedPriceAfterNewEpbReduction
      correctionFactor
      chargesAmountsDetails {
        leaseVariousOperationId
        previousMonthlyAmount
        newMonthlyAmount
        indexationBaseIndex
        indexationBaseAmount
        indexationBaseIndexDate
        indexed
        __typename
      }
      reductionPercentage
      rentDifference
      rentReduction
      indexedRentAfterReduction
      chargesDifference
      chargesReduction
      indexedChargesAfterReduction
      previousYearIndexationNewIndex
      previousYearIndexedRent
      previousYearIndexedCharges
      __typename
    }
    type
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createLeaseVariousOperation = /* GraphQL */ `mutation CreateLeaseVariousOperation($input: CreateLeaseVariousOperationInput!, $condition: ModelLeaseVariousOperationConditionInput) {
  createLeaseVariousOperation(input: $input, condition: $condition) {
    id
    accountLabelIds
    amount
    billingMode
    contactId
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dueDateDaysAfterPeriodStart
    endDate
    indexationBaseAmount
    indexationBaseIndexDate
    indexationFrozen
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issueLeadDays
    label
    lastInvoiceDate
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    operationType
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    periodNature
    reason
    separateInvoice
    startDate
    type
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createMandateLink = /* GraphQL */ `mutation CreateMandateLink($input: CreateMandateLinkInput!) {
  createMandateLink(input: $input) {
    status
    id
    __typename
  }
}
`;

export const createMortgage = /* GraphQL */ `mutation CreateMortgage($input: CreateMortgageInput!, $condition: ModelMortgageConditionInput) {
  createMortgage(input: $input, condition: $condition) {
    id
    lender
    durationInYears
    rateType
    interestRate
    aprRate
    startDate
    amount
    monthlyPayment
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createNotification = /* GraphQL */ `mutation CreateNotification($input: CreateNotificationInput!, $condition: ModelNotificationConditionInput) {
  createNotification(input: $input, condition: $condition) {
    id
    createdBy
    type
    message
    popupDate
    expirationDate
    status
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicId
    technic {
      id
      type
      technicLibraryId
      technicLibrary {
        id
        communicationSettingsProfileId
        criticality
        isDefault
        issuingAuthority
        linkedCertificateIds
        locationScope
        status
        tagIds
        technicLibraryFormat
        type
        utilityTypes
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicName
      lastControlDate
      status
      contractNumber
      communicationSettingsProfileId
      maintenanceHistory {
        date
        contactId
        fileId
        id
        maintenanceSchemaId
        __typename
      }
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityDistributor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      utilityHistory {
        date
        reason
        reading
        secondReading
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      originalTechnicId
      replacedTechnicId
      certificateIds
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ticketId
    ticket {
      id
      assignedAt
      assignedTo {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedToId
      attachment {
        nextToken
        startedAt
        __typename
      }
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      closedAt
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      content
      conversations {
        nextToken
        startedAt
        __typename
      }
      emailMessageId
      emailReferences
      parentId
      plannedAt
      referenceCode
      sourceType
      status
      subject
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unread
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createPaymentBatch = /* GraphQL */ `mutation CreatePaymentBatch($input: CreatePaymentBatchInput!, $condition: ModelPaymentBatchConditionInput) {
  createPaymentBatch(input: $input, condition: $condition) {
    id
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientStatusKey
    currentVersion
    number
    outdated
    sentAt
    sentBy
    status
    versions {
      version
      exclusions {
        orderId
        reason
        __typename
      }
      fileKey
      fingerprint
      generatedAt
      generatedBy
      orderCount
      totalAmount
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createPaymentLink = /* GraphQL */ `mutation CreatePaymentLink($input: CreatePaymentLinkInput!) {
  createPaymentLink(input: $input) {
    status
    id
    __typename
  }
}
`;

export const createPaymentOrder = /* GraphQL */ `mutation CreatePaymentOrder($input: CreatePaymentOrderInput!, $condition: ModelPaymentOrderConditionInput) {
  createPaymentOrder(input: $input, condition: $condition) {
    id
    amount
    anomalies
    anomalyAcknowledgedAt
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    confirmationDeadlineDate
    counterpartAccountNumber
    counterpartContactId
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    counterpartContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartRemittanceInformation
    createdBy
    dueDate
    executedDate
    executedAt
    executedBy
    executedTransactionId
    feeArrearsId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    fundAmounts {
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issuedAt
    issuedBy
    ownerContactId
    paymentBatchId
    paymentBatch {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    reconciledAt
    recurringPaymentTemplateId
    reference
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    requestedAmount
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createPaymentOrders = /* GraphQL */ `mutation CreatePaymentOrders($invoiceIds: [ID!]!, $overrides: [OrderOverride!]) {
  createPaymentOrders(invoiceIds: $invoiceIds, overrides: $overrides) {
    failures {
      invoiceId
      reason
      __typename
    }
    orders {
      amount
      bankAccountId
      dueDate
      id
      invoiceId
      reference
      status
      __typename
    }
    warnings {
      bankAccountId
      invoiceId
      shortAmount
      __typename
    }
    __typename
  }
}
`;

export const createPaymentProviderAccount = /* GraphQL */ `mutation CreatePaymentProviderAccount($input: CreatePaymentProviderAccountInput!) {
  createPaymentProviderAccount(input: $input) {
    url
    __typename
  }
}
`;

export const createPeppolDocument = /* GraphQL */ `mutation CreatePeppolDocument($input: CreatePeppolDocumentInput!) {
  createPeppolDocument(input: $input) {
    size
    status
    __typename
  }
}
`;

export const createPosting = /* GraphQL */ `mutation CreatePosting($input: CreatePostingInput!, $condition: ModelPostingConditionInput) {
  createPosting(input: $input, condition: $condition) {
    id
    class
    customLabel
    customValues {
      name
      value
      __typename
    }
    topClass
    type
    totalAmount
    periodFrom
    periodTo
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    transactionId
    transaction {
      id
      status
      snoozedUntil
      sequence
      statementDate
      operationDate
      customValues {
        name
        value
        __typename
      }
      remittanceInformationType
      remittanceInformation
      remittanceInformationRaw
      additionalInformation
      structuredCommunication
      bankTransactionCode
      proprietaryBankTransactionCode
      endToEndId
      mandateId
      creditorId
      purposeCode
      internalReference
      comment
      exclusionReason
      exclusionComment
      excludedAt
      excludedBy
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartDisplayName
      counterpartAccountNumber
      origin
      sourceChannel
      nativeTransactionId
      fingerprint
      linkedSourceChannels
      proposedLeaseId
      proposedUnitId
      proposedContractorId
      proposedOwnerId
      proposedMatch
      proposedAllocation
      classification
      classificationConfidence
      classificationReason
      recurrence
      links {
        amount
        linkId
        linkType
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationId
    leaseVariousOperation {
      id
      accountLabelIds
      amount
      billingMode
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dueDateDaysAfterPeriodStart
      endDate
      indexationBaseAmount
      indexationBaseIndexDate
      indexationFrozen
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issueLeadDays
      label
      lastInvoiceDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      operationType
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      periodNature
      reason
      separateInvoice
      startDate
      type
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    amountVatExcluded
    vatAmount
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    vatRateId
    vatRateValue
    foreignId
    foreignType
    invoicePostingId
    reconciledAt
    decisionId
    status
    chargeOwnerRepartition
    chargeRepartitionMetric
    chargeRepartitionValue
    chargeSplitNumber
    chargeType
    tenantShare {
      basis
      mode
      percentage
      __typename
    }
    provisional
    flaggedAt
    carriedForward
    tenantLandings {
      amount
      amountVatExcluded
      days
      leaseId
      periodFrom
      periodTo
      statementId
      vatAmount
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createReconciliationDecision = /* GraphQL */ `mutation CreateReconciliationDecision($input: CreateReconciliationDecisionInput!, $condition: ModelReconciliationDecisionConditionInput) {
  createReconciliationDecision(input: $input, condition: $condition) {
    id
    decisionId
    transactionId
    relatedTransactionIds
    kind
    status
    source
    trigger
    actorId
    outcome
    score
    reasonCodes
    flowType
    amount
    links {
      amount
      linkId
      linkType
      __typename
    }
    allocations {
      invoiceId
      postingId
      amount
      awaitingPosting
      __typename
    }
    exclusionReason
    comment
    snoozedUntil
    reversesDecisionId
    appliesDecisionId
    decidedAt
    backfilled
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createReconciliationSetting = /* GraphQL */ `mutation CreateReconciliationSetting($input: CreateReconciliationSettingInput!, $condition: ModelReconciliationSettingConditionInput) {
  createReconciliationSetting(input: $input, condition: $condition) {
    id
    type
    allocationMode
    leaseId
    ownerId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createRecurringPayment = /* GraphQL */ `mutation CreateRecurringPayment($input: CreateRecurringPaymentInput!) {
  createRecurringPayment(input: $input) {
    failureReason
    recurringPayment {
      amountVersions {
        createdAt
        createdBy
        effectiveFrom
        note
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      bankAccountId
      beneficiaryBankAccountId
      beneficiaryContactId
      currentAmountVersion {
        createdAt
        createdBy
        effectiveFrom
        note
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      endDate
      firstPeriodFrom
      funds {
        accountLabelId
        fundId
        remittanceInformation
        __typename
      }
      generatedThisMonthAmount
      generatedThisMonthOrderCount
      generationDay
      id
      name
      nextDueDate
      oldestPendingPeriodFrom
      pendingAmount
      pendingPeriodCount
      periodicity
      remittanceInformation
      splitTransfers
      status
      underfunded
      unitId
      __typename
    }
    __typename
  }
}
`;

export const createRecurringPaymentTemplate = /* GraphQL */ `mutation CreateRecurringPaymentTemplate($input: CreateRecurringPaymentTemplateInput!, $condition: ModelRecurringPaymentTemplateConditionInput) {
  createRecurringPaymentTemplate(input: $input, condition: $condition) {
    id
    amountVersions {
      amounts {
        amount
        fundId
        __typename
      }
      createdAt
      createdBy
      effectiveFrom
      note
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryBankAccountId
    beneficiaryBankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryContactId
    beneficiaryContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdBy
    endDate
    endedAt
    endedBy
    firstPeriodFrom
    funds {
      accountLabelId
      fundId
      remittanceInformation
      __typename
    }
    generationDay
    lastGeneratedPeriodFrom
    name
    periodicity
    remittanceInformation
    splitTransfers
    status
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createReleaseNote = /* GraphQL */ `mutation CreateReleaseNote($input: CreateReleaseNoteInput!, $condition: ModelReleaseNoteConditionInput) {
  createReleaseNote(input: $input, condition: $condition) {
    id
    status
    publishedAt
    visibleToOwners
    contents {
      language
      title
      body
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createRepartitionKey = /* GraphQL */ `mutation CreateRepartitionKey($input: CreateRepartitionKeyInput!, $condition: ModelRepartitionKeyConditionInput) {
  createRepartitionKey(input: $input, condition: $condition) {
    id
    name
    type
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitRepartition {
      unitId
      value
      __typename
    }
    ownerRepartition
    tenantRepartition
    repartitionMetric
    technics
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createRepaymentStatement = /* GraphQL */ `mutation CreateRepaymentStatement($input: CreateRepaymentStatementInput!, $condition: ModelRepaymentStatementConditionInput) {
  createRepaymentStatement(input: $input, condition: $condition) {
    id
    accountOwnership
    delaysCleared
    expectedRent
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    rentsCollected
    repaymentStatementDetails {
      class
      customLabel
      invoiceId
      invoicePostingId
      originalTotalAmount
      periodFrom
      periodTo
      totalAmount
      transactionId
      type
      __typename
    }
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    totalReceivedInJointAccount
    totalExpectedInOwnerAccount
    unpaidRents
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createScheduleRule = /* GraphQL */ `mutation CreateScheduleRule($input: CreateScheduleRuleInput!, $condition: ModelScheduleRuleConditionInput) {
  createScheduleRule(input: $input, condition: $condition) {
    id
    conditions {
      attribute {
        attributeName
        __typename
      }
      comparisonMode
      operator
      values
      valueKind
      __typename
    }
    conditionsOperator
    foreignKey
    foreignTableName
    name {
      language
      label
      __typename
    }
    order
    outcome {
      interval {
        __typename
      }
      type
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createSenderRule = /* GraphQL */ `mutation CreateSenderRule($input: CreateSenderRuleInput!, $condition: ModelSenderRuleConditionInput) {
  createSenderRule(input: $input, condition: $condition) {
    id
    senderId
    sender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    kind
    scope {
      accountClass
      identifierKind
      identifierValue
      labelKey
      ownerId
      __typename
    }
    value {
      accountLabelId
      encodesInvoiceNumber
      paymentOnReceipt
      paymentTermDays
      privateExpense
      recoverabilityMode
      recoverabilityPercentage
      reminderFees
      roundingPrecision
      vatRateValues
      __typename
    }
    source
    confirmations
    updatedBy
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createSendingSource = /* GraphQL */ `mutation CreateSendingSource($input: CreateSendingSourceInput!, $condition: ModelSendingSourceConditionInput) {
  createSendingSource(input: $input, condition: $condition) {
    id
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dnsRecords {
      name
      type
      value
      __typename
    }
    emailAddress
    issuesEmail
    chargesEmail
    errorMessage
    name
    lastReminderDate
    status
    statusLastVerification
    verifiedType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createSetting = /* GraphQL */ `mutation CreateSetting($input: CreateSettingInput!, $condition: ModelSettingConditionInput) {
  createSetting(input: $input, condition: $condition) {
    id
    name
    value
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createSignatureDocument = /* GraphQL */ `mutation CreateSignatureDocument($input: CreateSignatureDocumentInput!, $condition: ModelSignatureDocumentConditionInput) {
  createSignatureDocument(input: $input, condition: $condition) {
    id
    additionalMessage
    automaticRemindersDisabled
    communicationBody
    expirationDate
    fileIds
    foreignKey
    foreignTableName
    sentAt
    signatureMethods
    signatureResults {
      openedDate
      signedDate
      signed
      signatureLink
      rejectReason
      lastSignInviteSentDate
      reminderDates
      trackingProvider
      trackingCode
      contactId
      __typename
    }
    status
    externalStatus
    type
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createStatement = /* GraphQL */ `mutation CreateStatement($input: CreateStatementInput!, $condition: ModelStatementConditionInput) {
  createStatement(input: $input, condition: $condition) {
    id
    amounts {
      name
      value
      __typename
    }
    attachSupportingDocuments
    chargeStatements {
      items {
        id
        chargeId
        statementId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    closingStatement
    periodFrom
    periodTo
    selectedPocketKeys
    source
    status
    sentDate
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    agencyRateStatements {
      items {
        id
        agencyRateId
        statementId
        totalAmountRateable
        totalFixedAmount
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    repaymentStatements {
      items {
        id
        accountOwnership
        delaysCleared
        expectedRent
        leaseId
        rentsCollected
        statementId
        totalReceivedInJointAccount
        totalExpectedInOwnerAccount
        unpaidRents
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    types
    viewType
    unitIds
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createStatementSetting = /* GraphQL */ `mutation CreateStatementSetting($input: CreateStatementSettingInput!, $condition: ModelStatementSettingConditionInput) {
  createStatementSetting(input: $input, condition: $condition) {
    id
    type
    custom
    disabled
    monthFrequency
    startMonth
    generationDay
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createSubscriptionUsageHistory = /* GraphQL */ `mutation CreateSubscriptionUsageHistory($input: CreateSubscriptionUsageHistoryInput!, $condition: ModelSubscriptionUsageHistoryConditionInput) {
  createSubscriptionUsageHistory(input: $input, condition: $condition) {
    id
    clientId
    creditUsageDetail {
      numberUsed
      creditsAccount
      creditOperationType
      __typename
    }
    customerCreatorId
    requestId
    applicationInvoiceId
    storageUsageDetail {
      numberUsed
      __typename
    }
    type
    unitsUsageDetail {
      unitsUsage {
        numberUsed
        unitId
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      proRataUnits {
        unitId
        numberOfDays
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createTag = /* GraphQL */ `mutation CreateTag($input: CreateTagInput!, $condition: ModelTagConditionInput) {
  createTag(input: $input, condition: $condition) {
    id
    color
    foreignTableName
    labels {
      language
      label
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createTechnic = /* GraphQL */ `mutation CreateTechnic($input: CreateTechnicInput!, $condition: ModelTechnicConditionInput) {
  createTechnic(input: $input, condition: $condition) {
    id
    type
    technicLibraryId
    technicLibrary {
      id
      certificateValidity {
        nonCompliant
        overlapping
        riskLevel
        __typename
      }
      communicationSettingsProfileId
      criticality
      customFields {
        nextToken
        startedAt
        __typename
      }
      descriptions {
        language
        label
        __typename
      }
      isDefault
      issuingAuthority
      linkedCertificateIds
      locationScope
      maintenanceSchemas {
        id
        criticality
        deadline
        maintenanceType
        notificationsEnabled
        notificationType
        proofType
        recurrence
        responsibleParty
        triggerType
        __typename
      }
      names {
        language
        label
        __typename
      }
      status
      tagIds
      technicLibraryFormat
      type
      utilityTypes
      validity {
        value
        validityUnit
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicName
    lastControlDate
    status
    contractNumber
    communicationSettingsProfileId
    maintenanceHistory {
      date
      contactId
      customValues {
        name
        value
        __typename
      }
      fileId
      id
      maintenanceSchemaId
      __typename
    }
    utilityType
    utilityEanCode
    utilityMeterNumber
    utilityDistributorId
    utilityDistributor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    utilityHistory {
      date
      reason
      reading
      secondReading
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    originalTechnicId
    replacedTechnicId
    certificateIds
    readers
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createTechnicLibrary = /* GraphQL */ `mutation CreateTechnicLibrary($input: CreateTechnicLibraryInput!, $condition: ModelTechnicLibraryConditionInput) {
  createTechnicLibrary(input: $input, condition: $condition) {
    id
    certificateValidity {
      gracePeriod {
        value
        validityUnit
        __typename
      }
      nonCompliant
      overlapping
      riskLevel
      __typename
    }
    communicationSettingsProfileId
    criticality
    customFields {
      items {
        id
        fieldName
        fieldType
        foreignKey
        foreignTableName
        order
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    descriptions {
      language
      label
      __typename
    }
    isDefault
    issuingAuthority
    linkedCertificateIds
    locationScope
    maintenanceSchemas {
      id
      criticality
      deadline
      descriptions {
        language
        label
        __typename
      }
      interval {
        value
        validityUnit
        __typename
      }
      maintenanceType
      names {
        language
        label
        __typename
      }
      notificationsEnabled
      notificationType
      proofType
      proofTypeName {
        language
        label
        __typename
      }
      recurrence
      responsibleParty
      triggerType
      __typename
    }
    names {
      language
      label
      __typename
    }
    status
    tagIds
    technicLibraryFormat
    type
    utilityTypes
    validity {
      value
      validityUnit
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createTemplate = /* GraphQL */ `mutation CreateTemplate($input: CreateTemplateInput!, $condition: ModelTemplateConditionInput) {
  createTemplate(input: $input, condition: $condition) {
    id
    language
    name
    subject
    subjectRawFormat
    body
    bodyRawFormat
    type
    subType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createTicket = /* GraphQL */ `mutation CreateTicket($input: CreateTicketInput!, $condition: ModelTicketConditionInput) {
  createTicket(input: $input, condition: $condition) {
    id
    assignedAt
    assignedTo {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedToId
    attachment {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    closedAt
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    content
    conversations {
      items {
        id
        assignedAt
        assignedToId
        buildingId
        closedAt
        contactId
        content
        emailMessageId
        emailReferences
        parentId
        plannedAt
        referenceCode
        sourceType
        status
        subject
        unitId
        unread
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    emailMessageId
    emailReferences
    parentId
    plannedAt
    referenceCode
    sourceType
    status
    subject
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unread
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createTransaction = /* GraphQL */ `mutation CreateTransaction($input: CreateTransactionInput!, $condition: ModelTransactionConditionInput) {
  createTransaction(input: $input, condition: $condition) {
    id
    status
    snoozedUntil
    sequence
    statementDate
    operationDate
    customValues {
      name
      value
      __typename
    }
    remittanceInformationType
    remittanceInformation
    remittanceInformationRaw
    additionalInformation
    structuredCommunication
    bankTransactionCode
    proprietaryBankTransactionCode
    endToEndId
    mandateId
    creditorId
    purposeCode
    internalReference
    comment
    exclusionReason
    exclusionComment
    excludedAt
    excludedBy
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartDisplayName
    counterpartAccountNumber
    origin
    sourceChannel
    nativeTransactionId
    fingerprint
    linkedSourceChannels
    proposedLeaseId
    proposedUnitId
    proposedContractorId
    proposedOwnerId
    proposedMatch
    proposedAllocation
    classification
    classificationConfidence
    classificationReason
    recurrence
    links {
      amount
      linkId
      linkType
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createTransactionRule = /* GraphQL */ `mutation CreateTransactionRule($input: CreateTransactionRuleInput!, $condition: ModelTransactionRuleConditionInput) {
  createTransactionRule(input: $input, condition: $condition) {
    id
    isFullRemittance
    remittanceInformation
    counterpartName
    counterpartAccountNumber
    usedFields
    exclude
    exclusionReason
    exclusionComment
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createU2REntitiesFromExactOnline = /* GraphQL */ `mutation CreateU2REntitiesFromExactOnline($input: CreateU2REntitiesFromExactOnlineInput!) {
  createU2REntitiesFromExactOnline(input: $input)
}
`;

export const createUnit = /* GraphQL */ `mutation CreateUnit($input: CreateUnitInput!, $condition: ModelUnitConditionInput) {
  createUnit(input: $input, condition: $condition) {
    id
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    acquisitionValue
    advertisedMonthlyCharges
    advertisedRentalPrice
    cadastralIncome
    customValues {
      name
      value
      __typename
    }
    floor
    jointOwnershipId
    managementDate
    name
    notes
    predictedPrice
    propertyTax
    publishAddress
    surface
    type
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owners {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leases {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        unitId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    unitAdvertisementId
    unitInventories {
      items {
        id
        privateBatthRoom
        deletedAt
        kitchenEquipment
        roomName
        roomType
        surface
        showSurface
        unitId
        inside
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createUnitEvent = /* GraphQL */ `mutation CreateUnitEvent($input: CreateUnitEventInput!, $condition: ModelUnitEventConditionInput) {
  createUnitEvent(input: $input, condition: $condition) {
    id
    unitId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createUnitInventory = /* GraphQL */ `mutation CreateUnitInventory($input: CreateUnitInventoryInput!, $condition: ModelUnitInventoryConditionInput) {
  createUnitInventory(input: $input, condition: $condition) {
    id
    privateBatthRoom
    deletedAt
    kitchenEquipment
    roomName
    roomType
    surface
    showSurface
    unitId
    inside
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createUnitLease = /* GraphQL */ `mutation CreateUnitLease($input: CreateUnitLeaseInput!, $condition: ModelUnitLeaseConditionInput) {
  createUnitLease(input: $input, condition: $condition) {
    id
    allowChargeAdjustment
    authorizeProfessionalActivity
    chargesIndexation
    endDate
    furnishedRental
    furnishedRentalInsuranceByTenant
    furnishedRentalRentalPricePercentage
    initialRentalPrice
    indexation
    advancedIndexation
    indexType
    baseYear
    baseIndexType
    baseIndexDate
    nextIndexationMonth
    nextIndexation
    leaseId
    mainUnit
    rentalPrice
    signatureDate
    startDate
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createUnitOwner = /* GraphQL */ `mutation CreateUnitOwner($input: CreateUnitOwnerInput!, $condition: ModelUnitOwnerConditionInput) {
  createUnitOwner(input: $input, condition: $condition) {
    id
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    periodFrom
    periodTo
    stake
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createValuation = /* GraphQL */ `mutation CreateValuation($input: CreateValuationInput!, $condition: ModelValuationConditionInput) {
  createValuation(input: $input, condition: $condition) {
    id
    sourceType
    valorization
    date
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createVariousOperation = /* GraphQL */ `mutation CreateVariousOperation($input: CreateVariousOperationInput!, $condition: ModelVariousOperationConditionInput) {
  createVariousOperation(input: $input, condition: $condition) {
    id
    amount
    labels {
      language
      label
      __typename
    }
    numberOfMonths
    operationType
    paymentFrequency
    type
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const createVatRate = /* GraphQL */ `mutation CreateVatRate($input: CreateVatRateInput!, $condition: ModelVatRateConditionInput) {
  createVatRate(input: $input, condition: $condition) {
    id
    country
    label
    value
    vatKind
    customValues {
      name
      value
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const decideLeasePriceHistories = /* GraphQL */ `mutation DecideLeasePriceHistories($input: DecideLeasePriceHistoriesInput!) {
  decideLeasePriceHistories(input: $input) {
    failed {
      id
      reason
      __typename
    }
    succeededIds
    __typename
  }
}
`;

export const deleteAccountLabel = /* GraphQL */ `mutation DeleteAccountLabel($input: DeleteAccountLabelInput!, $condition: ModelAccountLabelConditionInput) {
  deleteAccountLabel(input: $input, condition: $condition) {
    id
    labels {
      language
      label
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    class
    customUsage
    customValues {
      name
      value
      __typename
    }
    disabled
    hoaFundId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    topClass
    vatNonDeductiblePercentage
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteAddress = /* GraphQL */ `mutation DeleteAddress($input: DeleteAddressInput!, $condition: ModelAddressConditionInput) {
  deleteAddress(input: $input, condition: $condition) {
    id
    status
    street
    number
    box
    postalCode
    city
    region
    country
    customValues {
      name
      value
      __typename
    }
    latitude
    longitude
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteAdminCommunication = /* GraphQL */ `mutation DeleteAdminCommunication($input: DeleteAdminCommunicationInput!, $condition: ModelAdminCommunicationConditionInput) {
  deleteAdminCommunication(input: $input, condition: $condition) {
    id
    body
    clientId
    externalId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    applicationInvoiceId
    recipient
    sentAt
    status
    subject
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteAdminFile = /* GraphQL */ `mutation DeleteAdminFile($input: DeleteAdminFileInput!, $condition: ModelAdminFileConditionInput) {
  deleteAdminFile(input: $input, condition: $condition) {
    id
    bucket
    foreignKey
    foreignTableName
    key
    mimeType
    region
    size
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteAdvertisement = /* GraphQL */ `mutation DeleteAdvertisement($input: DeleteAdvertisementInput!, $condition: ModelAdvertisementConditionInput) {
  deleteAdvertisement(input: $input, condition: $condition) {
    id
    type
    subType
    amenities
    amountOfFacades
    availabilityDate
    certificateOfConformity
    citationForPlanningOffence
    descriptions {
      language
      description
      __typename
    }
    delimitedZone
    floodProneArea
    furnished
    firstOccupancy
    gardenSurface
    heatingAmenities
    heatingType
    landTerrain
    landArea
    length
    nearbyComodities {
      type
      name
      distance
      __typename
    }
    publishedPlatforms {
      name
      publishedDate
      id
      __typename
    }
    planningPermission
    publishCadastralIncome
    resort
    rightOfPreemption
    subdivisionAuthorization
    wheelChairAccessible
    width
    terraceSurface
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteAgencyRate = /* GraphQL */ `mutation DeleteAgencyRate($input: DeleteAgencyRateInput!, $condition: ModelAgencyRateConditionInput) {
  deleteAgencyRate(input: $input, condition: $condition) {
    id
    amountDetails {
      amountType
      endAmount
      feeApplied
      startAmount
      __typename
    }
    rateWhenVacant {
      amount
      type
      __typename
    }
    amountMinimumFees
    custom
    feesAppliedTo
    includedInAmount
    name
    owners {
      items {
        id
        agencyRateId
        contactId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    repartitionType
    type
    unitType
    vatRateId
    unitIds
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteAgencyRateOwner = /* GraphQL */ `mutation DeleteAgencyRateOwner($input: DeleteAgencyRateOwnerInput!, $condition: ModelAgencyRateOwnerConditionInput) {
  deleteAgencyRateOwner(input: $input, condition: $condition) {
    id
    agencyRateId
    contactId
    agencyRate {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteAgencyRateStatement = /* GraphQL */ `mutation DeleteAgencyRateStatement($input: DeleteAgencyRateStatementInput!, $condition: ModelAgencyRateStatementConditionInput) {
  deleteAgencyRateStatement(input: $input, condition: $condition) {
    id
    agencyRate {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    agencyRateId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    unitAmounts {
      unitId
      amountRateable
      fixedAmount
      __typename
    }
    totalAmountRateable
    totalFixedAmount
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteApplicationInvoice = /* GraphQL */ `mutation DeleteApplicationInvoice($input: DeleteApplicationInvoiceInput!, $condition: ModelApplicationInvoiceConditionInput) {
  deleteApplicationInvoice(input: $input, condition: $condition) {
    id
    amount
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    dueDate
    invoiceDate
    invoiceLines {
      items {
        id
        amountVatExcluded
        applicationInvoiceId
        calculationMethod
        clientId
        customLabel
        extraInformation
        quantity
        periodFrom
        periodTo
        subscriptionVariousOperationId
        subscriptionUsageHistoryId
        totalAmount
        type
        vatAmount
        vatRate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoiceNumber
    periodFrom
    periodTo
    clientSnapshot {
      name
      vat
      businessNumber
      email
      address {
        street
        number
        box
        postalCode
        city
        country
        __typename
      }
      __typename
    }
    peppolProperties {
      peppolStatus
      peppolId
      peppolErrorType
      peppolErrorMessage
      __typename
    }
    status
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteApplicationInvoiceLine = /* GraphQL */ `mutation DeleteApplicationInvoiceLine($input: DeleteApplicationInvoiceLineInput!, $condition: ModelApplicationInvoiceLineConditionInput) {
  deleteApplicationInvoiceLine(input: $input, condition: $condition) {
    id
    amountVatExcluded
    applicationInvoiceId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    calculationDetail {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    clientId
    customLabel
    extraInformation
    quantity
    periodFrom
    periodTo
    subscriptionVariousOperationId
    subscriptionVariousOperation {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    subscriptionUsageHistoryId
    subscriptionUsageHistory {
      id
      clientId
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    totalAmount
    type
    vatAmount
    vatRate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteApplicationPlan = /* GraphQL */ `mutation DeleteApplicationPlan($input: DeleteApplicationPlanInput!, $condition: ModelApplicationPlanConditionInput) {
  deleteApplicationPlan(input: $input, condition: $condition) {
    id
    calculationDetails {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    includedVariousOperations {
      items {
        id
        amount
        applicationPlanIncludedVariousOperationsId
        customerVisible
        duration
        numberOfCredits
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    isBillable
    isDefaultPlan
    labels {
      language
      label
      __typename
    }
    numberOfTrialMonths
    setupFees
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteApplicationSubscription = /* GraphQL */ `mutation DeleteApplicationSubscription($input: DeleteApplicationSubscriptionInput!, $condition: ModelApplicationSubscriptionConditionInput) {
  deleteApplicationSubscription(input: $input, condition: $condition) {
    id
    clientId
    creditsBalancePaid
    creditsBalanceIncluded
    creditsConfiguration {
      allowPostPaid
      creditsNotification
      postPaidThreshold
      __typename
    }
    endDate
    language
    lastInvoiceDate
    paymentCustomerId
    paymentLastExecution
    paymentLastStatus
    paymentLastError
    paymentMode
    paymentTerms
    invoicesProperties {
      hideQuantities
      __typename
    }
    plan {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    planId
    referenceNumber
    seller {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sellerId
    startDate
    status
    subscriptionVariousOperations {
      items {
        id
        applicationSubscriptionId
        clientId
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteApplicationSubscriptionVariousOperation = /* GraphQL */ `mutation DeleteApplicationSubscriptionVariousOperation($input: DeleteApplicationSubscriptionVariousOperationInput!, $condition: ModelApplicationSubscriptionVariousOperationConditionInput) {
  deleteApplicationSubscriptionVariousOperation(input: $input, condition: $condition) {
    id
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    createdBy {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    endDate
    label
    lastInvoiceDate
    sellerId
    startDate
    subscriptionVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteApplicationVariousOperation = /* GraphQL */ `mutation DeleteApplicationVariousOperation($input: DeleteApplicationVariousOperationInput!, $condition: ModelApplicationVariousOperationConditionInput) {
  deleteApplicationVariousOperation(input: $input, condition: $condition) {
    id
    amount
    applicationPlanIncludedVariousOperationsId
    customerVisible
    duration
    labels {
      language
      label
      __typename
    }
    numberOfCredits
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteAuthMember = /* GraphQL */ `mutation DeleteAuthMember($input: DeleteAuthMemberInput!) {
  deleteAuthMember(input: $input) {
    status
    id
    __typename
  }
}
`;

export const deleteAuthTeam = /* GraphQL */ `mutation DeleteAuthTeam($input: DeleteAuthTeamInput!) {
  deleteAuthTeam(input: $input) {
    clientId
    id
    name
    parentId
    __typename
  }
}
`;

export const deleteAuthUserRole = /* GraphQL */ `mutation DeleteAuthUserRole($input: DeleteAuthUserRoleInput!) {
  deleteAuthUserRole(input: $input) {
    clientId
    id
    isDefault
    name
    userRights {
      access
      section
      __typename
    }
    __typename
  }
}
`;

export const deleteBankAccount = /* GraphQL */ `mutation DeleteBankAccount($input: DeleteBankAccountInput!, $condition: ModelBankAccountConditionInput) {
  deleteBankAccount(input: $input, condition: $condition) {
    id
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactIds
    buildingIds
    number
    bicNumber
    bankName
    holderName
    label
    customValues {
      name
      value
      __typename
    }
    disabled
    integrations
    matchingRule
    initiationChannel
    retainedBalanceThreshold
    balance
    balanceDate
    type
    ibanStatus
    ibanVerifiedAt
    ibanVerifiedBy
    ibanVerifiedNumber
    ibanVerifiedSourceDocumentId
    ibanRole
    ibanRoleLabel
    isDefault
    note
    paymentRunPriorityOrderIds
    paymentRunPriorityUpdatedAt
    paymentRunPriorityUpdatedBy
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteBillingItem = /* GraphQL */ `mutation DeleteBillingItem($input: DeleteBillingItemInput!, $condition: ModelBillingItemConditionInput) {
  deleteBillingItem(input: $input, condition: $condition) {
    id
    name
    baseAmount
    billingType
    amountCalculationType
    percentageBase
    period
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    quantity
    percentage
    allocationOption
    multipleUnitsSplit
    leaseIds
    unitIds
    buildingIds
    accountLabelId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteBuilding = /* GraphQL */ `mutation DeleteBuilding($input: DeleteBuildingInput!, $condition: ModelBuildingConditionInput) {
  deleteBuilding(input: $input, condition: $condition) {
    id
    name
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    acquisitionValue
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    amountOfFacades
    amountOfFloors
    amountOfHousings
    buildingState
    cadastralIncome
    constructionYear
    customValues {
      name
      value
      __typename
    }
    janitor
    jointOwnershipId
    notes
    owners {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    propertyTax
    residenceName
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    units {
      items {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        buildingId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteBuildingEvent = /* GraphQL */ `mutation DeleteBuildingEvent($input: DeleteBuildingEventInput!, $condition: ModelBuildingEventConditionInput) {
  deleteBuildingEvent(input: $input, condition: $condition) {
    id
    buildingId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteBuildingOwner = /* GraphQL */ `mutation DeleteBuildingOwner($input: DeleteBuildingOwnerInput!, $condition: ModelBuildingOwnerConditionInput) {
  deleteBuildingOwner(input: $input, condition: $condition) {
    id
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    periodTo
    stake
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteBuildingSite = /* GraphQL */ `mutation DeleteBuildingSite($input: DeleteBuildingSiteInput!, $condition: ModelBuildingSiteConditionInput) {
  deleteBuildingSite(input: $input, condition: $condition) {
    id
    name
    buildings {
      items {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCashExpectation = /* GraphQL */ `mutation DeleteCashExpectation($input: DeleteCashExpectationInput!, $condition: ModelCashExpectationConditionInput) {
  deleteCashExpectation(input: $input, condition: $condition) {
    id
    sourceType
    sourceId
    direction
    flowType
    status
    accountIds
    originalAmount
    openAmount
    disputedAmount
    expectedAmount
    issueDate
    dueDate
    confirmationDeadline
    structuredCommunication
    invoiceNumber
    reference
    counterpartyIban
    leaseId
    unitId
    ownerId
    contractorId
    isOffLedgerReceivable
    awaitingPosting
    lines {
      postingId
      accountClass
      originalAmount
      openAmount
      disputed
      periodFrom
      periodTo
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCause = /* GraphQL */ `mutation DeleteCause($input: DeleteCauseInput!, $condition: ModelCauseConditionInput) {
  deleteCause(input: $input, condition: $condition) {
    id
    distinctValues {
      candidates {
        reason
        targetId
        __typename
      }
      display
      sectionIds
      value
      __typename
    }
    importRunId
    key
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCharge = /* GraphQL */ `mutation DeleteCharge($input: DeleteChargeInput!, $condition: ModelChargeConditionInput) {
  deleteCharge(input: $input, condition: $condition) {
    id
    status
    invoiceDate
    paymentDueDate
    archivedDate
    periodFrom
    periodTo
    totalAmount
    payableAmount
    source
    draftFromOcr
    accountingDocumentId
    paid
    settlement {
      bankCheck
      modeResolved
      modeSource
      parts {
        amount
        executeOn
        kind
        reference
        __typename
      }
      __typename
    }
    remittanceInformation
    note
    creatorEmail
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedContractors {
      id
      confidence
      __typename
    }
    recipientId
    recipient {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedRecipients {
      id
      confidence
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    documentId
    sectionId
    document {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readId
    clientId
    openChargeClientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteChargeEnvelope = /* GraphQL */ `mutation DeleteChargeEnvelope($input: DeleteChargeEnvelopeInput!, $condition: ModelChargeEnvelopeConditionInput) {
  deleteChargeEnvelope(input: $input, condition: $condition) {
    id
    channel
    decryptedS3Key
    duplicateOfEnvelopeId
    encryption
    fileHash
    fileId
    file {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    importRunId
    mimeType
    originalFileName
    pageQuality {
      alphaRatio
      averageFontSize
      dictionaryHits
      kind
      page
      __typename
    }
    pages
    readFailure
    receivedAt
    s3Key
    sections {
      items {
        id
        attachedToSectionId
        chargeId
        envelopeId
        excludedPages
        fallbackIdentityKey
        genre
        genreSubKind
        identityKey
        index
        issueDate
        issuerDateKey
        issuerNumberKey
        readFailure
        setAsideReason
        splitSource
        state
        valuesFromSectionId
        resolvedAliases
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    setAsideReason
    splitProposal {
      ambiguousBoundaries
      autoApplied
      cuts {
        afterPage
        reason
        rule
        score
        __typename
      }
      proposedAt
      source
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteChargeSection = /* GraphQL */ `mutation DeleteChargeSection($input: DeleteChargeSectionInput!, $condition: ModelChargeSectionConditionInput) {
  deleteChargeSection(input: $input, condition: $condition) {
    id
    attachedToSectionId
    chargeId
    checkpoints {
      allocate
      pay
      payReasons
      read
      resolve
      sort
      tenant
      __typename
    }
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    duplicateCandidates {
      reason
      sectionId
      __typename
    }
    envelopeId
    envelope {
      id
      channel
      decryptedS3Key
      duplicateOfEnvelopeId
      encryption
      fileHash
      fileId
      file {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      importRunId
      mimeType
      originalFileName
      pageQuality {
        alphaRatio
        averageFontSize
        dictionaryHits
        kind
        page
        __typename
      }
      pages
      readFailure
      receivedAt
      s3Key
      sections {
        nextToken
        startedAt
        __typename
      }
      setAsideReason
      splitProposal {
        ambiguousBoundaries
        autoApplied
        proposedAt
        source
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    excludedPages
    fallbackIdentityKey
    genre
    genreCandidates {
      genre
      reasons
      score
      __typename
    }
    genreSubKind
    identity {
      documentNumber
      grossTotal
      issuer
      source
      values {
        field
        value
        __typename
      }
      __typename
    }
    identityKey
    index
    issueDate
    issuerDateKey
    issuerNumberKey
    readFailure
    pageRange {
      from
      to
      __typename
    }
    renderings {
      attachedAt
      differences {
        field
        renderingValue
        survivorValue
        __typename
      }
      envelopeId
      reason
      sectionId
      source
      __typename
    }
    setAsideReason
    splitSource
    state
    valuesFromSectionId
    resolvedAliases
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteChargeStatement = /* GraphQL */ `mutation DeleteChargeStatement($input: DeleteChargeStatementInput!, $condition: ModelChargeStatementConditionInput) {
  deleteChargeStatement(input: $input, condition: $condition) {
    id
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCommunication = /* GraphQL */ `mutation DeleteCommunication($input: DeleteCommunicationInput!, $condition: ModelCommunicationConditionInput) {
  deleteCommunication(input: $input, condition: $condition) {
    id
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    blockedRecipients {
      recipient
      bounceType
      __typename
    }
    body
    buildingId
    channel
    communicationTemplateId
    concernedContactIds
    contactId
    contactIds
    deliveredAt
    draftProperties {
      entityType
      leaseIds
      unitIds
      buildingIds
      contactIds
      contactTypes
      sendInBcc
      cc
      bcc
      allowRecipientsToSeeEachOther
      unitTypeFilter
      __typename
    }
    errorCode
    expirationDate
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    leasePriceHistoryId
    leasePriceHistory {
      id
      previousTotalRentalPrice
      totalRentalPrice
      optimalTotalRentalPrice
      optimalTotalMonthlyCharges
      applicationDate
      status
      comment
      amountDetails {
        unitId
        indexationBaseIndex
        indexationNewIndex
        previousRentalPrice
        newRentalPrice
        rentalStatus
        monthlyChargesStatus
        optimalNewRentalPrice
        optimalNewMonthlyChargesPrice
        epb
        epbIssueDate
        oldestIndexForCorrectionFactorCalculation
        newestIndexForCorrectionFactorCalculation
        rentIndexedPriceAfterNewEpbReduction
        chargesIndexedPriceAfterNewEpbReduction
        correctionFactor
        reductionPercentage
        rentDifference
        rentReduction
        indexedRentAfterReduction
        chargesDifference
        chargesReduction
        indexedChargesAfterReduction
        previousYearIndexationNewIndex
        previousYearIndexedRent
        previousYearIndexedCharges
        __typename
      }
      type
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    letterTrackingCode
    letterTrackingProvider
    linkedCommunicationsIds
    nextRetryAt
    recipient
    recipientContactIdsInBcc
    recipientContactIdsInCc
    recipientInBcc
    recipientInCc
    scheduledAt
    sender
    sendRetryCount
    sentAt
    externalId
    externalStatus
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    snoozedDate
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    status
    subject
    supportingDocumentFileIds
    toSend
    hideLogo
    type
    _ttl
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCommunicationSettingsProfile = /* GraphQL */ `mutation DeleteCommunicationSettingsProfile($input: DeleteCommunicationSettingsProfileInput!, $condition: ModelCommunicationSettingsProfileConditionInput) {
  deleteCommunicationSettingsProfile(input: $input, condition: $condition) {
    id
    communicationsSettings {
      channels
      communicationType
      daysBeforeDueDate
      daysOverdue
      invoiceDaysAfterPeriodStart
      frequency {
        dateFrom
        periodInterval
        periodType
        __typename
      }
      sendingRule
      recipients
      recipientsInBcc
      recipientsInCopy
      displayOpenBalance
      __typename
    }
    defaultName
    isDefaultSetting
    referent
    tenantStatementView
    replacementId
    displayLogo
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCompanyUser = /* GraphQL */ `mutation DeleteCompanyUser($input: DeleteCompanyUserInput!, $condition: ModelCompanyUserConditionInput) {
  deleteCompanyUser(input: $input, condition: $condition) {
    id
    cognitoSub
    email
    firstName
    language
    lastName
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteContact = /* GraphQL */ `mutation DeleteContact($input: DeleteContactInput!, $condition: ModelContactConditionInput) {
  deleteContact(input: $input, condition: $condition) {
    id
    firstName
    lastName
    companyName
    commercialName
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    businessNumber
    types
    vat
    emails {
      address
      isPrimary
      label
      __typename
    }
    email
    birthDate
    birthPlace
    nationalRegister
    ipiNumber
    insuranceCompany
    insuranceContractNumber
    judicialDistrict
    civility
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    phoneNumbers {
      countryCode
      isPrimary
      label
      number
      __typename
    }
    language
    notes
    profileType
    jointOwners {
      contactId
      contactPerson
      __typename
    }
    hoaFunds {
      archivedAt
      id
      kind
      name
      __typename
    }
    paymentTermDays
    acpSyndicEras {
      syndicContactId
      validFrom
      validTo
      __typename
    }
    acpSyndicHistory {
      changedAt
      changedBy
      previousSyndicContactId
      previousValidFrom
      syndicContactId
      validFrom
      __typename
    }
    defaultBankAccountId
    supplierPaymentMode
    supplierPaymentModeExceptions {
      confirmedAt
      confirmedBy
      mode
      ownerId
      __typename
    }
    supplierPaymentModeHistory {
      changedAt
      changedBy
      mode
      ownerId
      previousMode
      __typename
    }
    agencyRateDisabled
    attachStatementSupportingDocuments
    status
    leases {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildings {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sendInvitation
    peppolProperties {
      isRegistered
      mustSend
      __typename
    }
    integrations {
      paymentProperties {
        accountId
        __typename
      }
      __typename
    }
    readers
    readId
    clientId
    sourceEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    foreignEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCounterpartyIdentity = /* GraphQL */ `mutation DeleteCounterpartyIdentity($input: DeleteCounterpartyIdentityInput!, $condition: ModelCounterpartyIdentityConditionInput) {
  deleteCounterpartyIdentity(input: $input, condition: $condition) {
    id
    keyType
    key
    isFullRemittance
    kind
    contactId
    source
    status
    evidenceCount
    firstSeenAt
    lastSeenAt
    lastCounterpartName
    lastDecisionId
    evidenceTransactionIds
    exclusionReason
    exclusionComment
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCounterpartyRole = /* GraphQL */ `mutation DeleteCounterpartyRole($input: DeleteCounterpartyRoleInput!, $condition: ModelCounterpartyRoleConditionInput) {
  deleteCounterpartyRole(input: $input, condition: $condition) {
    id
    subjectId
    targetType
    targetId
    source
    status
    evidenceCount
    lastSeenAt
    lastDecisionId
    evidenceTransactionIds
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCreditCost = /* GraphQL */ `mutation DeleteCreditCost($input: DeleteCreditCostInput!, $condition: ModelCreditCostConditionInput) {
  deleteCreditCost(input: $input, condition: $condition) {
    id
    clientId
    endDate
    numberOfCredits
    price
    startDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCreditUsageCost = /* GraphQL */ `mutation DeleteCreditUsageCost($input: DeleteCreditUsageCostInput!, $condition: ModelCreditUsageCostConditionInput) {
  deleteCreditUsageCost(input: $input, condition: $condition) {
    id
    endDate
    numberOfCreditsPerOperation
    startDate
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCustomField = /* GraphQL */ `mutation DeleteCustomField($input: DeleteCustomFieldInput!, $condition: ModelCustomFieldConditionInput) {
  deleteCustomField(input: $input, condition: $condition) {
    id
    fieldName
    fieldType
    foreignKey
    foreignTableName
    labels {
      language
      label
      __typename
    }
    customFieldProperties {
      isRequired
      isDefault
      defaultValue
      options {
        id
        __typename
      }
      __typename
    }
    order
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteCustomFieldDeep = /* GraphQL */ `mutation DeleteCustomFieldDeep($input: DeleteCustomFieldDeepInput!) {
  deleteCustomFieldDeep(input: $input) {
    status
    id
    __typename
  }
}
`;

export const deleteCustomSubscription = /* GraphQL */ `mutation DeleteCustomSubscription($input: DeleteCustomSubscriptionInput!, $condition: ModelCustomSubscriptionConditionInput) {
  deleteCustomSubscription(input: $input, condition: $condition) {
    id
    name
    value
    userId
    _ttl
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteDocumentCategory = /* GraphQL */ `mutation DeleteDocumentCategory($input: DeleteDocumentCategoryInput!, $condition: ModelDocumentCategoryConditionInput) {
  deleteDocumentCategory(input: $input, condition: $condition) {
    id
    entity
    fileCategory
    labels {
      language
      label
      __typename
    }
    parentId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteDocumentExtraction = /* GraphQL */ `mutation DeleteDocumentExtraction($input: DeleteDocumentExtractionInput!, $condition: ModelDocumentExtractionConditionInput) {
  deleteDocumentExtraction(input: $input, condition: $condition) {
    id
    corrected
    createdBy
    evidence {
      bbox
      field
      method
      page
      quote
      rawConfidence
      __typename
    }
    flags
    raw
    reasons
    score
    sectionId
    version
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteDocumentNumber = /* GraphQL */ `mutation DeleteDocumentNumber($input: DeleteDocumentNumberInput!, $condition: ModelDocumentNumberConditionInput) {
  deleteDocumentNumber(input: $input, condition: $condition) {
    id
    format
    lastUpdate
    incrementNumber
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteDraftInvoice = /* GraphQL */ `mutation DeleteDraftInvoice($input: DeleteDraftInvoiceInput!) {
  deleteDraftInvoice(input: $input) {
    status
    id
    __typename
  }
}
`;

export const deleteEntityAlias = /* GraphQL */ `mutation DeleteEntityAlias($input: DeleteEntityAliasInput!, $condition: ModelEntityAliasConditionInput) {
  deleteEntityAlias(input: $input, condition: $condition) {
    id
    confirmations
    confirmedBy
    key
    kind
    lastSeenAt
    lookupKey
    printedValue
    senderKeyType
    source
    targetId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteEntityById = /* GraphQL */ `mutation DeleteEntityById($input: DeleteEntityByIdInput!) {
  deleteEntityById(input: $input) {
    status
    id
    __typename
  }
}
`;

export const deleteEntityRelation = /* GraphQL */ `mutation DeleteEntityRelation($input: DeleteEntityRelationInput!, $condition: ModelEntityRelationConditionInput) {
  deleteEntityRelation(input: $input, condition: $condition) {
    id
    sourceId
    sourceTableName
    foreignId
    foreignTableName
    linkDescription
    linkProperties {
      contact {
        communicationSubscriptions
        __typename
      }
      __typename
    }
    clientId
    readers
    readId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteFeeArrears = /* GraphQL */ `mutation DeleteFeeArrears($input: DeleteFeeArrearsInput!, $condition: ModelFeeArrearsConditionInput) {
  deleteFeeArrears(input: $input, condition: $condition) {
    id
    accumulatedFrom {
      accumulatedAt
      amount
      paymentOrderId
      __typename
    }
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    openedAt
    originalAmount
    originPaymentOrderId
    originPaymentOrder {
      id
      amount
      anomalies
      anomalyAcknowledgedAt
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      confirmationDeadlineDate
      counterpartAccountNumber
      counterpartContactId
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      counterpartContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartRemittanceInformation
      createdBy
      dueDate
      executedDate
      executedAt
      executedBy
      executedTransactionId
      feeArrearsId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      fundAmounts {
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issuedAt
      issuedBy
      ownerContactId
      paymentBatchId
      paymentBatch {
        id
        bankAccountId
        clientStatusKey
        currentVersion
        number
        outdated
        sentAt
        sentBy
        status
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      reconciledAt
      recurringPaymentTemplateId
      reference
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      requestedAmount
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerContactId
    ownerContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    servedBy {
      amount
      paymentOrderId
      servedAt
      __typename
    }
    settledAt
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteFile = /* GraphQL */ `mutation DeleteFile($input: DeleteFileInput!, $condition: ModelFileConditionInput) {
  deleteFile(input: $input, condition: $condition) {
    id
    bucket
    category {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    categoryId
    foreignKey
    foreignTableName
    key
    mimeType
    region
    signaturePositions {
      top
      left
      page
      width
      height
      contactId
      __typename
    }
    size
    readers
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteFilterGroup = /* GraphQL */ `mutation DeleteFilterGroup($input: DeleteFilterGroupInput!, $condition: ModelFilterGroupConditionInput) {
  deleteFilterGroup(input: $input, condition: $condition) {
    id
    filterGroupDetails {
      filterEntityType
      filterEntityField
      filterEntityValues
      filterEntityNumber
      filterEntityDate
      __typename
    }
    name
    screenName
    type
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteImportRun = /* GraphQL */ `mutation DeleteImportRun($input: DeleteImportRunInput!, $condition: ModelImportRunConditionInput) {
  deleteImportRun(input: $input, condition: $condition) {
    id
    channel
    files
    finishedAt
    handled
    needsYou
    reviewEverything
    sections
    setAside
    startedAt
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteIntegration = /* GraphQL */ `mutation DeleteIntegration($input: DeleteIntegrationInput!, $condition: ModelIntegrationConditionInput) {
  deleteIntegration(input: $input, condition: $condition) {
    id
    configurations {
      name
      value
      __typename
    }
    error
    lastRun
    name
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteInternalComment = /* GraphQL */ `mutation DeleteInternalComment($input: DeleteInternalCommentInput!, $condition: ModelInternalCommentConditionInput) {
  deleteInternalComment(input: $input, condition: $condition) {
    id
    authorId
    content
    entityId
    entityType
    kind
    mentionedUserIds
    userIdsReactions {
      reactionType
      userId
      __typename
    }
    replyToId
    attachmentFileIds
    systemMessage
    systemMessageParameters
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteInvoice = /* GraphQL */ `mutation DeleteInvoice($input: DeleteInvoiceInput!, $condition: ModelInvoiceConditionInput) {
  deleteInvoice(input: $input, condition: $condition) {
    id
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    creditNote
    creditNoteLabel
    customValues {
      name
      value
      __typename
    }
    disputedPostingIds
    disputes {
      id
      scope
      postingId
      postingLabel
      reason
      comment
      disputedOn
      openedAt
      openedById
      openDecisionId
      liftedAt
      liftedById
      liftCause
      liftDecisionId
      __typename
    }
    disputeStatus
    dueDate
    invoiceDate
    invoiceNumber
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    paid
    integrations {
      paymentProperties {
        availableOn
        error
        feeAmount
        paymentIntentId
        paymentLinkAmount
        paymentLinkUrl
        payoutId
        statementDescriptor
        __typename
      }
      __typename
    }
    lastValidatedAt
    note
    postedDate
    purchaseOrderNumber
    receiptNumber
    reminderDates
    remittanceInformation
    reversedInvoiceId
    sentVersions {
      version
      sentAt
      invoiceNumber
      invoiceSenderId
      channels {
        channel
        status
        communicationId
        peppolId
        __typename
      }
      pdfFileId
      xmlFileId
      resetAt
      resetBy
      reason
      __typename
    }
    statementId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    type
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteInvoiceSetting = /* GraphQL */ `mutation DeleteInvoiceSetting($input: DeleteInvoiceSettingInput!, $condition: ModelInvoiceSettingConditionInput) {
  deleteInvoiceSetting(input: $input, condition: $condition) {
    id
    creditNoteFormat
    creditNoteLastUpdate
    creditNoteIncrementNumber
    invoiceFormat
    invoiceLastUpdate
    invoiceIncrementNumber
    paymentRequestFormat
    paymentRequestLastUpdate
    paymentRequestIncrementNumber
    receiptFormat
    receiptLastUpdate
    receiptIncrementNumber
    variousOperationFormat
    variousOperationLastUpdate
    variousOperationIncrementNumber
    customInvoicingConfiguration
    defaultVatRateId
    fiscalYearStart
    allPurposeInvoiceIssuer
    paymentBankAccountId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteLearningEvent = /* GraphQL */ `mutation DeleteLearningEvent($input: DeleteLearningEventInput!, $condition: ModelLearningEventConditionInput) {
  deleteLearningEvent(input: $input, condition: $condition) {
    id
    at
    field
    from
    kind
    layoutId
    senderId
    to
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteLease = /* GraphQL */ `mutation DeleteLease($input: DeleteLeaseInput!, $condition: ModelLeaseConditionInput) {
  deleteLease(input: $input, condition: $condition) {
    id
    advancedChargesInvoices {
      communicationSettingsProfileId
      invoiceSenderId
      lastDraftInvoiceDate
      lastInvoiceDate
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      remittanceInformation
      remittanceInformationType
      bankAccountId
      __typename
    }
    balance
    canBeExtended
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    endDate
    includeRealEstateInLeaseContract
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    inventoryOfFixturesExpert
    inventoryOfFixturesMethod
    inventoryOfFixturesType
    ipiNumber
    language
    lastDraftInvoiceDate
    lastIndexationProcessDate
    lastInvoiceDate
    legalCompetentAuthority
    name
    notes
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    paymentOption {
      enabled
      mandateStatus
      mandateActivatedAt
      customerId
      paymentMethodId
      qrType
      __typename
    }
    purchaseOrderNumber
    realEstateAgency
    realEstateTax
    remittanceInformation
    remittanceInformationType
    rentalGuaranty {
      amount
      blockedAmount
      releasedAmount
      type
      financialInstitution
      __typename
    }
    signatureDate
    startDate
    nextIndexationMonth
    nextIndexation
    status
    subletting
    technicCommunicationSettingsProfileId
    totalInitialRentalPrice
    totalRentalPrice
    type
    vatRateRentId
    vatRateRent {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    additionalClauses {
      items {
        id
        leaseId
        title
        body
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    attachStatementSupportingDocuments
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contacts {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leaseActionHistories {
      items {
        id
        action
        comment
        contactId
        leaseId
        communicationId
        signatureDocumentId
        status
        communicationChannel
        communicationSendDate
        communicationByPlatform
        endReason
        endReasonOwnUseRelation
        endReasonOwnUseName
        initiator
        totalAmount
        totalAmountLabel
        automatic
        hasLeaseTypeChanged
        jiraId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leasePriceHistories {
      items {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    signatureDocuments {
      items {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    variousOperations {
      items {
        id
        accountLabelIds
        amount
        billingMode
        contactId
        dueDateDaysAfterPeriodStart
        endDate
        indexationBaseAmount
        indexationBaseIndexDate
        indexationFrozen
        invoiceSenderId
        issueLeadDays
        label
        lastInvoiceDate
        leaseId
        operationType
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        periodNature
        reason
        separateInvoice
        startDate
        type
        unitId
        vatRateId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteLeaseActionHistory = /* GraphQL */ `mutation DeleteLeaseActionHistory($input: DeleteLeaseActionHistoryInput!, $condition: ModelLeaseActionHistoryConditionInput) {
  deleteLeaseActionHistory(input: $input, condition: $condition) {
    id
    action
    comment
    contactId
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    historyDetails {
      unitId
      newEndDate
      newSignatureDate
      newStartDate
      previousEndDate
      previousSignatureDate
      previousStartDate
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    communicationChannel
    communicationSendDate
    communicationByPlatform
    endReason
    endReasonOwnUseRelation
    endReasonOwnUseName
    initiator
    totalAmount
    totalAmountLabel
    automatic
    hasLeaseTypeChanged
    jiraId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteLeaseAdditionalClause = /* GraphQL */ `mutation DeleteLeaseAdditionalClause($input: DeleteLeaseAdditionalClauseInput!, $condition: ModelLeaseAdditionalClauseConditionInput) {
  deleteLeaseAdditionalClause(input: $input, condition: $condition) {
    id
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    title
    body
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteLeaseContact = /* GraphQL */ `mutation DeleteLeaseContact($input: DeleteLeaseContactInput!, $condition: ModelLeaseContactConditionInput) {
  deleteLeaseContact(input: $input, condition: $condition) {
    id
    leaseId
    contactId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactRole
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteLeasePriceHistory = /* GraphQL */ `mutation DeleteLeasePriceHistory($input: DeleteLeasePriceHistoryInput!, $condition: ModelLeasePriceHistoryConditionInput) {
  deleteLeasePriceHistory(input: $input, condition: $condition) {
    id
    previousTotalRentalPrice
    totalRentalPrice
    optimalTotalRentalPrice
    optimalTotalMonthlyCharges
    applicationDate
    status
    comment
    amountDetails {
      unitId
      indexationBaseIndex
      indexationNewIndex
      previousRentalPrice
      newRentalPrice
      rentalStatus
      monthlyChargesStatus
      optimalNewRentalPrice
      optimalNewMonthlyChargesPrice
      epb
      epbIssueDate
      oldestIndexForCorrectionFactorCalculation
      newestIndexForCorrectionFactorCalculation
      rentIndexedPriceAfterNewEpbReduction
      chargesIndexedPriceAfterNewEpbReduction
      correctionFactor
      chargesAmountsDetails {
        leaseVariousOperationId
        previousMonthlyAmount
        newMonthlyAmount
        indexationBaseIndex
        indexationBaseAmount
        indexationBaseIndexDate
        indexed
        __typename
      }
      reductionPercentage
      rentDifference
      rentReduction
      indexedRentAfterReduction
      chargesDifference
      chargesReduction
      indexedChargesAfterReduction
      previousYearIndexationNewIndex
      previousYearIndexedRent
      previousYearIndexedCharges
      __typename
    }
    type
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteLeaseVariousOperation = /* GraphQL */ `mutation DeleteLeaseVariousOperation($input: DeleteLeaseVariousOperationInput!, $condition: ModelLeaseVariousOperationConditionInput) {
  deleteLeaseVariousOperation(input: $input, condition: $condition) {
    id
    accountLabelIds
    amount
    billingMode
    contactId
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dueDateDaysAfterPeriodStart
    endDate
    indexationBaseAmount
    indexationBaseIndexDate
    indexationFrozen
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issueLeadDays
    label
    lastInvoiceDate
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    operationType
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    periodNature
    reason
    separateInvoice
    startDate
    type
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteMortgage = /* GraphQL */ `mutation DeleteMortgage($input: DeleteMortgageInput!, $condition: ModelMortgageConditionInput) {
  deleteMortgage(input: $input, condition: $condition) {
    id
    lender
    durationInYears
    rateType
    interestRate
    aprRate
    startDate
    amount
    monthlyPayment
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteNotification = /* GraphQL */ `mutation DeleteNotification($input: DeleteNotificationInput!, $condition: ModelNotificationConditionInput) {
  deleteNotification(input: $input, condition: $condition) {
    id
    createdBy
    type
    message
    popupDate
    expirationDate
    status
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicId
    technic {
      id
      type
      technicLibraryId
      technicLibrary {
        id
        communicationSettingsProfileId
        criticality
        isDefault
        issuingAuthority
        linkedCertificateIds
        locationScope
        status
        tagIds
        technicLibraryFormat
        type
        utilityTypes
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicName
      lastControlDate
      status
      contractNumber
      communicationSettingsProfileId
      maintenanceHistory {
        date
        contactId
        fileId
        id
        maintenanceSchemaId
        __typename
      }
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityDistributor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      utilityHistory {
        date
        reason
        reading
        secondReading
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      originalTechnicId
      replacedTechnicId
      certificateIds
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ticketId
    ticket {
      id
      assignedAt
      assignedTo {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedToId
      attachment {
        nextToken
        startedAt
        __typename
      }
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      closedAt
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      content
      conversations {
        nextToken
        startedAt
        __typename
      }
      emailMessageId
      emailReferences
      parentId
      plannedAt
      referenceCode
      sourceType
      status
      subject
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unread
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deletePaymentBatch = /* GraphQL */ `mutation DeletePaymentBatch($input: DeletePaymentBatchInput!, $condition: ModelPaymentBatchConditionInput) {
  deletePaymentBatch(input: $input, condition: $condition) {
    id
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientStatusKey
    currentVersion
    number
    outdated
    sentAt
    sentBy
    status
    versions {
      version
      exclusions {
        orderId
        reason
        __typename
      }
      fileKey
      fingerprint
      generatedAt
      generatedBy
      orderCount
      totalAmount
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deletePaymentOrder = /* GraphQL */ `mutation DeletePaymentOrder($input: DeletePaymentOrderInput!, $condition: ModelPaymentOrderConditionInput) {
  deletePaymentOrder(input: $input, condition: $condition) {
    id
    amount
    anomalies
    anomalyAcknowledgedAt
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    confirmationDeadlineDate
    counterpartAccountNumber
    counterpartContactId
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    counterpartContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartRemittanceInformation
    createdBy
    dueDate
    executedDate
    executedAt
    executedBy
    executedTransactionId
    feeArrearsId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    fundAmounts {
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issuedAt
    issuedBy
    ownerContactId
    paymentBatchId
    paymentBatch {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    reconciledAt
    recurringPaymentTemplateId
    reference
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    requestedAmount
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deletePosting = /* GraphQL */ `mutation DeletePosting($input: DeletePostingInput!, $condition: ModelPostingConditionInput) {
  deletePosting(input: $input, condition: $condition) {
    id
    class
    customLabel
    customValues {
      name
      value
      __typename
    }
    topClass
    type
    totalAmount
    periodFrom
    periodTo
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    transactionId
    transaction {
      id
      status
      snoozedUntil
      sequence
      statementDate
      operationDate
      customValues {
        name
        value
        __typename
      }
      remittanceInformationType
      remittanceInformation
      remittanceInformationRaw
      additionalInformation
      structuredCommunication
      bankTransactionCode
      proprietaryBankTransactionCode
      endToEndId
      mandateId
      creditorId
      purposeCode
      internalReference
      comment
      exclusionReason
      exclusionComment
      excludedAt
      excludedBy
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartDisplayName
      counterpartAccountNumber
      origin
      sourceChannel
      nativeTransactionId
      fingerprint
      linkedSourceChannels
      proposedLeaseId
      proposedUnitId
      proposedContractorId
      proposedOwnerId
      proposedMatch
      proposedAllocation
      classification
      classificationConfidence
      classificationReason
      recurrence
      links {
        amount
        linkId
        linkType
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationId
    leaseVariousOperation {
      id
      accountLabelIds
      amount
      billingMode
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dueDateDaysAfterPeriodStart
      endDate
      indexationBaseAmount
      indexationBaseIndexDate
      indexationFrozen
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issueLeadDays
      label
      lastInvoiceDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      operationType
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      periodNature
      reason
      separateInvoice
      startDate
      type
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    amountVatExcluded
    vatAmount
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    vatRateId
    vatRateValue
    foreignId
    foreignType
    invoicePostingId
    reconciledAt
    decisionId
    status
    chargeOwnerRepartition
    chargeRepartitionMetric
    chargeRepartitionValue
    chargeSplitNumber
    chargeType
    tenantShare {
      basis
      mode
      percentage
      __typename
    }
    provisional
    flaggedAt
    carriedForward
    tenantLandings {
      amount
      amountVatExcluded
      days
      leaseId
      periodFrom
      periodTo
      statementId
      vatAmount
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteReconciliationDecision = /* GraphQL */ `mutation DeleteReconciliationDecision($input: DeleteReconciliationDecisionInput!, $condition: ModelReconciliationDecisionConditionInput) {
  deleteReconciliationDecision(input: $input, condition: $condition) {
    id
    decisionId
    transactionId
    relatedTransactionIds
    kind
    status
    source
    trigger
    actorId
    outcome
    score
    reasonCodes
    flowType
    amount
    links {
      amount
      linkId
      linkType
      __typename
    }
    allocations {
      invoiceId
      postingId
      amount
      awaitingPosting
      __typename
    }
    exclusionReason
    comment
    snoozedUntil
    reversesDecisionId
    appliesDecisionId
    decidedAt
    backfilled
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteReconciliationSetting = /* GraphQL */ `mutation DeleteReconciliationSetting($input: DeleteReconciliationSettingInput!, $condition: ModelReconciliationSettingConditionInput) {
  deleteReconciliationSetting(input: $input, condition: $condition) {
    id
    type
    allocationMode
    leaseId
    ownerId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteRecurringPaymentTemplate = /* GraphQL */ `mutation DeleteRecurringPaymentTemplate($input: DeleteRecurringPaymentTemplateInput!, $condition: ModelRecurringPaymentTemplateConditionInput) {
  deleteRecurringPaymentTemplate(input: $input, condition: $condition) {
    id
    amountVersions {
      amounts {
        amount
        fundId
        __typename
      }
      createdAt
      createdBy
      effectiveFrom
      note
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryBankAccountId
    beneficiaryBankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryContactId
    beneficiaryContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdBy
    endDate
    endedAt
    endedBy
    firstPeriodFrom
    funds {
      accountLabelId
      fundId
      remittanceInformation
      __typename
    }
    generationDay
    lastGeneratedPeriodFrom
    name
    periodicity
    remittanceInformation
    splitTransfers
    status
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteRejectedOrders = /* GraphQL */ `mutation DeleteRejectedOrders($ids: [ID!]!) {
  deleteRejectedOrders(ids: $ids) {
    failures {
      id
      reason
      __typename
    }
    items {
      amount
      anomalies
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      beneficiaryBankAccountId
      beneficiaryIban
      beneficiaryIbanReplaced
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      beneficiaryIbanState
      beneficiaryName
      buildingId
      buildingName
      bulkApprovable
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      collectedFee
      confirmationDeadlineDate
      confirmationOverdue
      counterpartContactId
      counterpartRemittanceInformation
      createdBy
      dueDate
      eligibleRerouteAccountIds
      executedAt
      executedBy
      executedDate
      executedTransactionId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      id
      invoiceId
      issuedAt
      issuedBy
      paymentBatchId
      periodFrom
      recurringPaymentTemplateId
      recurringPendingCount
      recurringPendingRank
      reference
      reissuable
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      selectable
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      __typename
    }
    __typename
  }
}
`;

export const deleteReleaseNote = /* GraphQL */ `mutation DeleteReleaseNote($input: DeleteReleaseNoteInput!, $condition: ModelReleaseNoteConditionInput) {
  deleteReleaseNote(input: $input, condition: $condition) {
    id
    status
    publishedAt
    visibleToOwners
    contents {
      language
      title
      body
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteRepartitionKey = /* GraphQL */ `mutation DeleteRepartitionKey($input: DeleteRepartitionKeyInput!, $condition: ModelRepartitionKeyConditionInput) {
  deleteRepartitionKey(input: $input, condition: $condition) {
    id
    name
    type
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitRepartition {
      unitId
      value
      __typename
    }
    ownerRepartition
    tenantRepartition
    repartitionMetric
    technics
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteRepaymentStatement = /* GraphQL */ `mutation DeleteRepaymentStatement($input: DeleteRepaymentStatementInput!, $condition: ModelRepaymentStatementConditionInput) {
  deleteRepaymentStatement(input: $input, condition: $condition) {
    id
    accountOwnership
    delaysCleared
    expectedRent
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    rentsCollected
    repaymentStatementDetails {
      class
      customLabel
      invoiceId
      invoicePostingId
      originalTotalAmount
      periodFrom
      periodTo
      totalAmount
      transactionId
      type
      __typename
    }
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    totalReceivedInJointAccount
    totalExpectedInOwnerAccount
    unpaidRents
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteScheduleRule = /* GraphQL */ `mutation DeleteScheduleRule($input: DeleteScheduleRuleInput!, $condition: ModelScheduleRuleConditionInput) {
  deleteScheduleRule(input: $input, condition: $condition) {
    id
    conditions {
      attribute {
        attributeName
        __typename
      }
      comparisonMode
      operator
      values
      valueKind
      __typename
    }
    conditionsOperator
    foreignKey
    foreignTableName
    name {
      language
      label
      __typename
    }
    order
    outcome {
      interval {
        __typename
      }
      type
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteSenderRule = /* GraphQL */ `mutation DeleteSenderRule($input: DeleteSenderRuleInput!, $condition: ModelSenderRuleConditionInput) {
  deleteSenderRule(input: $input, condition: $condition) {
    id
    senderId
    sender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    kind
    scope {
      accountClass
      identifierKind
      identifierValue
      labelKey
      ownerId
      __typename
    }
    value {
      accountLabelId
      encodesInvoiceNumber
      paymentOnReceipt
      paymentTermDays
      privateExpense
      recoverabilityMode
      recoverabilityPercentage
      reminderFees
      roundingPrecision
      vatRateValues
      __typename
    }
    source
    confirmations
    updatedBy
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteSendingSource = /* GraphQL */ `mutation DeleteSendingSource($input: DeleteSendingSourceInput!, $condition: ModelSendingSourceConditionInput) {
  deleteSendingSource(input: $input, condition: $condition) {
    id
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dnsRecords {
      name
      type
      value
      __typename
    }
    emailAddress
    issuesEmail
    chargesEmail
    errorMessage
    name
    lastReminderDate
    status
    statusLastVerification
    verifiedType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteSetting = /* GraphQL */ `mutation DeleteSetting($input: DeleteSettingInput!, $condition: ModelSettingConditionInput) {
  deleteSetting(input: $input, condition: $condition) {
    id
    name
    value
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteSignatureDocument = /* GraphQL */ `mutation DeleteSignatureDocument($input: DeleteSignatureDocumentInput!, $condition: ModelSignatureDocumentConditionInput) {
  deleteSignatureDocument(input: $input, condition: $condition) {
    id
    additionalMessage
    automaticRemindersDisabled
    communicationBody
    expirationDate
    fileIds
    foreignKey
    foreignTableName
    sentAt
    signatureMethods
    signatureResults {
      openedDate
      signedDate
      signed
      signatureLink
      rejectReason
      lastSignInviteSentDate
      reminderDates
      trackingProvider
      trackingCode
      contactId
      __typename
    }
    status
    externalStatus
    type
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteStatement = /* GraphQL */ `mutation DeleteStatement($input: DeleteStatementInput!, $condition: ModelStatementConditionInput) {
  deleteStatement(input: $input, condition: $condition) {
    id
    amounts {
      name
      value
      __typename
    }
    attachSupportingDocuments
    chargeStatements {
      items {
        id
        chargeId
        statementId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    closingStatement
    periodFrom
    periodTo
    selectedPocketKeys
    source
    status
    sentDate
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    agencyRateStatements {
      items {
        id
        agencyRateId
        statementId
        totalAmountRateable
        totalFixedAmount
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    repaymentStatements {
      items {
        id
        accountOwnership
        delaysCleared
        expectedRent
        leaseId
        rentsCollected
        statementId
        totalReceivedInJointAccount
        totalExpectedInOwnerAccount
        unpaidRents
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    types
    viewType
    unitIds
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteStatementSetting = /* GraphQL */ `mutation DeleteStatementSetting($input: DeleteStatementSettingInput!, $condition: ModelStatementSettingConditionInput) {
  deleteStatementSetting(input: $input, condition: $condition) {
    id
    type
    custom
    disabled
    monthFrequency
    startMonth
    generationDay
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteSubscriptionUsageHistory = /* GraphQL */ `mutation DeleteSubscriptionUsageHistory($input: DeleteSubscriptionUsageHistoryInput!, $condition: ModelSubscriptionUsageHistoryConditionInput) {
  deleteSubscriptionUsageHistory(input: $input, condition: $condition) {
    id
    clientId
    creditUsageDetail {
      numberUsed
      creditsAccount
      creditOperationType
      __typename
    }
    customerCreatorId
    requestId
    applicationInvoiceId
    storageUsageDetail {
      numberUsed
      __typename
    }
    type
    unitsUsageDetail {
      unitsUsage {
        numberUsed
        unitId
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      proRataUnits {
        unitId
        numberOfDays
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteTag = /* GraphQL */ `mutation DeleteTag($input: DeleteTagInput!, $condition: ModelTagConditionInput) {
  deleteTag(input: $input, condition: $condition) {
    id
    color
    foreignTableName
    labels {
      language
      label
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteTechnic = /* GraphQL */ `mutation DeleteTechnic($input: DeleteTechnicInput!, $condition: ModelTechnicConditionInput) {
  deleteTechnic(input: $input, condition: $condition) {
    id
    type
    technicLibraryId
    technicLibrary {
      id
      certificateValidity {
        nonCompliant
        overlapping
        riskLevel
        __typename
      }
      communicationSettingsProfileId
      criticality
      customFields {
        nextToken
        startedAt
        __typename
      }
      descriptions {
        language
        label
        __typename
      }
      isDefault
      issuingAuthority
      linkedCertificateIds
      locationScope
      maintenanceSchemas {
        id
        criticality
        deadline
        maintenanceType
        notificationsEnabled
        notificationType
        proofType
        recurrence
        responsibleParty
        triggerType
        __typename
      }
      names {
        language
        label
        __typename
      }
      status
      tagIds
      technicLibraryFormat
      type
      utilityTypes
      validity {
        value
        validityUnit
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicName
    lastControlDate
    status
    contractNumber
    communicationSettingsProfileId
    maintenanceHistory {
      date
      contactId
      customValues {
        name
        value
        __typename
      }
      fileId
      id
      maintenanceSchemaId
      __typename
    }
    utilityType
    utilityEanCode
    utilityMeterNumber
    utilityDistributorId
    utilityDistributor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    utilityHistory {
      date
      reason
      reading
      secondReading
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    originalTechnicId
    replacedTechnicId
    certificateIds
    readers
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteTechnicLibrary = /* GraphQL */ `mutation DeleteTechnicLibrary($input: DeleteTechnicLibraryInput!, $condition: ModelTechnicLibraryConditionInput) {
  deleteTechnicLibrary(input: $input, condition: $condition) {
    id
    certificateValidity {
      gracePeriod {
        value
        validityUnit
        __typename
      }
      nonCompliant
      overlapping
      riskLevel
      __typename
    }
    communicationSettingsProfileId
    criticality
    customFields {
      items {
        id
        fieldName
        fieldType
        foreignKey
        foreignTableName
        order
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    descriptions {
      language
      label
      __typename
    }
    isDefault
    issuingAuthority
    linkedCertificateIds
    locationScope
    maintenanceSchemas {
      id
      criticality
      deadline
      descriptions {
        language
        label
        __typename
      }
      interval {
        value
        validityUnit
        __typename
      }
      maintenanceType
      names {
        language
        label
        __typename
      }
      notificationsEnabled
      notificationType
      proofType
      proofTypeName {
        language
        label
        __typename
      }
      recurrence
      responsibleParty
      triggerType
      __typename
    }
    names {
      language
      label
      __typename
    }
    status
    tagIds
    technicLibraryFormat
    type
    utilityTypes
    validity {
      value
      validityUnit
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteTemplate = /* GraphQL */ `mutation DeleteTemplate($input: DeleteTemplateInput!, $condition: ModelTemplateConditionInput) {
  deleteTemplate(input: $input, condition: $condition) {
    id
    language
    name
    subject
    subjectRawFormat
    body
    bodyRawFormat
    type
    subType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteTicket = /* GraphQL */ `mutation DeleteTicket($input: DeleteTicketInput!, $condition: ModelTicketConditionInput) {
  deleteTicket(input: $input, condition: $condition) {
    id
    assignedAt
    assignedTo {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedToId
    attachment {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    closedAt
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    content
    conversations {
      items {
        id
        assignedAt
        assignedToId
        buildingId
        closedAt
        contactId
        content
        emailMessageId
        emailReferences
        parentId
        plannedAt
        referenceCode
        sourceType
        status
        subject
        unitId
        unread
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    emailMessageId
    emailReferences
    parentId
    plannedAt
    referenceCode
    sourceType
    status
    subject
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unread
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteTransaction = /* GraphQL */ `mutation DeleteTransaction($input: DeleteTransactionInput!, $condition: ModelTransactionConditionInput) {
  deleteTransaction(input: $input, condition: $condition) {
    id
    status
    snoozedUntil
    sequence
    statementDate
    operationDate
    customValues {
      name
      value
      __typename
    }
    remittanceInformationType
    remittanceInformation
    remittanceInformationRaw
    additionalInformation
    structuredCommunication
    bankTransactionCode
    proprietaryBankTransactionCode
    endToEndId
    mandateId
    creditorId
    purposeCode
    internalReference
    comment
    exclusionReason
    exclusionComment
    excludedAt
    excludedBy
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartDisplayName
    counterpartAccountNumber
    origin
    sourceChannel
    nativeTransactionId
    fingerprint
    linkedSourceChannels
    proposedLeaseId
    proposedUnitId
    proposedContractorId
    proposedOwnerId
    proposedMatch
    proposedAllocation
    classification
    classificationConfidence
    classificationReason
    recurrence
    links {
      amount
      linkId
      linkType
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteTransactionRule = /* GraphQL */ `mutation DeleteTransactionRule($input: DeleteTransactionRuleInput!, $condition: ModelTransactionRuleConditionInput) {
  deleteTransactionRule(input: $input, condition: $condition) {
    id
    isFullRemittance
    remittanceInformation
    counterpartName
    counterpartAccountNumber
    usedFields
    exclude
    exclusionReason
    exclusionComment
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteUnit = /* GraphQL */ `mutation DeleteUnit($input: DeleteUnitInput!, $condition: ModelUnitConditionInput) {
  deleteUnit(input: $input, condition: $condition) {
    id
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    acquisitionValue
    advertisedMonthlyCharges
    advertisedRentalPrice
    cadastralIncome
    customValues {
      name
      value
      __typename
    }
    floor
    jointOwnershipId
    managementDate
    name
    notes
    predictedPrice
    propertyTax
    publishAddress
    surface
    type
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owners {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leases {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        unitId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    unitAdvertisementId
    unitInventories {
      items {
        id
        privateBatthRoom
        deletedAt
        kitchenEquipment
        roomName
        roomType
        surface
        showSurface
        unitId
        inside
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteUnitEvent = /* GraphQL */ `mutation DeleteUnitEvent($input: DeleteUnitEventInput!, $condition: ModelUnitEventConditionInput) {
  deleteUnitEvent(input: $input, condition: $condition) {
    id
    unitId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteUnitInventory = /* GraphQL */ `mutation DeleteUnitInventory($input: DeleteUnitInventoryInput!, $condition: ModelUnitInventoryConditionInput) {
  deleteUnitInventory(input: $input, condition: $condition) {
    id
    privateBatthRoom
    deletedAt
    kitchenEquipment
    roomName
    roomType
    surface
    showSurface
    unitId
    inside
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteUnitLease = /* GraphQL */ `mutation DeleteUnitLease($input: DeleteUnitLeaseInput!, $condition: ModelUnitLeaseConditionInput) {
  deleteUnitLease(input: $input, condition: $condition) {
    id
    allowChargeAdjustment
    authorizeProfessionalActivity
    chargesIndexation
    endDate
    furnishedRental
    furnishedRentalInsuranceByTenant
    furnishedRentalRentalPricePercentage
    initialRentalPrice
    indexation
    advancedIndexation
    indexType
    baseYear
    baseIndexType
    baseIndexDate
    nextIndexationMonth
    nextIndexation
    leaseId
    mainUnit
    rentalPrice
    signatureDate
    startDate
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteUnitOwner = /* GraphQL */ `mutation DeleteUnitOwner($input: DeleteUnitOwnerInput!, $condition: ModelUnitOwnerConditionInput) {
  deleteUnitOwner(input: $input, condition: $condition) {
    id
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    periodFrom
    periodTo
    stake
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteValuation = /* GraphQL */ `mutation DeleteValuation($input: DeleteValuationInput!, $condition: ModelValuationConditionInput) {
  deleteValuation(input: $input, condition: $condition) {
    id
    sourceType
    valorization
    date
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteVariousOperation = /* GraphQL */ `mutation DeleteVariousOperation($input: DeleteVariousOperationInput!, $condition: ModelVariousOperationConditionInput) {
  deleteVariousOperation(input: $input, condition: $condition) {
    id
    amount
    labels {
      language
      label
      __typename
    }
    numberOfMonths
    operationType
    paymentFrequency
    type
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const deleteVatRate = /* GraphQL */ `mutation DeleteVatRate($input: DeleteVatRateInput!, $condition: ModelVatRateConditionInput) {
  deleteVatRate(input: $input, condition: $condition) {
    id
    country
    label
    value
    vatKind
    customValues {
      name
      value
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const disableClientAccount = /* GraphQL */ `mutation DisableClientAccount($input: DisableClientAccountInput!) {
  disableClientAccount(input: $input) {
    deletionTime
    errorMessage
    success
    __typename
  }
}
`;

export const downloadCommunications = /* GraphQL */ `mutation DownloadCommunications($input: DownloadCommunicationsInput!) {
  downloadCommunications(input: $input) {
    key
    success
    zipUrl
    __typename
  }
}
`;

export const duplicateCompanyInvoice = /* GraphQL */ `mutation DuplicateCompanyInvoice($input: DuplicateCompanyInvoiceInput!) {
  duplicateCompanyInvoice(input: $input) {
    status
    id
    __typename
  }
}
`;

export const editPrivateAccountTransactionAmount = /* GraphQL */ `mutation EditPrivateAccountTransactionAmount($input: EditPrivateAccountTransactionAmountInput!) {
  editPrivateAccountTransactionAmount(input: $input) {
    status
    id
    __typename
  }
}
`;

export const endRecurringPayment = /* GraphQL */ `mutation EndRecurringPayment($input: EndRecurringPaymentInput!) {
  endRecurringPayment(input: $input) {
    failureReason
    recurringPayment {
      amountVersions {
        createdAt
        createdBy
        effectiveFrom
        note
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      bankAccountId
      beneficiaryBankAccountId
      beneficiaryContactId
      currentAmountVersion {
        createdAt
        createdBy
        effectiveFrom
        note
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      endDate
      firstPeriodFrom
      funds {
        accountLabelId
        fundId
        remittanceInformation
        __typename
      }
      generatedThisMonthAmount
      generatedThisMonthOrderCount
      generationDay
      id
      name
      nextDueDate
      oldestPendingPeriodFrom
      pendingAmount
      pendingPeriodCount
      periodicity
      remittanceInformation
      splitTransfers
      status
      underfunded
      unitId
      __typename
    }
    __typename
  }
}
`;

export const generateDocument = /* GraphQL */ `mutation GenerateDocument($input: GenerateDocumentInput!) {
  generateDocument(input: $input) {
    status
    id
    __typename
  }
}
`;

export const generateReport = /* GraphQL */ `mutation GenerateReport($input: GenerateReportInput!) {
  generateReport(input: $input) {
    errorCode
    status
    __typename
  }
}
`;

export const generateSepaBatchFile = /* GraphQL */ `mutation GenerateSepaBatchFile($input: SepaBatchIdInput!) {
  generateSepaBatchFile(input: $input) {
    batch {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    failures {
      orderId
      reason
      __typename
    }
    fileKey
    version
    __typename
  }
}
`;

export const getDownloadZipFileUrl = /* GraphQL */ `mutation GetDownloadZipFileUrl($input: DownloadFoldersInput!) {
  getDownloadZipFileUrl(input: $input) {
    success
    message
    __typename
  }
}
`;

export const getExactOnlineClientId = /* GraphQL */ `mutation GetExactOnlineClientId($input: GetExactOnlineClientIdInput!) {
  getExactOnlineClientId(input: $input)
}
`;

export const getExactOnlineEntities = /* GraphQL */ `mutation GetExactOnlineEntities($input: GetExactOnlineEntitiesInput!) {
  getExactOnlineEntities(input: $input)
}
`;

export const handleAdvertisementPublishing = /* GraphQL */ `mutation HandleAdvertisementPublishing($input: AdvertisementPublishingInput!) {
  handleAdvertisementPublishing(input: $input) {
    id
    statusList {
      publishingPlatform
      status
      successCode
      __typename
    }
    errorMessage
    __typename
  }
}
`;

export const handleUserRightsChange = /* GraphQL */ `mutation HandleUserRightsChange($input: UserRightsChangeInput!) {
  handleUserRightsChange(input: $input) {
    status
    id
    __typename
  }
}
`;

export const inviteContactToClientAccount = /* GraphQL */ `mutation InviteContactToClientAccount($input: InviteContactToClientAccountInput!) {
  inviteContactToClientAccount(input: $input) {
    status
    id
    __typename
  }
}
`;

export const inviteUserToClientAccount = /* GraphQL */ `mutation InviteUserToClientAccount($input: InviteUserToClientAccountInput!) {
  inviteUserToClientAccount(input: $input) {
    status
    id
    __typename
  }
}
`;

export const isEmailAlreadyTaken = /* GraphQL */ `mutation IsEmailAlreadyTaken($input: IsEmailAlreadyTakenInput!) {
  isEmailAlreadyTaken(input: $input) {
    success
    message
    __typename
  }
}
`;

export const issueOrders = /* GraphQL */ `mutation IssueOrders($ids: [ID!]!, $channel: PaymentInitiationChannel!, $confirmationDeadlineDate: AWSDate) {
  issueOrders(ids: $ids, channel: $channel, confirmationDeadlineDate: $confirmationDeadlineDate) {
    failures {
      id
      reason
      __typename
    }
    items {
      amount
      anomalies
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      beneficiaryBankAccountId
      beneficiaryIban
      beneficiaryIbanReplaced
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      beneficiaryIbanState
      beneficiaryName
      buildingId
      buildingName
      bulkApprovable
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      collectedFee
      confirmationDeadlineDate
      confirmationOverdue
      counterpartContactId
      counterpartRemittanceInformation
      createdBy
      dueDate
      eligibleRerouteAccountIds
      executedAt
      executedBy
      executedDate
      executedTransactionId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      id
      invoiceId
      issuedAt
      issuedBy
      paymentBatchId
      periodFrom
      recurringPaymentTemplateId
      recurringPendingCount
      recurringPendingRank
      reference
      reissuable
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      selectable
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      __typename
    }
    __typename
  }
}
`;

export const liftInvoiceDispute = /* GraphQL */ `mutation LiftInvoiceDispute($input: LiftInvoiceDisputeInput!) {
  liftInvoiceDispute(input: $input) {
    status
    id
    __typename
  }
}
`;

export const markSepaBatchSent = /* GraphQL */ `mutation MarkSepaBatchSent($input: SepaBatchIdInput!) {
  markSepaBatchSent(input: $input) {
    id
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientStatusKey
    currentVersion
    number
    outdated
    sentAt
    sentBy
    status
    versions {
      version
      exclusions {
        orderId
        reason
        __typename
      }
      fileKey
      fingerprint
      generatedAt
      generatedBy
      orderCount
      totalAmount
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const openInvoiceDispute = /* GraphQL */ `mutation OpenInvoiceDispute($input: OpenInvoiceDisputeInput!) {
  openInvoiceDispute(input: $input) {
    status
    id
    __typename
  }
}
`;

export const processOcr = /* GraphQL */ `mutation ProcessOcr($input: ProcessOcrInput!) {
  processOcr(input: $input) {
    status
    id
    __typename
  }
}
`;

export const publishReleaseNote = /* GraphQL */ `mutation PublishReleaseNote($input: PublishReleaseNoteInput!) {
  publishReleaseNote(input: $input) {
    id
    status
    publishedAt
    visibleToOwners
    contents {
      language
      title
      body
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const recalculateStatement = /* GraphQL */ `mutation RecalculateStatement($input: RecalculateStatementInput!) {
  recalculateStatement(input: $input) {
    status
    id
    __typename
  }
}
`;

export const reconcileInvoicesWithCreditNotes = /* GraphQL */ `mutation ReconcileInvoicesWithCreditNotes($input: ReconcileInvoicesWithCreditNotesInput!) {
  reconcileInvoicesWithCreditNotes(input: $input) {
    status
    id
    __typename
  }
}
`;

export const reconcilePendingBalanceWithInvoices = /* GraphQL */ `mutation ReconcilePendingBalanceWithInvoices($input: ReconcilePendingBalanceWithInvoicesInput!) {
  reconcilePendingBalanceWithInvoices(input: $input) {
    status
    id
    __typename
  }
}
`;

export const reconcileTransactionWithInvoices = /* GraphQL */ `mutation ReconcileTransactionWithInvoices($input: ReconcileTransactionWithInvoicesInput!) {
  reconcileTransactionWithInvoices(input: $input) {
    status
    id
    __typename
  }
}
`;

export const reconcileTransactionWithTransaction = /* GraphQL */ `mutation ReconcileTransactionWithTransaction($input: ReconcileTransactionWithTransactionInput!) {
  reconcileTransactionWithTransaction(input: $input) {
    status
    id
    __typename
  }
}
`;

export const recordEarlyDeparture = /* GraphQL */ `mutation RecordEarlyDeparture($input: RecordEarlyDepartureInput!) {
  recordEarlyDeparture(input: $input) {
    status
    id
    __typename
  }
}
`;

export const refreshBeneficiaryIban = /* GraphQL */ `mutation RefreshBeneficiaryIban($id: ID!) {
  refreshBeneficiaryIban(id: $id) {
    amount
    anomalies
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryIban
    beneficiaryIbanReplaced
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    beneficiaryIbanState
    beneficiaryName
    buildingId
    buildingName
    bulkApprovable
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    collectedFee
    confirmationDeadlineDate
    confirmationOverdue
    counterpartContactId
    counterpartRemittanceInformation
    createdBy
    dueDate
    eligibleRerouteAccountIds
    executedAt
    executedBy
    executedDate
    executedTransactionId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    id
    invoiceId
    issuedAt
    issuedBy
    paymentBatchId
    periodFrom
    recurringPaymentTemplateId
    recurringPendingCount
    recurringPendingRank
    reference
    reissuable
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    selectable
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    __typename
  }
}
`;

export const refreshClientOrganizationStats = /* GraphQL */ `mutation RefreshClientOrganizationStats {
  refreshClientOrganizationStats {
    id
    name
    accountType
    contactId
    createdAt
    pendingDeletion
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      email
      language
      vat
      businessNumber
      addressId
      __typename
    }
    stats {
      activeMembers
      computedAt
      membersByStatus {
        count
        status
        __typename
      }
      rootUserName
      units
      unitsByType {
        count
        type
        __typename
      }
      __typename
    }
    __typename
  }
}
`;

export const reissueOrder = /* GraphQL */ `mutation ReissueOrder($id: ID!) {
  reissueOrder(id: $id) {
    amount
    anomalies
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryIban
    beneficiaryIbanReplaced
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    beneficiaryIbanState
    beneficiaryName
    buildingId
    buildingName
    bulkApprovable
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    collectedFee
    confirmationDeadlineDate
    confirmationOverdue
    counterpartContactId
    counterpartRemittanceInformation
    createdBy
    dueDate
    eligibleRerouteAccountIds
    executedAt
    executedBy
    executedDate
    executedTransactionId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    id
    invoiceId
    issuedAt
    issuedBy
    paymentBatchId
    periodFrom
    recurringPaymentTemplateId
    recurringPendingCount
    recurringPendingRank
    reference
    reissuable
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    selectable
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    __typename
  }
}
`;

export const rejectDocument = /* GraphQL */ `mutation RejectDocument($input: RejectDocumentInput!) {
  rejectDocument(input: $input) {
    status
    id
    __typename
  }
}
`;

export const rejectOrder = /* GraphQL */ `mutation RejectOrder($id: ID!, $reason: String!, $flaggedField: PaymentOrderFixField) {
  rejectOrder(id: $id, reason: $reason, flaggedField: $flaggedField) {
    amount
    anomalies
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryIban
    beneficiaryIbanReplaced
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    beneficiaryIbanState
    beneficiaryName
    buildingId
    buildingName
    bulkApprovable
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    collectedFee
    confirmationDeadlineDate
    confirmationOverdue
    counterpartContactId
    counterpartRemittanceInformation
    createdBy
    dueDate
    eligibleRerouteAccountIds
    executedAt
    executedBy
    executedDate
    executedTransactionId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    id
    invoiceId
    issuedAt
    issuedBy
    paymentBatchId
    periodFrom
    recurringPaymentTemplateId
    recurringPendingCount
    recurringPendingRank
    reference
    reissuable
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    selectable
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    __typename
  }
}
`;

export const remindSignatureDocument = /* GraphQL */ `mutation RemindSignatureDocument($input: RemindSignatureDocumentInput!) {
  remindSignatureDocument(input: $input) {
    status
    id
    __typename
  }
}
`;

export const removeAuthUserTeam = /* GraphQL */ `mutation RemoveAuthUserTeam($input: RemoveAuthUserTeamInput!) {
  removeAuthUserTeam(input: $input) {
    clientId
    dynamoUserId
    id
    teamId
    userId
    __typename
  }
}
`;

export const removeEntityAlias = /* GraphQL */ `mutation RemoveEntityAlias($id: ID!) {
  removeEntityAlias(id: $id)
}
`;

export const removeOrdersFromSepaBatch = /* GraphQL */ `mutation RemoveOrdersFromSepaBatch($input: SepaBatchOrdersInput!) {
  removeOrdersFromSepaBatch(input: $input) {
    batches {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    failures {
      orderId
      reason
      __typename
    }
    __typename
  }
}
`;

export const removeSenderRule = /* GraphQL */ `mutation RemoveSenderRule($id: ID!) {
  removeSenderRule(id: $id)
}
`;

export const rerouteOrder = /* GraphQL */ `mutation RerouteOrder($id: ID!, $bankAccountId: ID!) {
  rerouteOrder(id: $id, bankAccountId: $bankAccountId) {
    amount
    anomalies
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryIban
    beneficiaryIbanReplaced
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    beneficiaryIbanState
    beneficiaryName
    buildingId
    buildingName
    bulkApprovable
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    collectedFee
    confirmationDeadlineDate
    confirmationOverdue
    counterpartContactId
    counterpartRemittanceInformation
    createdBy
    dueDate
    eligibleRerouteAccountIds
    executedAt
    executedBy
    executedDate
    executedTransactionId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    id
    invoiceId
    issuedAt
    issuedBy
    paymentBatchId
    periodFrom
    recurringPaymentTemplateId
    recurringPendingCount
    recurringPendingRank
    reference
    reissuable
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    selectable
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    __typename
  }
}
`;

export const resendApplicationInvoiceToPeppol = /* GraphQL */ `mutation ResendApplicationInvoiceToPeppol($input: ResendApplicationInvoiceToPeppolInput!) {
  resendApplicationInvoiceToPeppol(input: $input) {
    applicationInvoiceId
    message
    success
    __typename
  }
}
`;

export const resendInvoiceToPeppol = /* GraphQL */ `mutation ResendInvoiceToPeppol($input: ResendInvoiceToPeppolInput!) {
  resendInvoiceToPeppol(input: $input) {
    success
    message
    __typename
  }
}
`;

export const resetAuthUserPreferences = /* GraphQL */ `mutation ResetAuthUserPreferences($input: ResetAuthUserPreferencesInput) {
  resetAuthUserPreferences(input: $input) {
    status
    id
    __typename
  }
}
`;

export const resetInvoiceToDraft = /* GraphQL */ `mutation ResetInvoiceToDraft($input: ResetInvoiceToDraftInput!) {
  resetInvoiceToDraft(input: $input) {
    status
    id
    __typename
  }
}
`;

export const resetPaymentRunPriority = /* GraphQL */ `mutation ResetPaymentRunPriority($accountId: ID!, $scope: ScopeInput) {
  resetPaymentRunPriority(accountId: $accountId, scope: $scope) {
    accountId
    available
    channel
    endBalance
    fees
    heldCount
    heldTotal
    isThirdParty
    keepMin
    manualPriority
    obligations
    ownerContactIds
    paidNow
    payoutReduced
    payoutTotal
    reconciliationCovered
    releasable
    reserved
    rows {
      amount
      confirmationOverdue
      counterpartContactId
      counterpartName
      dueDate
      feeArrearsId
      held
      id
      kind
      orderStatus
      orderType
      ownerContactId
      pay
      paymentBatchId
      paymentOrderId
      priority
      recurringFundId
      recurringPaymentTemplateId
      recurringPendingRank
      recurringPeriodFrom
      reference
      status
      tier
      __typename
    }
    shortfall
    total
    verdict
    __typename
  }
}
`;

export const resolveCause = /* GraphQL */ `mutation ResolveCause($input: ResolveCauseInput!) {
  resolveCause(input: $input) {
    createdSupplierPaymentHeld
    remainingValues
    resolvedSectionIds
    __typename
  }
}
`;

export const resolveSmartSuggestion = /* GraphQL */ `mutation ResolveSmartSuggestion($id: ID!, $accept: Boolean!, $declinedReason: String) {
  resolveSmartSuggestion(id: $id, accept: $accept, declinedReason: $declinedReason) {
    amount
    anomalies
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryIban
    beneficiaryIbanReplaced
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    beneficiaryIbanState
    beneficiaryName
    buildingId
    buildingName
    bulkApprovable
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    collectedFee
    confirmationDeadlineDate
    confirmationOverdue
    counterpartContactId
    counterpartRemittanceInformation
    createdBy
    dueDate
    eligibleRerouteAccountIds
    executedAt
    executedBy
    executedDate
    executedTransactionId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    id
    invoiceId
    issuedAt
    issuedBy
    paymentBatchId
    periodFrom
    recurringPaymentTemplateId
    recurringPendingCount
    recurringPendingRank
    reference
    reissuable
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    selectable
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    __typename
  }
}
`;

export const resubmitOrder = /* GraphQL */ `mutation ResubmitOrder($id: ID!, $fix: PaymentOrderFixInput!) {
  resubmitOrder(id: $id, fix: $fix) {
    amount
    anomalies
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryIban
    beneficiaryIbanReplaced
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    beneficiaryIbanState
    beneficiaryName
    buildingId
    buildingName
    bulkApprovable
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    collectedFee
    confirmationDeadlineDate
    confirmationOverdue
    counterpartContactId
    counterpartRemittanceInformation
    createdBy
    dueDate
    eligibleRerouteAccountIds
    executedAt
    executedBy
    executedDate
    executedTransactionId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    id
    invoiceId
    issuedAt
    issuedBy
    paymentBatchId
    periodFrom
    recurringPaymentTemplateId
    recurringPendingCount
    recurringPendingRank
    reference
    reissuable
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    selectable
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    __typename
  }
}
`;

export const retargetSenderAlias = /* GraphQL */ `mutation RetargetSenderAlias($input: RetargetSenderAliasInput!) {
  retargetSenderAlias(input: $input) {
    id
    confirmations
    confirmedBy
    key
    kind
    lastSeenAt
    lookupKey
    printedValue
    senderKeyType
    source
    targetId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const reverseCompanyInvoice = /* GraphQL */ `mutation ReverseCompanyInvoice($input: ReverseCompanyInvoiceInput!) {
  reverseCompanyInvoice(input: $input) {
    status
    id
    __typename
  }
}
`;

export const reverseTransaction = /* GraphQL */ `mutation ReverseTransaction($input: ReverseTransactionInput!) {
  reverseTransaction(input: $input) {
    status
    id
    __typename
  }
}
`;

export const revokePontoIntegration = /* GraphQL */ `mutation RevokePontoIntegration($input: RevokePontoIntegrationInput!) {
  revokePontoIntegration(input: $input) {
    status
    id
    __typename
  }
}
`;

export const saveExactOnlineEntitiesMatching = /* GraphQL */ `mutation SaveExactOnlineEntitiesMatching($input: SaveExactOnlineEntitiesMatchingInput!) {
  saveExactOnlineEntitiesMatching(input: $input)
}
`;

export const saveSenderRule = /* GraphQL */ `mutation SaveSenderRule($input: SaveSenderRuleInput!) {
  saveSenderRule(input: $input) {
    id
    senderId
    sender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    kind
    scope {
      accountClass
      identifierKind
      identifierValue
      labelKey
      ownerId
      __typename
    }
    value {
      accountLabelId
      encodesInvoiceNumber
      paymentOnReceipt
      paymentTermDays
      privateExpense
      recoverabilityMode
      recoverabilityPercentage
      reminderFees
      roundingPrecision
      vatRateValues
      __typename
    }
    source
    confirmations
    updatedBy
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const sendInvoice = /* GraphQL */ `mutation SendInvoice($input: SendInvoiceInput!) {
  sendInvoice(input: $input) {
    status
    id
    __typename
  }
}
`;

export const sendInvoiceToPeppol = /* GraphQL */ `mutation SendInvoiceToPeppol($input: SendInvoiceToPeppolInput!) {
  sendInvoiceToPeppol(input: $input) {
    success
    message
    __typename
  }
}
`;

export const setAuthMemberRole = /* GraphQL */ `mutation SetAuthMemberRole($input: SetAuthMemberRoleInput!) {
  setAuthMemberRole(input: $input) {
    userId
    userRoleId
    __typename
  }
}
`;

export const setAuthMemberStatus = /* GraphQL */ `mutation SetAuthMemberStatus($input: SetAuthMemberStatusInput!) {
  setAuthMemberStatus(input: $input) {
    status
    userId
    __typename
  }
}
`;

export const setAuthUserPreference = /* GraphQL */ `mutation SetAuthUserPreference($input: SetAuthUserPreferenceInput!) {
  setAuthUserPreference(input: $input) {
    name
    value
    __typename
  }
}
`;

export const setDefaultBankAccount = /* GraphQL */ `mutation SetDefaultBankAccount($input: SetDefaultBankAccountInput!) {
  setDefaultBankAccount(input: $input) {
    id
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactIds
    buildingIds
    number
    bicNumber
    bankName
    holderName
    label
    customValues {
      name
      value
      __typename
    }
    disabled
    integrations
    matchingRule
    initiationChannel
    retainedBalanceThreshold
    balance
    balanceDate
    type
    ibanStatus
    ibanVerifiedAt
    ibanVerifiedBy
    ibanVerifiedNumber
    ibanVerifiedSourceDocumentId
    ibanRole
    ibanRoleLabel
    isDefault
    note
    paymentRunPriorityOrderIds
    paymentRunPriorityUpdatedAt
    paymentRunPriorityUpdatedBy
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const setPaymentRunPriority = /* GraphQL */ `mutation SetPaymentRunPriority($accountId: ID!, $orderIds: [ID!]!, $scope: ScopeInput) {
  setPaymentRunPriority(accountId: $accountId, orderIds: $orderIds, scope: $scope) {
    accountId
    available
    channel
    endBalance
    fees
    heldCount
    heldTotal
    isThirdParty
    keepMin
    manualPriority
    obligations
    ownerContactIds
    paidNow
    payoutReduced
    payoutTotal
    reconciliationCovered
    releasable
    reserved
    rows {
      amount
      confirmationOverdue
      counterpartContactId
      counterpartName
      dueDate
      feeArrearsId
      held
      id
      kind
      orderStatus
      orderType
      ownerContactId
      pay
      paymentBatchId
      paymentOrderId
      priority
      recurringFundId
      recurringPaymentTemplateId
      recurringPendingRank
      recurringPeriodFrom
      reference
      status
      tier
      __typename
    }
    shortfall
    total
    verdict
    __typename
  }
}
`;

export const snoozeTransaction = /* GraphQL */ `mutation SnoozeTransaction($input: SnoozeTransactionInput!) {
  snoozeTransaction(input: $input) {
    status
    id
    __typename
  }
}
`;

export const submitCommunicationDialog = /* GraphQL */ `mutation SubmitCommunicationDialog($input: SubmitCommunicationDialogInput!) {
  submitCommunicationDialog(input: $input) {
    communicationIds
    createdCount
    success
    __typename
  }
}
`;

export const submitOrdersForApproval = /* GraphQL */ `mutation SubmitOrdersForApproval($ids: [ID!]!) {
  submitOrdersForApproval(ids: $ids) {
    failures {
      id
      reason
      __typename
    }
    items {
      amount
      anomalies
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      beneficiaryBankAccountId
      beneficiaryIban
      beneficiaryIbanReplaced
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      beneficiaryIbanState
      beneficiaryName
      buildingId
      buildingName
      bulkApprovable
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      collectedFee
      confirmationDeadlineDate
      confirmationOverdue
      counterpartContactId
      counterpartRemittanceInformation
      createdBy
      dueDate
      eligibleRerouteAccountIds
      executedAt
      executedBy
      executedDate
      executedTransactionId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      id
      invoiceId
      issuedAt
      issuedBy
      paymentBatchId
      periodFrom
      recurringPaymentTemplateId
      recurringPendingCount
      recurringPendingRank
      reference
      reissuable
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      selectable
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      __typename
    }
    __typename
  }
}
`;

export const synchronizeExactOnline = /* GraphQL */ `mutation SynchronizeExactOnline($input: SynchronizeExactOnlineInput!) {
  synchronizeExactOnline(input: $input)
}
`;

export const technicBulkRename = /* GraphQL */ `mutation TechnicBulkRename($input: TechnicBulkRenameInput!) {
  technicBulkRename(input: $input) {
    status
    id
    __typename
  }
}
`;

export const toggleInternalCommentReaction = /* GraphQL */ `mutation ToggleInternalCommentReaction($input: ToggleInternalCommentReactionInput!) {
  toggleInternalCommentReaction(input: $input) {
    status
    id
    __typename
  }
}
`;

export const translateText = /* GraphQL */ `mutation TranslateText($input: TranslateTextInput!) {
  translateText(input: $input) {
    success
    result
    __typename
  }
}
`;

export const undoImportRun = /* GraphQL */ `mutation UndoImportRun($input: UndoImportRunInput!) {
  undoImportRun(input: $input) {
    refused {
      reasons
      sectionId
      __typename
    }
    revertedSectionIds
    __typename
  }
}
`;

export const unlockChargeEnvelope = /* GraphQL */ `mutation UnlockChargeEnvelope($input: UnlockChargeEnvelopeInput!) {
  unlockChargeEnvelope(input: $input) {
    outcome
    __typename
  }
}
`;

export const unreconcileTransactionOrInvoices = /* GraphQL */ `mutation UnreconcileTransactionOrInvoices($input: UnreconcileTransactionOrInvoicesInput!) {
  unreconcileTransactionOrInvoices(input: $input) {
    status
    id
    __typename
  }
}
`;

export const updateAccountLabel = /* GraphQL */ `mutation UpdateAccountLabel($input: UpdateAccountLabelInput!, $condition: ModelAccountLabelConditionInput) {
  updateAccountLabel(input: $input, condition: $condition) {
    id
    labels {
      language
      label
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    class
    customUsage
    customValues {
      name
      value
      __typename
    }
    disabled
    hoaFundId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    topClass
    vatNonDeductiblePercentage
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateAddress = /* GraphQL */ `mutation UpdateAddress($input: UpdateAddressInput!, $condition: ModelAddressConditionInput) {
  updateAddress(input: $input, condition: $condition) {
    id
    status
    street
    number
    box
    postalCode
    city
    region
    country
    customValues {
      name
      value
      __typename
    }
    latitude
    longitude
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateAdminCommunication = /* GraphQL */ `mutation UpdateAdminCommunication($input: UpdateAdminCommunicationInput!, $condition: ModelAdminCommunicationConditionInput) {
  updateAdminCommunication(input: $input, condition: $condition) {
    id
    body
    clientId
    externalId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    applicationInvoiceId
    recipient
    sentAt
    status
    subject
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateAdminFile = /* GraphQL */ `mutation UpdateAdminFile($input: UpdateAdminFileInput!, $condition: ModelAdminFileConditionInput) {
  updateAdminFile(input: $input, condition: $condition) {
    id
    bucket
    foreignKey
    foreignTableName
    key
    mimeType
    region
    size
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateAdvertisement = /* GraphQL */ `mutation UpdateAdvertisement($input: UpdateAdvertisementInput!, $condition: ModelAdvertisementConditionInput) {
  updateAdvertisement(input: $input, condition: $condition) {
    id
    type
    subType
    amenities
    amountOfFacades
    availabilityDate
    certificateOfConformity
    citationForPlanningOffence
    descriptions {
      language
      description
      __typename
    }
    delimitedZone
    floodProneArea
    furnished
    firstOccupancy
    gardenSurface
    heatingAmenities
    heatingType
    landTerrain
    landArea
    length
    nearbyComodities {
      type
      name
      distance
      __typename
    }
    publishedPlatforms {
      name
      publishedDate
      id
      __typename
    }
    planningPermission
    publishCadastralIncome
    resort
    rightOfPreemption
    subdivisionAuthorization
    wheelChairAccessible
    width
    terraceSurface
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateAgencyRate = /* GraphQL */ `mutation UpdateAgencyRate($input: UpdateAgencyRateInput!, $condition: ModelAgencyRateConditionInput) {
  updateAgencyRate(input: $input, condition: $condition) {
    id
    amountDetails {
      amountType
      endAmount
      feeApplied
      startAmount
      __typename
    }
    rateWhenVacant {
      amount
      type
      __typename
    }
    amountMinimumFees
    custom
    feesAppliedTo
    includedInAmount
    name
    owners {
      items {
        id
        agencyRateId
        contactId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    repartitionType
    type
    unitType
    vatRateId
    unitIds
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateAgencyRateOwner = /* GraphQL */ `mutation UpdateAgencyRateOwner($input: UpdateAgencyRateOwnerInput!, $condition: ModelAgencyRateOwnerConditionInput) {
  updateAgencyRateOwner(input: $input, condition: $condition) {
    id
    agencyRateId
    contactId
    agencyRate {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateAgencyRateStatement = /* GraphQL */ `mutation UpdateAgencyRateStatement($input: UpdateAgencyRateStatementInput!, $condition: ModelAgencyRateStatementConditionInput) {
  updateAgencyRateStatement(input: $input, condition: $condition) {
    id
    agencyRate {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    agencyRateId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    unitAmounts {
      unitId
      amountRateable
      fixedAmount
      __typename
    }
    totalAmountRateable
    totalFixedAmount
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateApplicationInvoice = /* GraphQL */ `mutation UpdateApplicationInvoice($input: UpdateApplicationInvoiceInput!, $condition: ModelApplicationInvoiceConditionInput) {
  updateApplicationInvoice(input: $input, condition: $condition) {
    id
    amount
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    dueDate
    invoiceDate
    invoiceLines {
      items {
        id
        amountVatExcluded
        applicationInvoiceId
        calculationMethod
        clientId
        customLabel
        extraInformation
        quantity
        periodFrom
        periodTo
        subscriptionVariousOperationId
        subscriptionUsageHistoryId
        totalAmount
        type
        vatAmount
        vatRate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoiceNumber
    periodFrom
    periodTo
    clientSnapshot {
      name
      vat
      businessNumber
      email
      address {
        street
        number
        box
        postalCode
        city
        country
        __typename
      }
      __typename
    }
    peppolProperties {
      peppolStatus
      peppolId
      peppolErrorType
      peppolErrorMessage
      __typename
    }
    status
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateApplicationInvoiceLine = /* GraphQL */ `mutation UpdateApplicationInvoiceLine($input: UpdateApplicationInvoiceLineInput!, $condition: ModelApplicationInvoiceLineConditionInput) {
  updateApplicationInvoiceLine(input: $input, condition: $condition) {
    id
    amountVatExcluded
    applicationInvoiceId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    calculationDetail {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    clientId
    customLabel
    extraInformation
    quantity
    periodFrom
    periodTo
    subscriptionVariousOperationId
    subscriptionVariousOperation {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    subscriptionUsageHistoryId
    subscriptionUsageHistory {
      id
      clientId
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    totalAmount
    type
    vatAmount
    vatRate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateApplicationPlan = /* GraphQL */ `mutation UpdateApplicationPlan($input: UpdateApplicationPlanInput!, $condition: ModelApplicationPlanConditionInput) {
  updateApplicationPlan(input: $input, condition: $condition) {
    id
    calculationDetails {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    includedVariousOperations {
      items {
        id
        amount
        applicationPlanIncludedVariousOperationsId
        customerVisible
        duration
        numberOfCredits
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    isBillable
    isDefaultPlan
    labels {
      language
      label
      __typename
    }
    numberOfTrialMonths
    setupFees
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateApplicationSubscription = /* GraphQL */ `mutation UpdateApplicationSubscription($input: UpdateApplicationSubscriptionInput!, $condition: ModelApplicationSubscriptionConditionInput) {
  updateApplicationSubscription(input: $input, condition: $condition) {
    id
    clientId
    creditsBalancePaid
    creditsBalanceIncluded
    creditsConfiguration {
      allowPostPaid
      creditsNotification
      postPaidThreshold
      __typename
    }
    endDate
    language
    lastInvoiceDate
    paymentCustomerId
    paymentLastExecution
    paymentLastStatus
    paymentLastError
    paymentMode
    paymentTerms
    invoicesProperties {
      hideQuantities
      __typename
    }
    plan {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    planId
    referenceNumber
    seller {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sellerId
    startDate
    status
    subscriptionVariousOperations {
      items {
        id
        applicationSubscriptionId
        clientId
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateApplicationSubscriptionVariousOperation = /* GraphQL */ `mutation UpdateApplicationSubscriptionVariousOperation($input: UpdateApplicationSubscriptionVariousOperationInput!, $condition: ModelApplicationSubscriptionVariousOperationConditionInput) {
  updateApplicationSubscriptionVariousOperation(input: $input, condition: $condition) {
    id
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    createdBy {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    endDate
    label
    lastInvoiceDate
    sellerId
    startDate
    subscriptionVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateApplicationVariousOperation = /* GraphQL */ `mutation UpdateApplicationVariousOperation($input: UpdateApplicationVariousOperationInput!, $condition: ModelApplicationVariousOperationConditionInput) {
  updateApplicationVariousOperation(input: $input, condition: $condition) {
    id
    amount
    applicationPlanIncludedVariousOperationsId
    customerVisible
    duration
    labels {
      language
      label
      __typename
    }
    numberOfCredits
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateAuthTeam = /* GraphQL */ `mutation UpdateAuthTeam($input: UpdateAuthTeamInput!) {
  updateAuthTeam(input: $input) {
    clientId
    id
    name
    parentId
    __typename
  }
}
`;

export const updateAuthUserRole = /* GraphQL */ `mutation UpdateAuthUserRole($input: UpdateAuthUserRoleInput!) {
  updateAuthUserRole(input: $input) {
    clientId
    id
    isDefault
    name
    userRights {
      access
      section
      __typename
    }
    __typename
  }
}
`;

export const updateBankAccount = /* GraphQL */ `mutation UpdateBankAccount($input: UpdateBankAccountInput!, $condition: ModelBankAccountConditionInput) {
  updateBankAccount(input: $input, condition: $condition) {
    id
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactIds
    buildingIds
    number
    bicNumber
    bankName
    holderName
    label
    customValues {
      name
      value
      __typename
    }
    disabled
    integrations
    matchingRule
    initiationChannel
    retainedBalanceThreshold
    balance
    balanceDate
    type
    ibanStatus
    ibanVerifiedAt
    ibanVerifiedBy
    ibanVerifiedNumber
    ibanVerifiedSourceDocumentId
    ibanRole
    ibanRoleLabel
    isDefault
    note
    paymentRunPriorityOrderIds
    paymentRunPriorityUpdatedAt
    paymentRunPriorityUpdatedBy
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateBillingItem = /* GraphQL */ `mutation UpdateBillingItem($input: UpdateBillingItemInput!, $condition: ModelBillingItemConditionInput) {
  updateBillingItem(input: $input, condition: $condition) {
    id
    name
    baseAmount
    billingType
    amountCalculationType
    percentageBase
    period
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    quantity
    percentage
    allocationOption
    multipleUnitsSplit
    leaseIds
    unitIds
    buildingIds
    accountLabelId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateBuilding = /* GraphQL */ `mutation UpdateBuilding($input: UpdateBuildingInput!, $condition: ModelBuildingConditionInput) {
  updateBuilding(input: $input, condition: $condition) {
    id
    name
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    acquisitionValue
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    amountOfFacades
    amountOfFloors
    amountOfHousings
    buildingState
    cadastralIncome
    constructionYear
    customValues {
      name
      value
      __typename
    }
    janitor
    jointOwnershipId
    notes
    owners {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    propertyTax
    residenceName
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    units {
      items {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        buildingId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateBuildingEvent = /* GraphQL */ `mutation UpdateBuildingEvent($input: UpdateBuildingEventInput!, $condition: ModelBuildingEventConditionInput) {
  updateBuildingEvent(input: $input, condition: $condition) {
    id
    buildingId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateBuildingOwner = /* GraphQL */ `mutation UpdateBuildingOwner($input: UpdateBuildingOwnerInput!, $condition: ModelBuildingOwnerConditionInput) {
  updateBuildingOwner(input: $input, condition: $condition) {
    id
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    periodTo
    stake
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateBuildingSite = /* GraphQL */ `mutation UpdateBuildingSite($input: UpdateBuildingSiteInput!, $condition: ModelBuildingSiteConditionInput) {
  updateBuildingSite(input: $input, condition: $condition) {
    id
    name
    buildings {
      items {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCashExpectation = /* GraphQL */ `mutation UpdateCashExpectation($input: UpdateCashExpectationInput!, $condition: ModelCashExpectationConditionInput) {
  updateCashExpectation(input: $input, condition: $condition) {
    id
    sourceType
    sourceId
    direction
    flowType
    status
    accountIds
    originalAmount
    openAmount
    disputedAmount
    expectedAmount
    issueDate
    dueDate
    confirmationDeadline
    structuredCommunication
    invoiceNumber
    reference
    counterpartyIban
    leaseId
    unitId
    ownerId
    contractorId
    isOffLedgerReceivable
    awaitingPosting
    lines {
      postingId
      accountClass
      originalAmount
      openAmount
      disputed
      periodFrom
      periodTo
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCause = /* GraphQL */ `mutation UpdateCause($input: UpdateCauseInput!, $condition: ModelCauseConditionInput) {
  updateCause(input: $input, condition: $condition) {
    id
    distinctValues {
      candidates {
        reason
        targetId
        __typename
      }
      display
      sectionIds
      value
      __typename
    }
    importRunId
    key
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCharge = /* GraphQL */ `mutation UpdateCharge($input: UpdateChargeInput!, $condition: ModelChargeConditionInput) {
  updateCharge(input: $input, condition: $condition) {
    id
    status
    invoiceDate
    paymentDueDate
    archivedDate
    periodFrom
    periodTo
    totalAmount
    payableAmount
    source
    draftFromOcr
    accountingDocumentId
    paid
    settlement {
      bankCheck
      modeResolved
      modeSource
      parts {
        amount
        executeOn
        kind
        reference
        __typename
      }
      __typename
    }
    remittanceInformation
    note
    creatorEmail
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedContractors {
      id
      confidence
      __typename
    }
    recipientId
    recipient {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedRecipients {
      id
      confidence
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    documentId
    sectionId
    document {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readId
    clientId
    openChargeClientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateChargeEnvelope = /* GraphQL */ `mutation UpdateChargeEnvelope($input: UpdateChargeEnvelopeInput!, $condition: ModelChargeEnvelopeConditionInput) {
  updateChargeEnvelope(input: $input, condition: $condition) {
    id
    channel
    decryptedS3Key
    duplicateOfEnvelopeId
    encryption
    fileHash
    fileId
    file {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    importRunId
    mimeType
    originalFileName
    pageQuality {
      alphaRatio
      averageFontSize
      dictionaryHits
      kind
      page
      __typename
    }
    pages
    readFailure
    receivedAt
    s3Key
    sections {
      items {
        id
        attachedToSectionId
        chargeId
        envelopeId
        excludedPages
        fallbackIdentityKey
        genre
        genreSubKind
        identityKey
        index
        issueDate
        issuerDateKey
        issuerNumberKey
        readFailure
        setAsideReason
        splitSource
        state
        valuesFromSectionId
        resolvedAliases
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    setAsideReason
    splitProposal {
      ambiguousBoundaries
      autoApplied
      cuts {
        afterPage
        reason
        rule
        score
        __typename
      }
      proposedAt
      source
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateChargeSection = /* GraphQL */ `mutation UpdateChargeSection($input: UpdateChargeSectionInput!, $condition: ModelChargeSectionConditionInput) {
  updateChargeSection(input: $input, condition: $condition) {
    id
    attachedToSectionId
    chargeId
    checkpoints {
      allocate
      pay
      payReasons
      read
      resolve
      sort
      tenant
      __typename
    }
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    duplicateCandidates {
      reason
      sectionId
      __typename
    }
    envelopeId
    envelope {
      id
      channel
      decryptedS3Key
      duplicateOfEnvelopeId
      encryption
      fileHash
      fileId
      file {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      importRunId
      mimeType
      originalFileName
      pageQuality {
        alphaRatio
        averageFontSize
        dictionaryHits
        kind
        page
        __typename
      }
      pages
      readFailure
      receivedAt
      s3Key
      sections {
        nextToken
        startedAt
        __typename
      }
      setAsideReason
      splitProposal {
        ambiguousBoundaries
        autoApplied
        proposedAt
        source
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    excludedPages
    fallbackIdentityKey
    genre
    genreCandidates {
      genre
      reasons
      score
      __typename
    }
    genreSubKind
    identity {
      documentNumber
      grossTotal
      issuer
      source
      values {
        field
        value
        __typename
      }
      __typename
    }
    identityKey
    index
    issueDate
    issuerDateKey
    issuerNumberKey
    readFailure
    pageRange {
      from
      to
      __typename
    }
    renderings {
      attachedAt
      differences {
        field
        renderingValue
        survivorValue
        __typename
      }
      envelopeId
      reason
      sectionId
      source
      __typename
    }
    setAsideReason
    splitSource
    state
    valuesFromSectionId
    resolvedAliases
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateChargeStatement = /* GraphQL */ `mutation UpdateChargeStatement($input: UpdateChargeStatementInput!, $condition: ModelChargeStatementConditionInput) {
  updateChargeStatement(input: $input, condition: $condition) {
    id
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCommunication = /* GraphQL */ `mutation UpdateCommunication($input: UpdateCommunicationInput!, $condition: ModelCommunicationConditionInput) {
  updateCommunication(input: $input, condition: $condition) {
    id
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    blockedRecipients {
      recipient
      bounceType
      __typename
    }
    body
    buildingId
    channel
    communicationTemplateId
    concernedContactIds
    contactId
    contactIds
    deliveredAt
    draftProperties {
      entityType
      leaseIds
      unitIds
      buildingIds
      contactIds
      contactTypes
      sendInBcc
      cc
      bcc
      allowRecipientsToSeeEachOther
      unitTypeFilter
      __typename
    }
    errorCode
    expirationDate
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    leasePriceHistoryId
    leasePriceHistory {
      id
      previousTotalRentalPrice
      totalRentalPrice
      optimalTotalRentalPrice
      optimalTotalMonthlyCharges
      applicationDate
      status
      comment
      amountDetails {
        unitId
        indexationBaseIndex
        indexationNewIndex
        previousRentalPrice
        newRentalPrice
        rentalStatus
        monthlyChargesStatus
        optimalNewRentalPrice
        optimalNewMonthlyChargesPrice
        epb
        epbIssueDate
        oldestIndexForCorrectionFactorCalculation
        newestIndexForCorrectionFactorCalculation
        rentIndexedPriceAfterNewEpbReduction
        chargesIndexedPriceAfterNewEpbReduction
        correctionFactor
        reductionPercentage
        rentDifference
        rentReduction
        indexedRentAfterReduction
        chargesDifference
        chargesReduction
        indexedChargesAfterReduction
        previousYearIndexationNewIndex
        previousYearIndexedRent
        previousYearIndexedCharges
        __typename
      }
      type
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    letterTrackingCode
    letterTrackingProvider
    linkedCommunicationsIds
    nextRetryAt
    recipient
    recipientContactIdsInBcc
    recipientContactIdsInCc
    recipientInBcc
    recipientInCc
    scheduledAt
    sender
    sendRetryCount
    sentAt
    externalId
    externalStatus
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    snoozedDate
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    status
    subject
    supportingDocumentFileIds
    toSend
    hideLogo
    type
    _ttl
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCommunicationSettingsProfile = /* GraphQL */ `mutation UpdateCommunicationSettingsProfile($input: UpdateCommunicationSettingsProfileInput!, $condition: ModelCommunicationSettingsProfileConditionInput) {
  updateCommunicationSettingsProfile(input: $input, condition: $condition) {
    id
    communicationsSettings {
      channels
      communicationType
      daysBeforeDueDate
      daysOverdue
      invoiceDaysAfterPeriodStart
      frequency {
        dateFrom
        periodInterval
        periodType
        __typename
      }
      sendingRule
      recipients
      recipientsInBcc
      recipientsInCopy
      displayOpenBalance
      __typename
    }
    defaultName
    isDefaultSetting
    referent
    tenantStatementView
    replacementId
    displayLogo
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCompanyInvoice = /* GraphQL */ `mutation UpdateCompanyInvoice($input: UpdateCompanyInvoiceInput!) {
  updateCompanyInvoice(input: $input) {
    status
    id
    __typename
  }
}
`;

export const updateCompanyUser = /* GraphQL */ `mutation UpdateCompanyUser($input: UpdateCompanyUserInput!, $condition: ModelCompanyUserConditionInput) {
  updateCompanyUser(input: $input, condition: $condition) {
    id
    cognitoSub
    email
    firstName
    language
    lastName
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateContact = /* GraphQL */ `mutation UpdateContact($input: UpdateContactInput!, $condition: ModelContactConditionInput) {
  updateContact(input: $input, condition: $condition) {
    id
    firstName
    lastName
    companyName
    commercialName
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    businessNumber
    types
    vat
    emails {
      address
      isPrimary
      label
      __typename
    }
    email
    birthDate
    birthPlace
    nationalRegister
    ipiNumber
    insuranceCompany
    insuranceContractNumber
    judicialDistrict
    civility
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    phoneNumbers {
      countryCode
      isPrimary
      label
      number
      __typename
    }
    language
    notes
    profileType
    jointOwners {
      contactId
      contactPerson
      __typename
    }
    hoaFunds {
      archivedAt
      id
      kind
      name
      __typename
    }
    paymentTermDays
    acpSyndicEras {
      syndicContactId
      validFrom
      validTo
      __typename
    }
    acpSyndicHistory {
      changedAt
      changedBy
      previousSyndicContactId
      previousValidFrom
      syndicContactId
      validFrom
      __typename
    }
    defaultBankAccountId
    supplierPaymentMode
    supplierPaymentModeExceptions {
      confirmedAt
      confirmedBy
      mode
      ownerId
      __typename
    }
    supplierPaymentModeHistory {
      changedAt
      changedBy
      mode
      ownerId
      previousMode
      __typename
    }
    agencyRateDisabled
    attachStatementSupportingDocuments
    status
    leases {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildings {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sendInvitation
    peppolProperties {
      isRegistered
      mustSend
      __typename
    }
    integrations {
      paymentProperties {
        accountId
        __typename
      }
      __typename
    }
    readers
    readId
    clientId
    sourceEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    foreignEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCounterpartyIdentity = /* GraphQL */ `mutation UpdateCounterpartyIdentity($input: UpdateCounterpartyIdentityInput!, $condition: ModelCounterpartyIdentityConditionInput) {
  updateCounterpartyIdentity(input: $input, condition: $condition) {
    id
    keyType
    key
    isFullRemittance
    kind
    contactId
    source
    status
    evidenceCount
    firstSeenAt
    lastSeenAt
    lastCounterpartName
    lastDecisionId
    evidenceTransactionIds
    exclusionReason
    exclusionComment
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCounterpartyRole = /* GraphQL */ `mutation UpdateCounterpartyRole($input: UpdateCounterpartyRoleInput!, $condition: ModelCounterpartyRoleConditionInput) {
  updateCounterpartyRole(input: $input, condition: $condition) {
    id
    subjectId
    targetType
    targetId
    source
    status
    evidenceCount
    lastSeenAt
    lastDecisionId
    evidenceTransactionIds
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCreditCost = /* GraphQL */ `mutation UpdateCreditCost($input: UpdateCreditCostInput!, $condition: ModelCreditCostConditionInput) {
  updateCreditCost(input: $input, condition: $condition) {
    id
    clientId
    endDate
    numberOfCredits
    price
    startDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCreditUsageCost = /* GraphQL */ `mutation UpdateCreditUsageCost($input: UpdateCreditUsageCostInput!, $condition: ModelCreditUsageCostConditionInput) {
  updateCreditUsageCost(input: $input, condition: $condition) {
    id
    endDate
    numberOfCreditsPerOperation
    startDate
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCustomField = /* GraphQL */ `mutation UpdateCustomField($input: UpdateCustomFieldInput!, $condition: ModelCustomFieldConditionInput) {
  updateCustomField(input: $input, condition: $condition) {
    id
    fieldName
    fieldType
    foreignKey
    foreignTableName
    labels {
      language
      label
      __typename
    }
    customFieldProperties {
      isRequired
      isDefault
      defaultValue
      options {
        id
        __typename
      }
      __typename
    }
    order
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateCustomSubscription = /* GraphQL */ `mutation UpdateCustomSubscription($input: UpdateCustomSubscriptionInput!, $condition: ModelCustomSubscriptionConditionInput) {
  updateCustomSubscription(input: $input, condition: $condition) {
    id
    name
    value
    userId
    _ttl
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateDocumentCategory = /* GraphQL */ `mutation UpdateDocumentCategory($input: UpdateDocumentCategoryInput!, $condition: ModelDocumentCategoryConditionInput) {
  updateDocumentCategory(input: $input, condition: $condition) {
    id
    entity
    fileCategory
    labels {
      language
      label
      __typename
    }
    parentId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateDocumentExtraction = /* GraphQL */ `mutation UpdateDocumentExtraction($input: UpdateDocumentExtractionInput!, $condition: ModelDocumentExtractionConditionInput) {
  updateDocumentExtraction(input: $input, condition: $condition) {
    id
    corrected
    createdBy
    evidence {
      bbox
      field
      method
      page
      quote
      rawConfidence
      __typename
    }
    flags
    raw
    reasons
    score
    sectionId
    version
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateDocumentNumber = /* GraphQL */ `mutation UpdateDocumentNumber($input: UpdateDocumentNumberInput!, $condition: ModelDocumentNumberConditionInput) {
  updateDocumentNumber(input: $input, condition: $condition) {
    id
    format
    lastUpdate
    incrementNumber
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateEntityAlias = /* GraphQL */ `mutation UpdateEntityAlias($input: UpdateEntityAliasInput!, $condition: ModelEntityAliasConditionInput) {
  updateEntityAlias(input: $input, condition: $condition) {
    id
    confirmations
    confirmedBy
    key
    kind
    lastSeenAt
    lookupKey
    printedValue
    senderKeyType
    source
    targetId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateEntityRelation = /* GraphQL */ `mutation UpdateEntityRelation($input: UpdateEntityRelationInput!, $condition: ModelEntityRelationConditionInput) {
  updateEntityRelation(input: $input, condition: $condition) {
    id
    sourceId
    sourceTableName
    foreignId
    foreignTableName
    linkDescription
    linkProperties {
      contact {
        communicationSubscriptions
        __typename
      }
      __typename
    }
    clientId
    readers
    readId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateFeeArrears = /* GraphQL */ `mutation UpdateFeeArrears($input: UpdateFeeArrearsInput!, $condition: ModelFeeArrearsConditionInput) {
  updateFeeArrears(input: $input, condition: $condition) {
    id
    accumulatedFrom {
      accumulatedAt
      amount
      paymentOrderId
      __typename
    }
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    openedAt
    originalAmount
    originPaymentOrderId
    originPaymentOrder {
      id
      amount
      anomalies
      anomalyAcknowledgedAt
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      confirmationDeadlineDate
      counterpartAccountNumber
      counterpartContactId
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      counterpartContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartRemittanceInformation
      createdBy
      dueDate
      executedDate
      executedAt
      executedBy
      executedTransactionId
      feeArrearsId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      fundAmounts {
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issuedAt
      issuedBy
      ownerContactId
      paymentBatchId
      paymentBatch {
        id
        bankAccountId
        clientStatusKey
        currentVersion
        number
        outdated
        sentAt
        sentBy
        status
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      reconciledAt
      recurringPaymentTemplateId
      reference
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      requestedAmount
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerContactId
    ownerContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    servedBy {
      amount
      paymentOrderId
      servedAt
      __typename
    }
    settledAt
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateFile = /* GraphQL */ `mutation UpdateFile($input: UpdateFileInput!, $condition: ModelFileConditionInput) {
  updateFile(input: $input, condition: $condition) {
    id
    bucket
    category {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    categoryId
    foreignKey
    foreignTableName
    key
    mimeType
    region
    signaturePositions {
      top
      left
      page
      width
      height
      contactId
      __typename
    }
    size
    readers
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateFilterGroup = /* GraphQL */ `mutation UpdateFilterGroup($input: UpdateFilterGroupInput!, $condition: ModelFilterGroupConditionInput) {
  updateFilterGroup(input: $input, condition: $condition) {
    id
    filterGroupDetails {
      filterEntityType
      filterEntityField
      filterEntityValues
      filterEntityNumber
      filterEntityDate
      __typename
    }
    name
    screenName
    type
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateImportRun = /* GraphQL */ `mutation UpdateImportRun($input: UpdateImportRunInput!, $condition: ModelImportRunConditionInput) {
  updateImportRun(input: $input, condition: $condition) {
    id
    channel
    files
    finishedAt
    handled
    needsYou
    reviewEverything
    sections
    setAside
    startedAt
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateIntegration = /* GraphQL */ `mutation UpdateIntegration($input: UpdateIntegrationInput!, $condition: ModelIntegrationConditionInput) {
  updateIntegration(input: $input, condition: $condition) {
    id
    configurations {
      name
      value
      __typename
    }
    error
    lastRun
    name
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateInternalComment = /* GraphQL */ `mutation UpdateInternalComment($input: UpdateInternalCommentInput!, $condition: ModelInternalCommentConditionInput) {
  updateInternalComment(input: $input, condition: $condition) {
    id
    authorId
    content
    entityId
    entityType
    kind
    mentionedUserIds
    userIdsReactions {
      reactionType
      userId
      __typename
    }
    replyToId
    attachmentFileIds
    systemMessage
    systemMessageParameters
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateInvoice = /* GraphQL */ `mutation UpdateInvoice($input: UpdateInvoiceInput!, $condition: ModelInvoiceConditionInput) {
  updateInvoice(input: $input, condition: $condition) {
    id
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    creditNote
    creditNoteLabel
    customValues {
      name
      value
      __typename
    }
    disputedPostingIds
    disputes {
      id
      scope
      postingId
      postingLabel
      reason
      comment
      disputedOn
      openedAt
      openedById
      openDecisionId
      liftedAt
      liftedById
      liftCause
      liftDecisionId
      __typename
    }
    disputeStatus
    dueDate
    invoiceDate
    invoiceNumber
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    paid
    integrations {
      paymentProperties {
        availableOn
        error
        feeAmount
        paymentIntentId
        paymentLinkAmount
        paymentLinkUrl
        payoutId
        statementDescriptor
        __typename
      }
      __typename
    }
    lastValidatedAt
    note
    postedDate
    purchaseOrderNumber
    receiptNumber
    reminderDates
    remittanceInformation
    reversedInvoiceId
    sentVersions {
      version
      sentAt
      invoiceNumber
      invoiceSenderId
      channels {
        channel
        status
        communicationId
        peppolId
        __typename
      }
      pdfFileId
      xmlFileId
      resetAt
      resetBy
      reason
      __typename
    }
    statementId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    type
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateInvoiceSetting = /* GraphQL */ `mutation UpdateInvoiceSetting($input: UpdateInvoiceSettingInput!, $condition: ModelInvoiceSettingConditionInput) {
  updateInvoiceSetting(input: $input, condition: $condition) {
    id
    creditNoteFormat
    creditNoteLastUpdate
    creditNoteIncrementNumber
    invoiceFormat
    invoiceLastUpdate
    invoiceIncrementNumber
    paymentRequestFormat
    paymentRequestLastUpdate
    paymentRequestIncrementNumber
    receiptFormat
    receiptLastUpdate
    receiptIncrementNumber
    variousOperationFormat
    variousOperationLastUpdate
    variousOperationIncrementNumber
    customInvoicingConfiguration
    defaultVatRateId
    fiscalYearStart
    allPurposeInvoiceIssuer
    paymentBankAccountId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateLearningEvent = /* GraphQL */ `mutation UpdateLearningEvent($input: UpdateLearningEventInput!, $condition: ModelLearningEventConditionInput) {
  updateLearningEvent(input: $input, condition: $condition) {
    id
    at
    field
    from
    kind
    layoutId
    senderId
    to
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateLease = /* GraphQL */ `mutation UpdateLease($input: UpdateLeaseInput!, $condition: ModelLeaseConditionInput) {
  updateLease(input: $input, condition: $condition) {
    id
    advancedChargesInvoices {
      communicationSettingsProfileId
      invoiceSenderId
      lastDraftInvoiceDate
      lastInvoiceDate
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      remittanceInformation
      remittanceInformationType
      bankAccountId
      __typename
    }
    balance
    canBeExtended
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    endDate
    includeRealEstateInLeaseContract
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    inventoryOfFixturesExpert
    inventoryOfFixturesMethod
    inventoryOfFixturesType
    ipiNumber
    language
    lastDraftInvoiceDate
    lastIndexationProcessDate
    lastInvoiceDate
    legalCompetentAuthority
    name
    notes
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    paymentOption {
      enabled
      mandateStatus
      mandateActivatedAt
      customerId
      paymentMethodId
      qrType
      __typename
    }
    purchaseOrderNumber
    realEstateAgency
    realEstateTax
    remittanceInformation
    remittanceInformationType
    rentalGuaranty {
      amount
      blockedAmount
      releasedAmount
      type
      financialInstitution
      __typename
    }
    signatureDate
    startDate
    nextIndexationMonth
    nextIndexation
    status
    subletting
    technicCommunicationSettingsProfileId
    totalInitialRentalPrice
    totalRentalPrice
    type
    vatRateRentId
    vatRateRent {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    additionalClauses {
      items {
        id
        leaseId
        title
        body
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    attachStatementSupportingDocuments
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contacts {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leaseActionHistories {
      items {
        id
        action
        comment
        contactId
        leaseId
        communicationId
        signatureDocumentId
        status
        communicationChannel
        communicationSendDate
        communicationByPlatform
        endReason
        endReasonOwnUseRelation
        endReasonOwnUseName
        initiator
        totalAmount
        totalAmountLabel
        automatic
        hasLeaseTypeChanged
        jiraId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leasePriceHistories {
      items {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    signatureDocuments {
      items {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    variousOperations {
      items {
        id
        accountLabelIds
        amount
        billingMode
        contactId
        dueDateDaysAfterPeriodStart
        endDate
        indexationBaseAmount
        indexationBaseIndexDate
        indexationFrozen
        invoiceSenderId
        issueLeadDays
        label
        lastInvoiceDate
        leaseId
        operationType
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        periodNature
        reason
        separateInvoice
        startDate
        type
        unitId
        vatRateId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateLeaseActionHistory = /* GraphQL */ `mutation UpdateLeaseActionHistory($input: UpdateLeaseActionHistoryInput!, $condition: ModelLeaseActionHistoryConditionInput) {
  updateLeaseActionHistory(input: $input, condition: $condition) {
    id
    action
    comment
    contactId
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    historyDetails {
      unitId
      newEndDate
      newSignatureDate
      newStartDate
      previousEndDate
      previousSignatureDate
      previousStartDate
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    communicationChannel
    communicationSendDate
    communicationByPlatform
    endReason
    endReasonOwnUseRelation
    endReasonOwnUseName
    initiator
    totalAmount
    totalAmountLabel
    automatic
    hasLeaseTypeChanged
    jiraId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateLeaseAdditionalClause = /* GraphQL */ `mutation UpdateLeaseAdditionalClause($input: UpdateLeaseAdditionalClauseInput!, $condition: ModelLeaseAdditionalClauseConditionInput) {
  updateLeaseAdditionalClause(input: $input, condition: $condition) {
    id
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    title
    body
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateLeaseBillingItem = /* GraphQL */ `mutation UpdateLeaseBillingItem($input: UpdateLeaseBillingItemInput!) {
  updateLeaseBillingItem(input: $input) {
    id
    status
    invoiceId
    creditNoteId
    __typename
  }
}
`;

export const updateLeaseContact = /* GraphQL */ `mutation UpdateLeaseContact($input: UpdateLeaseContactInput!, $condition: ModelLeaseContactConditionInput) {
  updateLeaseContact(input: $input, condition: $condition) {
    id
    leaseId
    contactId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactRole
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateLeasePriceHistory = /* GraphQL */ `mutation UpdateLeasePriceHistory($input: UpdateLeasePriceHistoryInput!, $condition: ModelLeasePriceHistoryConditionInput) {
  updateLeasePriceHistory(input: $input, condition: $condition) {
    id
    previousTotalRentalPrice
    totalRentalPrice
    optimalTotalRentalPrice
    optimalTotalMonthlyCharges
    applicationDate
    status
    comment
    amountDetails {
      unitId
      indexationBaseIndex
      indexationNewIndex
      previousRentalPrice
      newRentalPrice
      rentalStatus
      monthlyChargesStatus
      optimalNewRentalPrice
      optimalNewMonthlyChargesPrice
      epb
      epbIssueDate
      oldestIndexForCorrectionFactorCalculation
      newestIndexForCorrectionFactorCalculation
      rentIndexedPriceAfterNewEpbReduction
      chargesIndexedPriceAfterNewEpbReduction
      correctionFactor
      chargesAmountsDetails {
        leaseVariousOperationId
        previousMonthlyAmount
        newMonthlyAmount
        indexationBaseIndex
        indexationBaseAmount
        indexationBaseIndexDate
        indexed
        __typename
      }
      reductionPercentage
      rentDifference
      rentReduction
      indexedRentAfterReduction
      chargesDifference
      chargesReduction
      indexedChargesAfterReduction
      previousYearIndexationNewIndex
      previousYearIndexedRent
      previousYearIndexedCharges
      __typename
    }
    type
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateLeaseVariousOperation = /* GraphQL */ `mutation UpdateLeaseVariousOperation($input: UpdateLeaseVariousOperationInput!, $condition: ModelLeaseVariousOperationConditionInput) {
  updateLeaseVariousOperation(input: $input, condition: $condition) {
    id
    accountLabelIds
    amount
    billingMode
    contactId
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dueDateDaysAfterPeriodStart
    endDate
    indexationBaseAmount
    indexationBaseIndexDate
    indexationFrozen
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issueLeadDays
    label
    lastInvoiceDate
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    operationType
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    periodNature
    reason
    separateInvoice
    startDate
    type
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateMortgage = /* GraphQL */ `mutation UpdateMortgage($input: UpdateMortgageInput!, $condition: ModelMortgageConditionInput) {
  updateMortgage(input: $input, condition: $condition) {
    id
    lender
    durationInYears
    rateType
    interestRate
    aprRate
    startDate
    amount
    monthlyPayment
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateNotification = /* GraphQL */ `mutation UpdateNotification($input: UpdateNotificationInput!, $condition: ModelNotificationConditionInput) {
  updateNotification(input: $input, condition: $condition) {
    id
    createdBy
    type
    message
    popupDate
    expirationDate
    status
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicId
    technic {
      id
      type
      technicLibraryId
      technicLibrary {
        id
        communicationSettingsProfileId
        criticality
        isDefault
        issuingAuthority
        linkedCertificateIds
        locationScope
        status
        tagIds
        technicLibraryFormat
        type
        utilityTypes
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicName
      lastControlDate
      status
      contractNumber
      communicationSettingsProfileId
      maintenanceHistory {
        date
        contactId
        fileId
        id
        maintenanceSchemaId
        __typename
      }
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityDistributor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      utilityHistory {
        date
        reason
        reading
        secondReading
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      originalTechnicId
      replacedTechnicId
      certificateIds
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ticketId
    ticket {
      id
      assignedAt
      assignedTo {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedToId
      attachment {
        nextToken
        startedAt
        __typename
      }
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      closedAt
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      content
      conversations {
        nextToken
        startedAt
        __typename
      }
      emailMessageId
      emailReferences
      parentId
      plannedAt
      referenceCode
      sourceType
      status
      subject
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unread
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updatePaymentBatch = /* GraphQL */ `mutation UpdatePaymentBatch($input: UpdatePaymentBatchInput!, $condition: ModelPaymentBatchConditionInput) {
  updatePaymentBatch(input: $input, condition: $condition) {
    id
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientStatusKey
    currentVersion
    number
    outdated
    sentAt
    sentBy
    status
    versions {
      version
      exclusions {
        orderId
        reason
        __typename
      }
      fileKey
      fingerprint
      generatedAt
      generatedBy
      orderCount
      totalAmount
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updatePaymentOrder = /* GraphQL */ `mutation UpdatePaymentOrder($input: UpdatePaymentOrderInput!, $condition: ModelPaymentOrderConditionInput) {
  updatePaymentOrder(input: $input, condition: $condition) {
    id
    amount
    anomalies
    anomalyAcknowledgedAt
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    confirmationDeadlineDate
    counterpartAccountNumber
    counterpartContactId
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    counterpartContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartRemittanceInformation
    createdBy
    dueDate
    executedDate
    executedAt
    executedBy
    executedTransactionId
    feeArrearsId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    fundAmounts {
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issuedAt
    issuedBy
    ownerContactId
    paymentBatchId
    paymentBatch {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    reconciledAt
    recurringPaymentTemplateId
    reference
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    requestedAmount
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updatePosting = /* GraphQL */ `mutation UpdatePosting($input: UpdatePostingInput!, $condition: ModelPostingConditionInput) {
  updatePosting(input: $input, condition: $condition) {
    id
    class
    customLabel
    customValues {
      name
      value
      __typename
    }
    topClass
    type
    totalAmount
    periodFrom
    periodTo
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    transactionId
    transaction {
      id
      status
      snoozedUntil
      sequence
      statementDate
      operationDate
      customValues {
        name
        value
        __typename
      }
      remittanceInformationType
      remittanceInformation
      remittanceInformationRaw
      additionalInformation
      structuredCommunication
      bankTransactionCode
      proprietaryBankTransactionCode
      endToEndId
      mandateId
      creditorId
      purposeCode
      internalReference
      comment
      exclusionReason
      exclusionComment
      excludedAt
      excludedBy
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartDisplayName
      counterpartAccountNumber
      origin
      sourceChannel
      nativeTransactionId
      fingerprint
      linkedSourceChannels
      proposedLeaseId
      proposedUnitId
      proposedContractorId
      proposedOwnerId
      proposedMatch
      proposedAllocation
      classification
      classificationConfidence
      classificationReason
      recurrence
      links {
        amount
        linkId
        linkType
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationId
    leaseVariousOperation {
      id
      accountLabelIds
      amount
      billingMode
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dueDateDaysAfterPeriodStart
      endDate
      indexationBaseAmount
      indexationBaseIndexDate
      indexationFrozen
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issueLeadDays
      label
      lastInvoiceDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      operationType
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      periodNature
      reason
      separateInvoice
      startDate
      type
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    amountVatExcluded
    vatAmount
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    vatRateId
    vatRateValue
    foreignId
    foreignType
    invoicePostingId
    reconciledAt
    decisionId
    status
    chargeOwnerRepartition
    chargeRepartitionMetric
    chargeRepartitionValue
    chargeSplitNumber
    chargeType
    tenantShare {
      basis
      mode
      percentage
      __typename
    }
    provisional
    flaggedAt
    carriedForward
    tenantLandings {
      amount
      amountVatExcluded
      days
      leaseId
      periodFrom
      periodTo
      statementId
      vatAmount
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateReconciliationDecision = /* GraphQL */ `mutation UpdateReconciliationDecision($input: UpdateReconciliationDecisionInput!, $condition: ModelReconciliationDecisionConditionInput) {
  updateReconciliationDecision(input: $input, condition: $condition) {
    id
    decisionId
    transactionId
    relatedTransactionIds
    kind
    status
    source
    trigger
    actorId
    outcome
    score
    reasonCodes
    flowType
    amount
    links {
      amount
      linkId
      linkType
      __typename
    }
    allocations {
      invoiceId
      postingId
      amount
      awaitingPosting
      __typename
    }
    exclusionReason
    comment
    snoozedUntil
    reversesDecisionId
    appliesDecisionId
    decidedAt
    backfilled
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateReconciliationSetting = /* GraphQL */ `mutation UpdateReconciliationSetting($input: UpdateReconciliationSettingInput!, $condition: ModelReconciliationSettingConditionInput) {
  updateReconciliationSetting(input: $input, condition: $condition) {
    id
    type
    allocationMode
    leaseId
    ownerId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateRecurringPayment = /* GraphQL */ `mutation UpdateRecurringPayment($input: UpdateRecurringPaymentInput!) {
  updateRecurringPayment(input: $input) {
    failureReason
    recurringPayment {
      amountVersions {
        createdAt
        createdBy
        effectiveFrom
        note
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      bankAccountId
      beneficiaryBankAccountId
      beneficiaryContactId
      currentAmountVersion {
        createdAt
        createdBy
        effectiveFrom
        note
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      endDate
      firstPeriodFrom
      funds {
        accountLabelId
        fundId
        remittanceInformation
        __typename
      }
      generatedThisMonthAmount
      generatedThisMonthOrderCount
      generationDay
      id
      name
      nextDueDate
      oldestPendingPeriodFrom
      pendingAmount
      pendingPeriodCount
      periodicity
      remittanceInformation
      splitTransfers
      status
      underfunded
      unitId
      __typename
    }
    __typename
  }
}
`;

export const updateRecurringPaymentTemplate = /* GraphQL */ `mutation UpdateRecurringPaymentTemplate($input: UpdateRecurringPaymentTemplateInput!, $condition: ModelRecurringPaymentTemplateConditionInput) {
  updateRecurringPaymentTemplate(input: $input, condition: $condition) {
    id
    amountVersions {
      amounts {
        amount
        fundId
        __typename
      }
      createdAt
      createdBy
      effectiveFrom
      note
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryBankAccountId
    beneficiaryBankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryContactId
    beneficiaryContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdBy
    endDate
    endedAt
    endedBy
    firstPeriodFrom
    funds {
      accountLabelId
      fundId
      remittanceInformation
      __typename
    }
    generationDay
    lastGeneratedPeriodFrom
    name
    periodicity
    remittanceInformation
    splitTransfers
    status
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateReleaseNote = /* GraphQL */ `mutation UpdateReleaseNote($input: UpdateReleaseNoteInput!, $condition: ModelReleaseNoteConditionInput) {
  updateReleaseNote(input: $input, condition: $condition) {
    id
    status
    publishedAt
    visibleToOwners
    contents {
      language
      title
      body
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateRepartitionKey = /* GraphQL */ `mutation UpdateRepartitionKey($input: UpdateRepartitionKeyInput!, $condition: ModelRepartitionKeyConditionInput) {
  updateRepartitionKey(input: $input, condition: $condition) {
    id
    name
    type
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitRepartition {
      unitId
      value
      __typename
    }
    ownerRepartition
    tenantRepartition
    repartitionMetric
    technics
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateRepaymentStatement = /* GraphQL */ `mutation UpdateRepaymentStatement($input: UpdateRepaymentStatementInput!, $condition: ModelRepaymentStatementConditionInput) {
  updateRepaymentStatement(input: $input, condition: $condition) {
    id
    accountOwnership
    delaysCleared
    expectedRent
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    rentsCollected
    repaymentStatementDetails {
      class
      customLabel
      invoiceId
      invoicePostingId
      originalTotalAmount
      periodFrom
      periodTo
      totalAmount
      transactionId
      type
      __typename
    }
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    totalReceivedInJointAccount
    totalExpectedInOwnerAccount
    unpaidRents
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateScheduleRule = /* GraphQL */ `mutation UpdateScheduleRule($input: UpdateScheduleRuleInput!, $condition: ModelScheduleRuleConditionInput) {
  updateScheduleRule(input: $input, condition: $condition) {
    id
    conditions {
      attribute {
        attributeName
        __typename
      }
      comparisonMode
      operator
      values
      valueKind
      __typename
    }
    conditionsOperator
    foreignKey
    foreignTableName
    name {
      language
      label
      __typename
    }
    order
    outcome {
      interval {
        __typename
      }
      type
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateSenderRule = /* GraphQL */ `mutation UpdateSenderRule($input: UpdateSenderRuleInput!, $condition: ModelSenderRuleConditionInput) {
  updateSenderRule(input: $input, condition: $condition) {
    id
    senderId
    sender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    kind
    scope {
      accountClass
      identifierKind
      identifierValue
      labelKey
      ownerId
      __typename
    }
    value {
      accountLabelId
      encodesInvoiceNumber
      paymentOnReceipt
      paymentTermDays
      privateExpense
      recoverabilityMode
      recoverabilityPercentage
      reminderFees
      roundingPrecision
      vatRateValues
      __typename
    }
    source
    confirmations
    updatedBy
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateSendingSource = /* GraphQL */ `mutation UpdateSendingSource($input: UpdateSendingSourceInput!, $condition: ModelSendingSourceConditionInput) {
  updateSendingSource(input: $input, condition: $condition) {
    id
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dnsRecords {
      name
      type
      value
      __typename
    }
    emailAddress
    issuesEmail
    chargesEmail
    errorMessage
    name
    lastReminderDate
    status
    statusLastVerification
    verifiedType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateSetting = /* GraphQL */ `mutation UpdateSetting($input: UpdateSettingInput!, $condition: ModelSettingConditionInput) {
  updateSetting(input: $input, condition: $condition) {
    id
    name
    value
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateSignatureDocument = /* GraphQL */ `mutation UpdateSignatureDocument($input: UpdateSignatureDocumentInput!, $condition: ModelSignatureDocumentConditionInput) {
  updateSignatureDocument(input: $input, condition: $condition) {
    id
    additionalMessage
    automaticRemindersDisabled
    communicationBody
    expirationDate
    fileIds
    foreignKey
    foreignTableName
    sentAt
    signatureMethods
    signatureResults {
      openedDate
      signedDate
      signed
      signatureLink
      rejectReason
      lastSignInviteSentDate
      reminderDates
      trackingProvider
      trackingCode
      contactId
      __typename
    }
    status
    externalStatus
    type
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateStatement = /* GraphQL */ `mutation UpdateStatement($input: UpdateStatementInput!, $condition: ModelStatementConditionInput) {
  updateStatement(input: $input, condition: $condition) {
    id
    amounts {
      name
      value
      __typename
    }
    attachSupportingDocuments
    chargeStatements {
      items {
        id
        chargeId
        statementId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    closingStatement
    periodFrom
    periodTo
    selectedPocketKeys
    source
    status
    sentDate
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    agencyRateStatements {
      items {
        id
        agencyRateId
        statementId
        totalAmountRateable
        totalFixedAmount
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    repaymentStatements {
      items {
        id
        accountOwnership
        delaysCleared
        expectedRent
        leaseId
        rentsCollected
        statementId
        totalReceivedInJointAccount
        totalExpectedInOwnerAccount
        unpaidRents
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    types
    viewType
    unitIds
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateStatementSetting = /* GraphQL */ `mutation UpdateStatementSetting($input: UpdateStatementSettingInput!, $condition: ModelStatementSettingConditionInput) {
  updateStatementSetting(input: $input, condition: $condition) {
    id
    type
    custom
    disabled
    monthFrequency
    startMonth
    generationDay
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateSubscriptionUsageHistory = /* GraphQL */ `mutation UpdateSubscriptionUsageHistory($input: UpdateSubscriptionUsageHistoryInput!, $condition: ModelSubscriptionUsageHistoryConditionInput) {
  updateSubscriptionUsageHistory(input: $input, condition: $condition) {
    id
    clientId
    creditUsageDetail {
      numberUsed
      creditsAccount
      creditOperationType
      __typename
    }
    customerCreatorId
    requestId
    applicationInvoiceId
    storageUsageDetail {
      numberUsed
      __typename
    }
    type
    unitsUsageDetail {
      unitsUsage {
        numberUsed
        unitId
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      proRataUnits {
        unitId
        numberOfDays
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateTag = /* GraphQL */ `mutation UpdateTag($input: UpdateTagInput!, $condition: ModelTagConditionInput) {
  updateTag(input: $input, condition: $condition) {
    id
    color
    foreignTableName
    labels {
      language
      label
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateTechnic = /* GraphQL */ `mutation UpdateTechnic($input: UpdateTechnicInput!, $condition: ModelTechnicConditionInput) {
  updateTechnic(input: $input, condition: $condition) {
    id
    type
    technicLibraryId
    technicLibrary {
      id
      certificateValidity {
        nonCompliant
        overlapping
        riskLevel
        __typename
      }
      communicationSettingsProfileId
      criticality
      customFields {
        nextToken
        startedAt
        __typename
      }
      descriptions {
        language
        label
        __typename
      }
      isDefault
      issuingAuthority
      linkedCertificateIds
      locationScope
      maintenanceSchemas {
        id
        criticality
        deadline
        maintenanceType
        notificationsEnabled
        notificationType
        proofType
        recurrence
        responsibleParty
        triggerType
        __typename
      }
      names {
        language
        label
        __typename
      }
      status
      tagIds
      technicLibraryFormat
      type
      utilityTypes
      validity {
        value
        validityUnit
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicName
    lastControlDate
    status
    contractNumber
    communicationSettingsProfileId
    maintenanceHistory {
      date
      contactId
      customValues {
        name
        value
        __typename
      }
      fileId
      id
      maintenanceSchemaId
      __typename
    }
    utilityType
    utilityEanCode
    utilityMeterNumber
    utilityDistributorId
    utilityDistributor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    utilityHistory {
      date
      reason
      reading
      secondReading
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    originalTechnicId
    replacedTechnicId
    certificateIds
    readers
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateTechnicLibrary = /* GraphQL */ `mutation UpdateTechnicLibrary($input: UpdateTechnicLibraryInput!, $condition: ModelTechnicLibraryConditionInput) {
  updateTechnicLibrary(input: $input, condition: $condition) {
    id
    certificateValidity {
      gracePeriod {
        value
        validityUnit
        __typename
      }
      nonCompliant
      overlapping
      riskLevel
      __typename
    }
    communicationSettingsProfileId
    criticality
    customFields {
      items {
        id
        fieldName
        fieldType
        foreignKey
        foreignTableName
        order
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    descriptions {
      language
      label
      __typename
    }
    isDefault
    issuingAuthority
    linkedCertificateIds
    locationScope
    maintenanceSchemas {
      id
      criticality
      deadline
      descriptions {
        language
        label
        __typename
      }
      interval {
        value
        validityUnit
        __typename
      }
      maintenanceType
      names {
        language
        label
        __typename
      }
      notificationsEnabled
      notificationType
      proofType
      proofTypeName {
        language
        label
        __typename
      }
      recurrence
      responsibleParty
      triggerType
      __typename
    }
    names {
      language
      label
      __typename
    }
    status
    tagIds
    technicLibraryFormat
    type
    utilityTypes
    validity {
      value
      validityUnit
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateTemplate = /* GraphQL */ `mutation UpdateTemplate($input: UpdateTemplateInput!, $condition: ModelTemplateConditionInput) {
  updateTemplate(input: $input, condition: $condition) {
    id
    language
    name
    subject
    subjectRawFormat
    body
    bodyRawFormat
    type
    subType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateTicket = /* GraphQL */ `mutation UpdateTicket($input: UpdateTicketInput!, $condition: ModelTicketConditionInput) {
  updateTicket(input: $input, condition: $condition) {
    id
    assignedAt
    assignedTo {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedToId
    attachment {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    closedAt
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    content
    conversations {
      items {
        id
        assignedAt
        assignedToId
        buildingId
        closedAt
        contactId
        content
        emailMessageId
        emailReferences
        parentId
        plannedAt
        referenceCode
        sourceType
        status
        subject
        unitId
        unread
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    emailMessageId
    emailReferences
    parentId
    plannedAt
    referenceCode
    sourceType
    status
    subject
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unread
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateTransaction = /* GraphQL */ `mutation UpdateTransaction($input: UpdateTransactionInput!, $condition: ModelTransactionConditionInput) {
  updateTransaction(input: $input, condition: $condition) {
    id
    status
    snoozedUntil
    sequence
    statementDate
    operationDate
    customValues {
      name
      value
      __typename
    }
    remittanceInformationType
    remittanceInformation
    remittanceInformationRaw
    additionalInformation
    structuredCommunication
    bankTransactionCode
    proprietaryBankTransactionCode
    endToEndId
    mandateId
    creditorId
    purposeCode
    internalReference
    comment
    exclusionReason
    exclusionComment
    excludedAt
    excludedBy
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartDisplayName
    counterpartAccountNumber
    origin
    sourceChannel
    nativeTransactionId
    fingerprint
    linkedSourceChannels
    proposedLeaseId
    proposedUnitId
    proposedContractorId
    proposedOwnerId
    proposedMatch
    proposedAllocation
    classification
    classificationConfidence
    classificationReason
    recurrence
    links {
      amount
      linkId
      linkType
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateTransactionRule = /* GraphQL */ `mutation UpdateTransactionRule($input: UpdateTransactionRuleInput!, $condition: ModelTransactionRuleConditionInput) {
  updateTransactionRule(input: $input, condition: $condition) {
    id
    isFullRemittance
    remittanceInformation
    counterpartName
    counterpartAccountNumber
    usedFields
    exclude
    exclusionReason
    exclusionComment
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateUnit = /* GraphQL */ `mutation UpdateUnit($input: UpdateUnitInput!, $condition: ModelUnitConditionInput) {
  updateUnit(input: $input, condition: $condition) {
    id
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    acquisitionValue
    advertisedMonthlyCharges
    advertisedRentalPrice
    cadastralIncome
    customValues {
      name
      value
      __typename
    }
    floor
    jointOwnershipId
    managementDate
    name
    notes
    predictedPrice
    propertyTax
    publishAddress
    surface
    type
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owners {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leases {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        unitId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    unitAdvertisementId
    unitInventories {
      items {
        id
        privateBatthRoom
        deletedAt
        kitchenEquipment
        roomName
        roomType
        surface
        showSurface
        unitId
        inside
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateUnitEvent = /* GraphQL */ `mutation UpdateUnitEvent($input: UpdateUnitEventInput!, $condition: ModelUnitEventConditionInput) {
  updateUnitEvent(input: $input, condition: $condition) {
    id
    unitId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateUnitInventory = /* GraphQL */ `mutation UpdateUnitInventory($input: UpdateUnitInventoryInput!, $condition: ModelUnitInventoryConditionInput) {
  updateUnitInventory(input: $input, condition: $condition) {
    id
    privateBatthRoom
    deletedAt
    kitchenEquipment
    roomName
    roomType
    surface
    showSurface
    unitId
    inside
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateUnitLease = /* GraphQL */ `mutation UpdateUnitLease($input: UpdateUnitLeaseInput!, $condition: ModelUnitLeaseConditionInput) {
  updateUnitLease(input: $input, condition: $condition) {
    id
    allowChargeAdjustment
    authorizeProfessionalActivity
    chargesIndexation
    endDate
    furnishedRental
    furnishedRentalInsuranceByTenant
    furnishedRentalRentalPricePercentage
    initialRentalPrice
    indexation
    advancedIndexation
    indexType
    baseYear
    baseIndexType
    baseIndexDate
    nextIndexationMonth
    nextIndexation
    leaseId
    mainUnit
    rentalPrice
    signatureDate
    startDate
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateUnitOwner = /* GraphQL */ `mutation UpdateUnitOwner($input: UpdateUnitOwnerInput!, $condition: ModelUnitOwnerConditionInput) {
  updateUnitOwner(input: $input, condition: $condition) {
    id
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    periodFrom
    periodTo
    stake
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateValuation = /* GraphQL */ `mutation UpdateValuation($input: UpdateValuationInput!, $condition: ModelValuationConditionInput) {
  updateValuation(input: $input, condition: $condition) {
    id
    sourceType
    valorization
    date
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateVariousOperation = /* GraphQL */ `mutation UpdateVariousOperation($input: UpdateVariousOperationInput!, $condition: ModelVariousOperationConditionInput) {
  updateVariousOperation(input: $input, condition: $condition) {
    id
    amount
    labels {
      language
      label
      __typename
    }
    numberOfMonths
    operationType
    paymentFrequency
    type
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const updateVatRate = /* GraphQL */ `mutation UpdateVatRate($input: UpdateVatRateInput!, $condition: ModelVatRateConditionInput) {
  updateVatRate(input: $input, condition: $condition) {
    id
    country
    label
    value
    vatKind
    customValues {
      name
      value
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const upsertReleaseNote = /* GraphQL */ `mutation UpsertReleaseNote($input: UpsertReleaseNoteInput!) {
  upsertReleaseNote(input: $input) {
    id
    status
    publishedAt
    visibleToOwners
    contents {
      language
      title
      body
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const validateInvoice = /* GraphQL */ `mutation ValidateInvoice($input: ValidateInvoiceInput!) {
  validateInvoice(input: $input) {
    status
    id
    __typename
  }
}
`;

export const verifyBeneficiaryIban = /* GraphQL */ `mutation VerifyBeneficiaryIban($bankAccountId: ID!, $iban: String!, $sourceDocumentId: ID) {
  verifyBeneficiaryIban(bankAccountId: $bankAccountId, iban: $iban, sourceDocumentId: $sourceDocumentId) {
    id
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactIds
    buildingIds
    number
    bicNumber
    bankName
    holderName
    label
    customValues {
      name
      value
      __typename
    }
    disabled
    integrations
    matchingRule
    initiationChannel
    retainedBalanceThreshold
    balance
    balanceDate
    type
    ibanStatus
    ibanVerifiedAt
    ibanVerifiedBy
    ibanVerifiedNumber
    ibanVerifiedSourceDocumentId
    ibanRole
    ibanRoleLabel
    isDefault
    note
    paymentRunPriorityOrderIds
    paymentRunPriorityUpdatedAt
    paymentRunPriorityUpdatedBy
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const verifyExactOnlineIntegration = /* GraphQL */ `mutation VerifyExactOnlineIntegration($input: VerifyExactOnlineIntegrationInput!) {
  verifyExactOnlineIntegration(input: $input)
}
`;

export const verifyPendingSendingSource = /* GraphQL */ `mutation VerifyPendingSendingSource($input: VerifyPendingSendingSourceInput!) {
  verifyPendingSendingSource(input: $input) {
    status
    id
    __typename
  }
}
`;

export const verifyPeppolContact = /* GraphQL */ `mutation VerifyPeppolContact($input: VerifyPeppolContactInput!) {
  verifyPeppolContact(input: $input) {
    contactId
    isContactVerified
    __typename
  }
}
`;

export const verifyPontoIntegration = /* GraphQL */ `mutation VerifyPontoIntegration($input: VerifyPontoIntegrationInput!) {
  verifyPontoIntegration(input: $input) {
    status
    id
    __typename
  }
}
`;

export const writeOffPendingBalance = /* GraphQL */ `mutation WriteOffPendingBalance($input: WriteOffPendingBalanceInput!) {
  writeOffPendingBalance(input: $input) {
    status
    id
    __typename
  }
}
`;
